let es = {
  translation: {
    legacy_timeline_repair: {
      title: "Se necesita una actualización rápida",
      body: "Esta formación se creó antes de la nueva línea de tiempo. Sus vídeos y audios aún no siguen la nueva estructura, así que las escenas pueden quedar cortas y el vídeo exportado puede perder el sonido.",
      note: "Tarda unos segundos. Nada más cambia en tu formación.",
      videos: "Vídeo",
      videos_plural: "Vídeos",
      audios: "Clip de audio",
      audios_plural: "Clips de audio",
      scenes: "Escena afectada",
      scenes_plural: "Escenas afectadas",
      repair: "Actualizar ahora",
      later: "Ahora no",
      running: "Actualizando…",
      retry: "Reintentar",
      preparing: "Preparando…",
      progress: "Comprobando archivos multimedia… {{done}} / {{total}}",
      saving: "Guardando…",
      error: "No se pudo completar la actualización. Comprueba tu conexión e inténtalo de nuevo.",
    },
    help: {
      title: "Ayuda y guías",
      nav: "Ayuda",
      search_placeholder: "Buscar funciones…",
      no_results: "Ninguna guía coincide.",
      video_soon: "Vídeo próximamente",
    },
    shortcuts: {
      title: "Atajos de teclado",
      trigger_label: "Atajos de teclado (pulsa ?)",
      foot_hint: "Pulsa ? en cualquier momento para abrir o cerrar esta lista.",
      click: "Clic",
      section_general: "General",
      section_editing: "Edición",
      section_canvas: "Selección y organización",
      section_scenes: "Lista de escenas",
      help_open: "Mostrar u ocultar esta lista",
      esc_close: "Cerrar el diálogo, panel o menú abierto",
      preview: "Previsualizar el curso",
      print_pdf: "Imprimir el curso o guardarlo como PDF",
      undo: "Deshacer",
      redo: "Rehacer",
      redo_alt: "Rehacer (alternativa)",
      copy: "Copiar el elemento seleccionado (sin nada seleccionado, copia toda la escena)",
      cut: "Cortar el elemento seleccionado",
      paste: "Pegar un elemento o escena copiados, o una imagen o texto del portapapeles",
      duplicate: "Duplicar el elemento seleccionado",
      delete_box:
        "Eliminar los elementos seleccionados o el clip seleccionado en la línea de tiempo",
      select_all: "Seleccionar todos los elementos de la escena actual",
      multi_select: "Añadir o quitar un elemento de la selección (Mayús + clic también funciona)",
      clear_selection: "Borrar la selección de varios elementos",
      move_box: "Desplazar el elemento seleccionado (un 1 % de la escena por pulsación)",
      resize_aspect:
        "Mantener pulsado al redimensionar un elemento para bloquear o desbloquear su relación de aspecto",
      scenes_toggle_select: "Añadir o quitar una escena de la selección",
      scenes_range_select:
        "Seleccionar todas las escenas entre la última en la que hiciste clic y esta",
      scenes_clear_select: "Borrar la selección de escenas",
    },
    aideaChat: {
      buildNotice: {
        frozen: "La edición está bloqueada mientras se generan las escenas — puedes previsualizar.",
        progress: "Escena {{n}} de {{total}} lista",
        ready: "Tu formación está lista — ya puedes editar.",
        readyMessage:
          "Tu formación está lista — {{count}} escena creada. Pídeme cualquier cambio: narración, visuales, una escena nueva.",
        readyMessage_plural:
          "Tu formación está lista — {{count}} escenas creadas. Pídeme cualquier cambio: narración, visuales, una escena nueva.",
        paused: "La escena 1 está lista — échale un vistazo.",
        pausedLine:
          "Continúa con {{count}} escena más (≈{{credits}} créditos) o mejora la escena 1 con una nota.",
        pausedLine_plural:
          "Continúa con {{count}} escenas más (≈{{credits}} créditos) o mejora la escena 1 con una nota.",
        continue: "Continuar",
        improve: "Mejorar la escena 1",
        improvePlaceholder: "¿Qué debe cambiar en la escena 1?",
        send: "Rehacer la escena 1",
        cancel: "Cancelar",
        pauseFailed: "No funcionó — inténtalo de nuevo.",
        pauseBusy: "Demasiadas solicitudes — espera un momento.",
        pauseNoCredits:
          "No hay créditos suficientes para las escenas restantes — recarga e inténtalo de nuevo.",
        improving: "Reconstruyendo la escena 1 con tu nota…",
        composerWait: "Podrás escribir aquí de nuevo cuando la generación se pause o termine.",
        noScene: "La generación no pudo crear ninguna escena.",
        noSceneVoice:
          "El servicio de voz no está disponible ahora mismo — elige otra voz y vuelve a intentarlo.",
        noSceneAgent:
          "El agente de diseño no está disponible ahora mismo — inténtalo de nuevo en un momento.",
        noSceneGeneric: "Algo salió mal durante la generación — inténtalo de nuevo.",
      },
      buildBrief: {
        title: "Resumen del curso",
        objectives: "Objetivos de aprendizaje",
        themes: "Temas",
        scenes: "Escenas y narración",
        loading: "Cargando la receta de tu curso…",
        fallback: "Tu curso se está creando: la receta aparecerá aquí.",
        recipe: "Tu receta",
        recipeKeys: {
          flow: "Flujo",
          format: "Formato visual",
          style: "Estilo de imagen",
          language: "Idioma",
          length: "Duración",
          sceneCount: "Escenas",
          voice: "Voz",
          brand: "Marca",
        },
        minutes: "{{count}} minuto",
        minutes_plural: "{{count}} minutos",
        sceneCount: "{{count}} escena",
        sceneCount_plural: "{{count}} escenas",
        sceneN: "Escena {{n}}",
      },
      tekno3: {
        composerNotEmpty: "Composer no está vacío",
        chipTextMotions: "Añadir movimiento de texto",
        chipVideoMotion: "Añadir movimiento de vídeo",
        chipTextMotionsPrompt: "Añade movimiento de texto a esta escena",
        chipVideoMotionPrompt: "Añade un movimiento de vídeo a esta escena",
        quick: "Revisar escena",
        running: "tekno3 está revisando esta escena… puede tardar hasta un minuto.",
        found: "tekno3 encontró {{count}} problema.",
        found_plural: "tekno3 encontró {{count}} problemas.",
        clean: "tekno3 no encontró problemas — la escena se ve bien.",
        applyAll: "Aplicar todas las correcciones ({{count}})",
        fix: "Corregir",
        recheck: "Volver a revisar",
        close: "Cerrar",
        retry: "Reintentar",
        undo: "Deshacer",
        applied: "Se aplicó {{count}} corrección — un solo Deshacer la revierte.",
        applied_plural: "Se aplicaron {{count}} correcciones — un solo Deshacer las revierte.",
        skipped: "{{count}} corrección no se pudo aplicar.",
        skipped_plural: "{{count}} correcciones no se pudieron aplicar.",
        undone: "Correcciones deshechas.",
        undoStale: "La escena cambió desde entonces — usa Deshacer en el editor (Ctrl+Z).",
        at: "en {{sec}} s",
        frameAlt: "Mostrar la escena en {{sec}} s",
        severity: { high: "Alta", med: "Media", low: "Baja" },
        category: {
          contrast: "Contraste",
          overflow: "Texto desbordado",
          safe_area: "Fuera del área segura",
          overlap: "Superposición",
          min_font: "Letra demasiado pequeña",
          reading_speed: "Velocidad de lectura",
          bible: "Guía de estilo",
          timeline: "Tiempos",
          media: "Multimedia",
          hierarchy: "Jerarquía",
          layout: "Composición",
          typography: "Tipografía",
          colour_contrast: "Contraste de color",
          imagery: "Imágenes",
          motion_timing: "Ritmo de animación",
          content_fit: "Ajuste del contenido",
          accessibility: "Accesibilidad",
          other: "Otro",
        },
        err: {
          failed: "La revisión no funcionó — inténtalo de nuevo.",
          busy: "tekno3 está ocupado — espera un momento e inténtalo de nuevo.",
          tooLarge: "Esta escena es demasiado grande para enviarla a revisión.",
          notFound: "Esta escena no se puede revisar — guarda el curso e inténtalo de nuevo.",
          timeout: "La revisión está tardando demasiado — inténtalo en un momento.",
        },
      },
      buildWait: {
        stages: {
          plan: "Planificando el curso",
          style: "Eligiendo el estilo y el diseño",
          voice: "Grabando la voz de la narración",
          scene: "Creando la escena 1 · visuales y composición",
          ready: "Escena 1 lista",
          pause: "En pausa para tu revisión",
          rest: "Creando las escenas restantes",
        },
        stagesTitle: "Etapas del trabajo de la IA",
        mindmap: "Mapa mental",
        mindmapPreparing: "Preparando el mapa mental…",
        mindmapClose: "Volver al progreso",
        progress: "Escena {{done}}/{{total}}",
        progressDot: "Escena {{n}}: {{title}}",
        wait: {
          title: "Mientras esperas",
          slide: "{{n}} de {{total}}",
          narration: "Narración · escena {{n}}",
          flows: "Otro flujo de Aidea",
          models: "Modelos en acción",
          quote: "Para pensar",
          kind: {
            narration: "Mostrar la narración",
            flows: "Mostrar otros flujos de Aidea",
            models: "Mostrar los modelos en acción",
            quotes: "Mostrar una cita",
          },
          roles: {
            drafter: "Redactor (receta, estilo)",
            narrator: "Narrador",
            planner: "Planificador",
            sceneBuilder: "Constructor de escenas",
            motion: "Movimiento",
          },
          effort: { low: "bajo", medium: "medio", high: "alto" },
        },
      },
      build: {
        title: "Creando tu formación",
        titleDone: "Tu formación",
        sceneReady: "La escena {{n}} está lista",
        sceneFailed: "No se pudo crear la escena {{n}} — sigo con las demás",
        done: "Tu formación está lista — {{count}} escenas",
        none: "No pude crear ninguna escena. Vuelve al chat e inténtalo de nuevo.",
        stoppedBudget: "Se ha superado el presupuesto del equipo — contacta con tu administrador",
        stoppedHold: "Creación detenida: no se pudieron reservar créditos. Inténtalo de nuevo.",
        stoppedBalance:
          "La creación se detuvo: no hay créditos suficientes para la siguiente escena.",
        expired: "Esta creación ha terminado",
        expiredEmpty:
          "Esta creación ha terminado y no se guardó ninguna escena. Vuelve al chat en la consola para empezar de nuevo.",
        balanceCta: "Ver créditos",
        connIssue: "Problema de conexión — reintentando…",
        chatClosed: "El chat de este curso está cerrado",
        loadingChat: "Cargando la conversación…",
        noToken: "Esperando tu sesión — me conectaré a la creación en cuanto inicies sesión.",
        saveLocked: "Creando — podrás guardar cuando termine la creación",
        preview: "Mostrar",
        watch: "Ver desde el principio",
        showAgain: "Mostrar de nuevo la escena {{n}}",
        ghost: "(en creación)",
        step: {
          waiting: "Preparando la creación…",
          narration: "Escena {{n}} · generando voz e imágenes",
          images: "Escena {{n}} · imágenes listas",
          video: "Escena {{n}} · animando un momento",
          motion: "Escena {{n}} · diseñando gráficos animados",
          saving: "Escena {{n}} · colocándola en el editor",
        },
        stepName: {
          narration: "narración",
          images: "imágenes",
          video: "vídeo",
          motion: "animación",
          saving: "guardando",
        },
        phase: {
          style_bible: "Diseñando el aspecto del curso…",
          plan: "Escena {{n}} · planificando los momentos clave",
          generate: "Escena {{n}} · generando imágenes y animación",
          compose: "Escena {{n}} · componiendo la escena",
          review: "Escena {{n}} · revisando una vista previa",
          fix: "Escena {{n}} · puliendo los detalles",
        },
        status: "Preparando la escena {{n}} — {{step}}",
        hint: "Cada escena tarda unos 2–4 minutos",
        thumb: "Mostrar la imagen {{n}} en la vista previa",
        note: {
          plan_ready: "Plan de animación listo",
          plan_failed: "Esta escena no tendrá gráficos animados",
          video_ready: "Momento de vídeo listo",
          video_failed: "Se mantiene la imagen fija",
        },
      },
      assistant: "Asistente Aidea",
      motionEdit: {
        chip: "Editar",
        running: "Editando la escena...",
        cancelled: "Cancelado: la escena no cambió.",
        failed: "No se pudo editar: la escena quedó igual.",
        done: "Listo. El mismo momento, antes y después:",
      },
      newThread: "Nueva conversación",
      newConversation: "Nueva conversación",
      courseBuild: "Creación del curso",
      empty: "Vacío",
      messages: "{{count}} mensaje",
      messagesPlural: "{{count}} mensajes",
      greetingTitle: "¡Hola!",
      greetingSubtitle: "¿En qué puedo ayudarte hoy?",
      placeholder: "Escribe a Aidea…",
      hint: "Aidea puede cometer errores. Enter para enviar, Shift+Enter para nueva línea.",
      suggestions: {
        infographicTitle: "Crear una escena infográfica",
        infographicPrompt: "Crea una escena infográfica que resuma los puntos clave.",
        imageTitle: "Generar una imagen",
        imagePrompt: "Genera una imagen que ilustre el concepto principal.",
        narrationTitle: "Actualizar narración",
        narrationPrompt: "Actualiza la narración de esta escena.",
        avatarTitle: "Añadir avatar",
        avatarPrompt: "Añade un avatar parlante para presentar esta escena.",
        videoTitle: "Generar vídeo",
        videoPrompt: "Genera un clip de vídeo para esta escena.",
        motionTitle: "Animar esta escena (Motion)",
        motionPrompt: "Añade gráficos animados a esta escena.",
      },
      motion: {
        appliedFromTray: "Aprobado desde la bandeja de trabajos: el plan se aplicó a la escena.",
        declinedFromTray: "Rechazado en la bandeja de trabajos: la escena no cambió.",
        confirm:
          "Diseña textos en pantalla, capas de legibilidad e iconos para esta escena a partir de sus imágenes y su narración.",
        summary: "Diseña gráficos animados para esta escena a partir de su imagen y su narración.",
        summary_plural:
          "Diseña gráficos animados para esta escena a partir de sus {{count}} imágenes y su narración.",
        cost: "≤{{credits}} créditos",
        chip: "Animación",
        design: "Diseñar gráficos animados",
        cancel: "Cancelar",
        cancelled: "Cancelado — no se diseñó nada.",
        designing:
          "Diseñando gráficos animados… puede tardar 1–3 minutos. Puedes seguir trabajando.",
        ready: "Plan de animación listo — {{count}} elementos. ¿Añadirlos a la escena?",
        apply: "Aplicar a la escena",
        applied:
          "Se añadieron {{count}} elementos a la escena. Un solo Deshacer los elimina todos.",
        undo: "Deshacer",
        failed: "No se pudieron diseñar los gráficos animados. Inténtalo de nuevo.",
        sceneMissing: "Esa escena ya no existe.",
        noImages: "Esta escena todavía no tiene imágenes. Añade primero una imagen de fondo.",
        noTraining: "Abre primero esta formación desde tu biblioteca y vuelve a intentarlo.",
        insufficientBalance:
          "No tienes créditos suficientes para esto. Recarga e inténtalo de nuevo.",
        timeout: "Está tardando más de lo esperado. Inténtalo de nuevo en unos minutos.",
        densityLabel: "Texto en pantalla",
        densityKey: "Frases clave",
        densityFull: "Todo el texto",
        graphicsLabel: "Gráficos",
        graphicsMinimal: "Mínimos",
        graphicsBalanced: "Equilibrados",
        graphicsRich: "Abundantes",
        textLabel: "Texto en las imágenes",
        textAuto: "Aidea decide",
        textExtract: "Animarlo",
        textAdd: "Añadir texto nuevo",
        iconsLabel: "Iconos",
        iconsAuto: "Aidea decide",
        iconsYes: "Sí",
        iconsNo: "No",
        someKept: "Algunas imágenes conservaron su texto",
        adjusted: "{{count}} elemento ajustado para mejorar la legibilidad.",
        adjusted_plural: "{{count}} elementos ajustados para mejorar la legibilidad.",
      },
    },
    scene: "Escena",
    Delete: "Eliminar",
    Cancel: "Cancelar",
    Edit: "Editar",
    Copy: "Copiar",
    Duplicate: "Duplicar",
    Show: "Mostrar",
    Hide: "Ocultar",
    Lock: "Bloquear",
    Unlock: "Desbloquear",
    layerOrder: {
      bringToFront: "Traer al frente",
      forward: "Adelantar",
      backward: "Retroceder",
      sendToBack: "Enviar al fondo",
    },
    add_to_scene_label: "Añadir a escena",
    HtmlContentAdd: "Añadir contenido HTML",
    AddAnswer: "Añadir respuesta",
    Design: "Diseño",
    Simulator: "Simulador",
    bgPreset: {
      transparent: "Transparente",
      dark: "Oscuro",
      navy: "Azul marino",
      white: "Blanco",
      gray: "Gris",
    },
    Videos: "Vídeos",
    Images: "Imágenes",
    Audios: "Audios",
    Skip: "Saltar",
    No: "No",
    PleaseWait: "Por favor espere...",
    AnimationEntrance: "Entrada",
    AnimationExit: "Salida",
    ScreenTraining: "Formación en pantalla",
    CustomHtmlContent: "Contenido HTML personalizado",
    DownloadMP4: "Descargar MP4",
    SharedUsers: "Usuarios compartidos",
    NoUsersAddedYet: "No se han añadido usuarios",
    InvitedOnly: "Solo invitados",
    TTS: {
      AddedToMyFiles: "El sonido generado se ha añadido a 'Mis archivos'.",
      AccessPreviousSounds:
        "Puede acceder a sus sonidos generados anteriormente aquí o eliminar los no utilizados.",
    },
    EditImage: {
      processing: "Editando imagen…",
    },
    timeline: {
      mediaLoadFailed: "No se pudo cargar el medio",
      mediaRetry: "Reintentar",
      addTrack: "Agregar pista",
      WaitingForInteractive: "Timeline esperando elemento interactivo",
      SkipInteractive: "Saltar interactivo y continuar timeline",
    },
    ScreenTrainingUseReadyTemplate: "Usar una plantilla lista de formación en pantalla",
    PickCustomColor: "Elegir color personalizado",
    SeekToStart: "Ir al inicio",
    Pause: "Pausar",
    ShowMediaAssets: "Mostrar recursos multimedia",
    ZoomOut: "Alejar",
    ZoomReset: "Restablecer zoom (100%)",
    ZoomIn: "Acercar",
    HideAll: "Ocultar todo",
    TimelineRowImages: "Imágenes",
    TimelineRowVideos: "Vídeos",
    TimelineRowAudios: "Audios",
    TimelineRowTexts: "Textos",
    ShowAll: "Mostrar todo",
    LockAll: "Bloquear todo",
    UnlockAll: "Desbloquear todo",
    SplitClipSourceSame: "Clip dividido — mismo origen",
    EntranceAnimation: "Animación de entrada",
    ExitAnimation: "Animación de salida",
    SplitAtPlayhead: "Dividir en el cabezal",
    AlignToPrevious: "Alinear al elemento anterior",
    AlignToNext: "Alinear al elemento siguiente",
    OpenPanel: "Abrir panel",
    ClosePanel: "Cerrar panel",
    SplitAtPlayheadHint: "Divide el clip en dos en el cabezal",
    CutAndDelete: "Cortar y eliminar",
    CutAndDeleteHint: "Elimina todo lo anterior al cabezal y ajusta el resto al inicio",
    CutPlayheadOutsideHint: "Coloca primero el cabezal dentro del clip",
    OpenInVideoDirector: "Abrir en Director de Video",
    PasteHtmlContentHere: "<div>Pegue su contenido HTML aquí...</div>",
    FontCategory: {
      System: "Sistema",
      Accessible: "Accesible",
      Handwriting: "Caligrafía",
      Other: "Otros",
      Custom: "Personalizado",
    },
    InteractiveKind: {
      MCQ: "Opción múltiple",
      VisualImage: "Imagen",
    },
    InteractiveCategory: {
      Questions: "Preguntas",
      Media: "Medios",
    },
    ElementType: {
      TextCard: "Tarjeta de texto",
      ImageCard: "Tarjeta de imagen",
      VideoCard: "Tarjeta de video",
      FlipCard: "Tarjeta reversible",
      TrueFalse: "Verdadero / Falso",
      MCQ: "Opción múltiple",
    },
    ClickToAddAnimation: "haga clic para añadir animación",
    ItemProps: {
      AlignLeft: "Izquierda",
      AlignCenter: "Centro",
      AlignRight: "Derecha",
      Kind: {
        VisualLabel: "Etiqueta visual",
        VisualImage: "Imagen",
        TrueFalse: "Verdadero / Falso",
        YesNo: "Sí / No",
        FlipCard: "Tarjeta reversible",
        MCQ: "Opción múltiple",
        MultipleAnswer: "Respuesta múltiple",
        FillInBlank: "Rellenar huecos",
        DragDrop: "Arrastrar y soltar",
        Matching: "Emparejar",
        Ordering: "Ordenar",
        BranchingQuestion: "Pregunta de bifurcación",
        EndScreen: "Pantalla final",
        DialogCards: "Tarjetas de diálogo",
        MemoryGame: "Juego de memoria",
        DragTheWords: "Arrastrar palabras",
        FindTheWords: "Encontrar palabras",
        ImageHotspots: "Puntos calientes",
        QuestionSet: "Conjunto de preguntas",
        PersonalityQuiz: "Test de personalidad",
        CoursePresentation: "Presentación del curso",
        SpeakTheWords: "Hablar las palabras",
        ImageSequencing: "Secuencia de imágenes",
        SingleChoiceSet: "Conjunto de opción única",
        DragQuestion: "Pregunta de arrastre",
        Essay: "Ensayo abierto",
        ShortLabel: "Etiqueta",
      },
      Action: {
        ShowItem: "Mostrar elemento",
        HideItem: "Ocultar elemento",
        Resume: "Continuar (timeline)",
        Complete: "Completar interacción",
        None: "Ninguno",
        ResumeLabel: "Continuar",
        ResumeHint: "Reanudar timeline",
        CompleteLabel: "Completar",
        CompleteHint: "Finalizar interacción",
        ShowItemLabel: "Mostrar Elemento",
        ShowItemHint: "Hace visible el elemento seleccionado",
        HideItemLabel: "Ocultar Elemento",
        HideItemHint: "Oculta el elemento seleccionado",
        JumpSceneLabel: "Ir a Escena",
        JumpSceneHint: "Saltar a la escena especificada",
      },
      SelectPlaceholder: "— Seleccionar —",
      AddAction: "+ Añadir acción",
      AnswerActions: "Acciones de respuesta",
      OnCorrect: "✓ Si es correcto",
      OnWrong: "✗ Si es incorrecto",
      ClickActions: "Acciones de clic",
      OnClick: "👆 Al hacer clic",
      OnCorrectShort: "Si es correcto",
      OnWrongShort: "Si es incorrecto",
      OnClickShort: "Al hacer clic",
      PromptDefault: "Pregunta / Descripción",
      Text: "Texto",
      FontSize: "Tamaño de fuente",
      Color: "Color",
      Alignment: "Alineación",
      Bold: "Negrita",
      ImageUrl: "URL de imagen",
      ObjectFit: "Ajuste",
      AltText: "Texto alternativo",
      AltTextPlaceholder: "Descripción de accesibilidad",
      Question: "Pregunta",
      CorrectAnswer: "Respuesta correcta",
      True: "Verdadero",
      False: "Falso",
      TrueLabel: "Etiqueta 'Verdadero'",
      FalseLabel: "Etiqueta 'Falso'",
      Yes: "Sí",
      No: "No",
      YesLabel: "Etiqueta 'Sí'",
      NoLabel: "Etiqueta 'No'",
      Options: "Opciones",
      Add: "+ Añadir",
      CorrectAnswerTitle: "Respuesta correcta",
      AcceptedAnswers: "Respuestas aceptadas (separadas por comas)",
      CaseSensitive: "Sensible a mayúsculas/minúsculas",
      FrontFace: "Cara frontal",
      BackFace: "Cara trasera",
      Title: "Título",
      Subtitle: "Subtítulo",
      ShowScore: "Mostrar puntuación",
      QuestionInstruction: "Pregunta / Instrucción",
      PlaceholderText: "Texto de marcador de posición",
      MinWordCount: "Recuento mín. de palabras",
      ComplexNote:
        "Los ajustes adicionales para este tipo de elemento se gestionan desde la pestaña Workflow.",
      AddClickAction: "Añadir acción al hacer clic",
      AddCorrectAction: "Añadir acción para respuesta correcta",
      AddWrongAction: "Añadir acción para respuesta incorrecta",
      InteractionPanel: "Panel de interacción",
      Interaction: "Interacción",
      Trigger: "Disparador",
      ActionLabel: "Acción",
      Target: "Destino",
      NoDisplayableItems: "No hay elementos visualizables",
      Scene: "Escena",
      SelectScene: "— Seleccionar escena —",
      NoScenesFound: "No se encontraron escenas",
      GoToScene: "Ir a escena",
    },
    filter_by_scene: "Filtrar por escena",
    all_files: "Todos los archivos",
    no_scene_media: "No hay medios en esta escena",
    Tools: "Herramientas",
    PointerEvents: "Eventos de puntero",
    Crop: "Recortar",
    Border: "Borde",
    RemoveBackground: "Quitar fondo",
    ChromaKey: "Clave de color",
    PickColor: "Elegir color",
    ClickToPickColor: "Haz clic en la imagen para elegir el color a quitar",
    ConfirmRemoveBg: "Confirmar",
    ClearPickedColor: "Quitar color",
    RemoveBgHint: "Confirma sin elegir color para quitar el fondo automáticamente",
    ImageAdjustments: "Ajustes",
    WhiteBalance: "Balance de blancos",
    Temperature: "Temperatura",
    Tint: "Tono",
    Light: "Luz",
    Brightness: "Brillo",
    Contrast: "Contraste",
    Color: "Color",
    Vibrance: "Vitalidad",
    Saturation: "Saturación",
    Invert: "Invertir",
    Texture: "Textura",
    Blur: "Desenfoque",
    ResetAdjustments: "Restablecer ajustes",
    Tolerance: "Tolerancia",
    BorderWidth: "Grosor del borde",
    BorderStyle: "Estilo del borde",
    BorderColor: "Color del borde",
    BorderRadius: "Radio del borde",
    QuickBorder: "Borde rápido",
    None: "Ninguno",
    Sharp: "Recto",
    Rounded: "Redondeado",
    Soft: "Suave",
    Pill: "Píldora",
    Circle: "Círculo",
    Dashed: "Discontinuo",
    Dotted: "Punteado",
    Padding: "Relleno",
    Left: "Izquierda",
    Right: "Derecha",
    Top: "Arriba",
    Bottom: "Abajo",
    Reset: "Restablecer",
    BackgroundColor: "Color de fondo",
    Confirm: "Confirmar",
    Opacity: "Opacidad",
    Cropping: "Recortando...",
    DragToCrop: "Arrastra para seleccionar una región a recortar",
    CropFailed: "Error al recortar",
    RestoreOriginalImage: "Restaurar la imagen original",
    RestoreOriginalImageHint: "Deshace el recorte y restaura la imagen original completa",
    Free: "Libre",
    AspectRatio: "Relación de aspecto",
    JobFailed: "La operación falló",
    JobTimedOut: "La operación expiró",
    Filters: "Filtros",
    FilterGroupNatural: "Natural",
    FilterGroupWarm: "Cálido",
    FilterGroupCold: "Frío",
    FilterFresh: "Fresco",
    FilterVivid: "Vívido",
    FilterFlint: "Sílex",
    FilterLuna: "Luna",
    FilterSky: "Cielo",
    FilterNoir: "Noir",
    FilterTropic: "Trópico",
    FilterSun: "Sol",
    FilterLatte: "Latte",
    FilterBronze: "Bronce",
    FilterSand: "Arena",
    FilterGrape: "Uva",
    FilterIce: "Hielo",
    FilterPolar: "Polar",
    FilterNight: "Noche",
    FilterMist: "Niebla",
    FilterOcean: "Océano",
    FilterSteel: "Acero",
    FilterRetro: "Retro",
    FilterGroupVivid: "Vívido",
    FilterGroupSoft: "Suave",
    FilterGroupVintage: "Vintage",
    FilterScandinavian: "Escandinavo",
    FilterNordic: "Nórdico",
    FilterAstro: "Astro",
    FilterArctic: "Ártico",
    FilterTundra: "Tundra",
    FilterSaturated: "Saturado",
    FilterRural: "Rural",
    FilterEffort: "Vigor",
    FilterArya: "Arya",
    FilterHarsh: "Duro",
    FilterAura: "Aura",
    FilterEla: "Ela",
    FilterDreamy: "Onírico",
    FilterRose: "Rosa",
    FilterCloud: "Nube",
    FilterVinto: "Vinto",
    FilterFade: "Desvanecido",
    FilterOld: "Antiguo",
    FilterNostalgic: "Nostálgico",
    FilterDream: "Sueño",
    FilterIntensity: "Intensidad",
    FilterGroupMono: "Mono",
    FilterGroupColorBurst: "Explosión de color",
    FilterClassic: "Clásico",
    FilterInk: "Tinta",
    FilterPitchBlack: "Negro azabache",
    FilterFilm: "Película",
    FilterNewspaper: "Periódico",
    FilterBlackboard: "Pizarra",
    FilterLimitless: "Sin límites",
    FilterHeatwave: "Ola de calor",
    FilterAmethyst: "Amatista",
    FilterMinty: "Menta",
    FilterHollyhock: "Malva",
    FilterPoster: "Póster",
    FilterGroupCinematic: "Cinematográfico",
    FilterTeal: "Turquesa",
    FilterNoirBlue: "Azul noir",
    FilterAmber: "Ámbar",
    FilterThriller: "Suspense",
    FilterWestern: "Western",
    FilterEpic: "Épico",
    FilterGroupPastel: "Pastel",
    FilterPastelPink: "Rosa",
    FilterPastelBlue: "Azul",
    FilterPastelMint: "Menta",
    FilterPastelLavender: "Lavanda",
    FilterPastelPeach: "Melocotón",
    FilterPastelPowder: "Polvo",
    FilterGroupNeon: "Neón",
    FilterCyber: "Cíber",
    FilterElectric: "Eléctrico",
    FilterNeonMagenta: "Magenta",
    FilterAcid: "Ácido",
    FilterPlasma: "Plasma",
    FilterLaser: "Láser",
    NarrationDraft: {
      Badge: "Borrador",
      GeneratingInfo:
        "La voz se está generando en segundo plano. Puedes cambiar de escena; quedará aquí como borrador cuando esté lista.",
      ReadyInfo:
        "Un texto y una voz editados esperan como borrador. Aprueba esta escena o descarta el borrador.",
      EditedInfo:
        "El texto cambió después de generar la voz. Vuelve a generar la voz para aprobarla.",
      Approve: "Aprobar",
      ApproveHint: "Aplicar solo a esta escena",
      SaveAll: "Guardar todo",
      SaveAllWaitGenerating: "Guardar todo estará disponible cuando termine la voz en generación.",
      ApproveAllPartial:
        "{{ready}}/{{total}} borradores listos; los demás aún se generan o su texto cambió.",
      ShowOriginal: "Mostrar original",
      ShowDraft: "Mostrar borrador",
      Discard: "Descartar borrador",
      SceneHasDraft: "Esta escena tiene un borrador de narración sin guardar",
    },
    NarrateScope: {
      Title: "¿Dónde aplicamos esta voz?",
      Description: "¿Quieres aplicar esta voz solo a esta escena o a todas las escenas?",
      ThisScene: "Solo esta escena",
      ThisSceneDesc: "La voz se guarda solo en esta escena.",
      AllScenes: "Todas las escenas",
      AllScenesDesc: "Esta voz se aplica a todas las escenas y cada escena se vuelve a narrar.",
      AllScenesDescCount: "Esta voz se aplica a {{count}} escenas y cada una se vuelve a narrar.",
      Recommended: "Recomendado",
      NarrateAllCheckbox: "Narrar todas las escenas",
      ConfirmTitle: "Narrar todas las escenas",
      ConfirmDesc:
        "Esta voz se aplicará a todas las escenas y cada escena se volverá a narrar. ¿Seguro que quieres continuar?",
      ConfirmDescCount:
        "Esta voz se aplicará a {{count}} escenas y cada una se volverá a narrar. ¿Seguro que quieres continuar?",
      ConfirmButton: "Sí, narrar",
      Applying: "Iniciando...",
      StartedTitle: "Narración iniciada",
      Started: "Narración iniciada ({{count}} escenas). Se completará en segundo plano.",
      NoScenes: "No se encontraron escenas con texto de narración.",
      Error: "No se pudo iniciar la narración. Inténtalo de nuevo.",
      Progress: "Narrando... {{progress}}%",
      DoneTitle: "Narración",
      Done: "{{count}} escenas se volvieron a narrar.",
      PartialDone: "{{success}} escenas actualizadas, {{failed}} fallidas.",
      Failed: "La narración falló.",
      Timeout: "La operación expiró.",
    },
    AnimateScope: {
      AnimateSceneButton: "Animar seleccionados",
      AnimateAllButton: "Animar todo ({{count}})",
      ConfirmDescCount:
        "Esto animará {{count}} imágenes infográficas en todas las escenas ({{alreadyAnimated}} ya tienen animación).",
      ConfirmSceneDescCount: "Esto animará {{count}} imágenes infográficas en esta escena.",
      WarningNotRevertable: "Esto no se puede deshacer una vez iniciado.",
      WarningCancelCharges: "Cancelar aún factura los clips que ya están en curso.",
      Applying: "Iniciando...",
      AlreadyAnimatedBadge: "Ya animado",
      StartButton: "Iniciar",
      NoImages: "No se encontraron imágenes infográficas en esta formación.",
      ProgressOf: "{{done}} de {{total}} completados",
      CancelButton: "Cancelar",
      CancelConfirm:
        "Esto detendrá el lote. Los clips ya en curso terminan igualmente y se facturan.",
      ResumeButton: "Reanudar",
      ResetButton: "Restablecer todo",
      ApplyButton: "Aplicar a las escenas",
      ApplyingAll: "Aplicando...",
      PreviewButton: "Vista previa",
      ItemRunning: "Animando…",
      ItemFailed: "Fallido",
      BlockedTitle: "Hay una animación por lotes en curso",
    },
    AnimatorPanel: {
      Retry: "Reintentar",
      ApplyToScene: "Aplicar a esta escena",
      NotAnimated: "Sin animar",
      SelectForAnimate: "Seleccionar para animar",
      NoAnimatableImages: "No hay imágenes para animar en esta escena",
      SceneProgress: "{{animated}}/{{total}}",
      SourceInfographic: "Infografía",
      SourceAllImages: "Todas las imágenes",
      UnsupportedFormatReason: "Formato no compatible",
      RevertButton: "Revertir",
      RevertToImage: "Revertir a imagen",
      RevertConfirm: "¿Revertir a la imagen original?",
      RevertNotFound: "No se encontró la imagen original — no se puede revertir esta.",
      UnsavedNotice: "Los cambios sin guardar aún no están en esta lista — guarda para incluirlos.",
      RefreshList: "Actualizar lista",
      SaveAndRefresh: "Guardar y actualizar",
      SaveError:
        "No se pudieron guardar los cambios. La lista de abajo sigue siendo tu última versión guardada.",
      AnimateButton: "Animar",
      ReanimateButton: "Volver a animar",
      BackToPanel: "Atrás",
      ProviderLabel: "Modelo",
      AppliedBadge: "Aplicado",
      NarrationLabel: "Narración",
      Play: "Reproducir",
      Pause: "Pausar",
      NoNarration: "No hay narración para esta escena",
      TimeRange: "{{start}}–{{end}} s",
      WholeScene: "escena completa",
      PredictedDuration: "animación de {{sec}} s",
    },
    activity_log: {
      menu_label: "Historial de actividad",
      title: "Historial de actividad",
      hint: "Desglose de los créditos gastados en este curso.",
      total_spent: "Total gastado",
      total_count: "Transacciones",
      col_date: "Fecha",
      col_operation: "Operación",
      col_user: "Usuario",
      col_amount: "Créditos",
      empty: "Aún no hay actividad de créditos para este curso.",
      error: "No se pudieron cargar los registros.",
      retry: "Intentar de nuevo",
      refresh: "Actualizar",
    },
    localDraft: {
      title: "Se encontró trabajo local",
      body: "Se encontró trabajo local sin guardar para esta formación ({{savedAt}}). ¿Quieres verlo?",
      serverNewer:
        "El servidor tiene un guardado más reciente que esta copia local. Si abres el trabajo local y guardas, recibirás un aviso de conflicto.",
      open: "Abrir trabajo local",
      useServer: "Continuar con la versión del servidor",
      discardTitle: "¿Eliminar el trabajo local?",
      discardBody:
        "La copia local se eliminará de forma permanente y se usará la versión del servidor.",
      discard: "Eliminar trabajo local",
      keep: "Conservarlo",
      loadedNotice: "Trabajo local cargado — recuerda guardar.",
      targetRemovedNotice:
        "Se eliminó la imagen original — el vídeo se añadió como un elemento nuevo.",
      quotaWarning:
        "No se pudo guardar la copia de seguridad local: el almacenamiento del navegador está lleno.",
    },
    navbar: {
      credits: "créditos",
      creditsInfo: {
        title: "Crédito restante",
        body: "Este es el crédito total restante de la organización a la que se carga este curso. Muestra el saldo disponible de toda la cuenta, no solo lo gastado en este curso.",
        bodyMember:
          "Esto es lo que queda de su asignación en el equipo {{team}} este mes. El límite se renueva el {{date}}.",
        bodyTeam:
          "Esto es lo que el equipo {{team}} aún puede gastar este mes, compartido con las demás personas del equipo. El límite se renueva el {{date}}.",
      },
      autosave: {
        label: "Guardado automático",
        prompt:
          "¿Activar el guardado automático para esta sesión? Se guarda automáticamente cada 2 minutos cuando hay cambios sin guardar.",
        enable: "Activar",
        notNow: "Ahora no",
        pulseTooltip: "Cambios sin guardar — haz clic para guardar",
      },
    },
    appModal: {
      showScene: "Mostrar escena",
      showPanel: "Mostrar panel",
    },
    authRequired: {
      title: "Tienes que volver a iniciar sesión",
      description:
        "Tu sesión ha caducado o no se pudo verificar. Vuelve a iniciar sesión para continuar.",
      loopDescription:
        "Demasiados intentos de inicio de sesión — actualiza la página o inténtalo de nuevo en breve.",
      authenticate: "Iniciar sesión",
      hardRefresh: "Recargar la página",
      goBack: "Volver a la formación",
      serverErrorTitle: "No se pudo cargar el editor",
      serverErrorDescription:
        "El servidor no está disponible temporalmente. Actualiza la página para volver a intentarlo.",
      runtimeErrorTitle: "Problema de conexión",
      runtimeErrorDescription:
        "No se pudo conectar con el servidor. Comprueba tu conexión e inténtalo de nuevo.",
      crashTitle: "El editor encontró un error",
      crashDescription:
        "Se produjo un error de renderizado — no es un problema de inicio de sesión. Actualiza la página para volver a intentarlo; si sigue ocurriendo, comparte el mensaje de abajo.",
    },
    serverErrorToast: {
      message: "Error del servidor — espere un momento y vuelva a intentarlo.",
    },
    styleClipboard: {
      copy: "Copiar estilo",
      copied: "Estilo copiado",
      title: "Estilo copiado",
      ready: "Listo para aplicar",
      hint: "Selecciona los elementos a los que aplicarlo",
      apply: "Aplicar",
      chip_box: "Caja",
      chip_text: "Texto",
      chip_image: "Ajustes de imagen",
      kind_text: "Texto",
      kind_image: "Imagen",
      kind_video: "Vídeo",
      kind_other: "Elemento",
      details: "Mostrar estilo copiado",
      details_hide: "Ocultar detalles",
      group_box: "Caja",
      group_text: "Texto",
      group_pose: "Pose",
      group_image: "Ajustes de imagen",
      group_animation: "Efecto",
      row_background: "Fondo",
      row_border: "Borde",
      row_radius: "Esquinas",
      row_padding: "Relleno",
      row_opacity: "Opacidad",
      row_filter: "Filtro",
      row_font: "Fuente",
      row_size: "Tamaño",
      row_weight: "Estilo",
      row_align: "Alineación",
      align_left: "Izquierda",
      align_center: "Centro",
      align_right: "Derecha",
      align_justify: "Justificado",
      value_on: "Sí",
      row_color: "Color",
      row_highlight: "Resaltado",
      row_rotation: "Rotación",
      row_flip: "Volteo",
      row_preset: "Preajuste",
      row_intensity: "Intensidad",
      row_entry: "Entrada",
      row_exit: "Salida",
      value_none: "Ninguno",
      value_default: "Predeterminado",
      value_transparent: "Transparente",
      value_flip_h: "Horizontal",
      value_flip_v: "Vertical",
      value_delay: "retardo",
      chip_pose: "Pose",
      chip_animation: "Efecto",
      clear: "Borrar el estilo copiado",
      applied: "Estilo aplicado a {{n}} elemento(s)",
      applied_skipped:
        "Estilo aplicado a {{n}} elemento(s) · {{skipped}} omitido(s) por ser de otro tipo",
    },
    Scene: "Escena",
    Versions: "Historial",
    "Loading versions": "Cargando historial",
    Animate: "Animar",
    Replace: "Reemplazar",
    Reference: "Referencia",
    "Text to Image": "Texto a Imagen",
    Avatar: "Avatar",
    Model: "Modelo",
    Infographic: "Infografía",
    Attempt: "Intento",
    Version: "Versión",
    Original: "Original",
    "No history": "Sin historial",
    Result: "Resultado",
    Failed: "Error",
    "Result will appear here": "El resultado aparecerá aquí",
    Scenes: "Escenas",
    Settings: "Ajustes",
    aideaSmartElements: "Elementos Inteligentes Aidea",
    aideaSmartElementsProcessing: "Descomponiendo imagen...",
    aideaSmartElementsFailed: "No se pudo descomponer esta imagen",
    aideaSmartElementsNoSubjects: "No se detectaron sujetos en esta imagen",
    aideaSmartElementsUngroup: "Desagrupar",
    colorPicker: {
      color: "Color",
      alpha: "Opacidad: {{value}}%",
      preview: "Vista previa",
      save: "Guardar",
    },
    knollingView: {
      title: "Recursos Multimedia",
      categories: "Categorías",
      currentSceneOnly: "Solo esta escena",
      all: "Todos",
      videos: "Videos",
      images: "Imágenes",
      audios: "Audios",
      noMedia: "No se encontraron recursos multimedia.",
      preview: "Vista previa",
      goToScene: "Ir a la escena",
      play: "Reproducir",
      pause: "Pausar",
    },
    InsufficientBalance: {
      Title: "Saldo Insuficiente",
      Description: "Tus créditos se han agotado. Contáctanos para obtener nuevos créditos.",
      RequestedAmount: "Créditos solicitados",
      CurrentBalance: "Saldo actual",
      ContactUs: "Contáctanos",
      Close: "Cerrar",
      UnitMinutes: "minutos",
      UnitCredits: "créditos",
      MessageLabel: "Tu mensaje",
      MessagePlaceholder: "Escribe tu mensaje aquí...",
      Send: "Enviar",
      Sending: "Enviando...",
      SubmitError: "Ocurrió un error al enviar tu mensaje. Por favor, inténtalo de nuevo.",
      MessageSentDescription: "Tu solicitud ha sido enviada. Nos pondremos en contacto pronto.",
      TeamTitle: "El presupuesto de tu equipo se ha agotado",
      TeamDescription:
        "El presupuesto mensual de créditos de {{team}} no alcanza para esta operación. Se renueva el {{date}}; si necesitas más antes, habla con el administrador de tu organización.",
      TeamRemaining: "Presupuesto restante del equipo",
      YourTeam: "Tu equipo",
      Failed: "Error al comprobar los créditos",
    },
    Layers: "Capas",
    Elements: "Elementos",
    Assessments: "Evaluaciones",
    // === Task 19 (rename Değerlendirmeler -> Etkileşim) ===
    Interactive: "Interactivo",
    Library: "Biblioteca",
    Audio: "Base de Conocimientos",
    aiToolsMenu: "Herramientas de IA",
    AddImage: "Agregar Imagen",
    ReferenceImages: "Imágenes de Referencia",
    LoadingCourseReferenceImages: "Cargando las imágenes de referencia de la formación...",
    UploadFromComputer: "Subir desde el Ordenador",
    SelectFromLibrary: "Seleccionar de la Biblioteca",
    AddTagPlaceholder: "Agregar etiqueta...",
    AddVideo: "Agregar Video",
    AddSound: "Agregar Sonido",
    SaveAndAdd: "Guardar y Agregar",
    AddAvatar: "Agregar Avatar",
    AddPdf: "Agregar PDF",
    AddToScene: "Agregar a Escena",
    AddedToScene: "Añadido a la escena",
    AddAgain: "Añadir de nuevo",
    SoundSound: "Sonido",
    GenerateImage: "Generar Imagen",
    GenerateInfographicImage: "Generar Imagen Infográfica",
    MotionizeScene: "Crear movimiento desde la escena",
    MotionizeBlocked: "Esta escena contiene",
    MotionizeBlockedTail: "— una escena solo puede tener su narración e imágenes",
    MotionizeWorking: "Convirtiendo la escena en animación...",
    ReviewMotionScene: "Escena animada generada",
    MotionizeHint:
      "La narración y las imágenes de la escena se usan para generar una escena animada dibujada enteramente con código. Las imágenes no se reproducen: indican de qué trata la escena. El movimiento se ajusta a los tiempos de las palabras.",
    MotionizeReferences: "Imágenes de referencia",
    GenerateNewScene: "Generar Nueva Escena",
    InfographicScene: "Escena Infográfica",
    Animator: "Animador",
    "AI Agent": "Agente de IA",
    QuestionGenerator: {
      Title: "Generador de Preguntas",
      TabSingle: "Una escena",
      TabCombined: "Varias narraciones",
      TabInteractive: "Interactivo",
      IncludeScene: "Incluir en la pregunta",
      CombinedNarrations: "Narraciones seleccionadas",
      SelectScenesHint: "Selecciona al menos una escena de la lista.",
      QuestionType: "Tipo de Pregunta",
      MultipleChoice: "Opción Múltiple",
      MultipleAnswer: "Respuesta Múltiple",
      FreeResponse: "Respuesta Libre",
      FillInBlank: "Rellenar el Espacio",
      Matching: "Emparejamiento",
      Ordering: "Ordenar",
      SelectScenes: "Seleccionar Escenas",
      QuestionCount: "preguntas",
      UseThisScene: "Generar desde esta escena",
      EnableSceneHint: "Activa el interruptor de la escena para generar preguntas de ella.",
      Review: "Preguntas generadas",
      GeneratingQuestions: "Generando preguntas...",
      NoQuestionsGenerated: "No se generaron preguntas.",
      ErrorOccurred: "Ocurrió un error",
      CorrectMark: "Correcta",
      History: "Historial",
      NoHistory: "No hay preguntas anteriores.",
      PendingApproval: "Pendiente de aprobación",
      Added: "Añadida",
      AddedForScene: "Preguntas añadidas a esta escena",
      AlreadyInTraining: "Ya en la formación",
      ApproveThisQuestion: "Aprobar esta pregunta",
    },
    InteractiveScenario: {
      Type: {
        VisualText: "Tarjeta de texto",
        VisualImage: "Tarjeta de imagen",
        VideoCard: "Tarjeta de video",
        FlipCard: "Tarjeta volteable",
        TrueFalse: "Verdadero / Falso",
        MCQ: "Opción múltiple",
      },
      ButtonStyle: {
        Primary: "Primario",
        Secondary: "Secundario",
        Success: "Éxito",
        Danger: "Peligro",
      },
      Label: {
        Buttons: "Botones",
        Content: "Contenido",
        Image: "Imagen",
        Description: "Descripción",
        ImageClickAction: "Acción al hacer clic en la imagen",
        Video: "Video",
        Autoplay: "Reproducción automática",
        FrontFace: "Cara frontal",
        BackFace: "Cara trasera",
        BackgroundColor: "Color de fondo",
        FrontFaceBackground: "Fondo de la cara frontal",
        BackFaceBackground: "Fondo de la cara trasera",
        TextColor: "Color de texto",
        FrontFaceTextColor: "Color de texto de la cara frontal",
        BackFaceTextColor: "Color de texto de la cara trasera",
        FlipAction: "Acción al voltear",
        ActionButtonOptional: "Botón de acción (opcional)",
        CorrectAnswer: "Respuesta correcta:",
        CorrectActions: "Acciones Correctas",
        IncorrectActions: "Acciones Incorrectas",
        BackActions: "Acciones traseras",
        Title: "Título",
        Start: "INICIO",
        SceneTitle: "Título de la escena",
        Background: "Fondo",
        Pattern: "Patrón",
        HiddenStarts: "Inicia oculto",
        VisibleStarts: "Inicia visible",
        Hidden: "Oculto",
        SceneCountSuffix: "escenas",
        StartTitleCase: "Inicio",
        ElementCountSuffix: "elemento",
        ClickToFlip: "Haz clic para voltear",
      },
      Action: {
        SelectFromLibrary: "Seleccionar de la biblioteca",
        AddButton: "+ Agregar botón",
        ChangeImage: "Cambiar imagen",
        AddImage: "Agregar imagen",
        RemoveImage: "Quitar imagen",
        AddChoice: "+ Agregar opción",
        AddElement: "+ Agregar elemento",
        MakeStart: "Definir como inicio",
        AddAction: "+ Agregar acción",
        AddScene: "Agregar escena",
        DeleteScene: "Eliminar esta escena",
        DeleteAction: "Eliminar acción",
        OK: "Aceptar",
      },
      Placeholder: {
        ButtonLabel: "Etiqueta del botón",
        OrEnterUrl: "o ingresa URL…",
        ImageDescriptionOptional: "Descripción de imagen (opcional)",
        VideoDescriptionOptional: "Descripción de video (opcional)",
        Title: "Título",
        Text: "Texto",
        Question: "Pregunta",
        TrueLabel: "Verdadero",
        FalseLabel: "Falso",
        TrueLabelDetailed: "Etiqueta de verdadero",
        FalseLabelDetailed: "Etiqueta de falso",
        ExplanationOptional: "Explicación (opcional)",
        ChoiceText: "Texto de la opción",
        ElementTitle: "Título del elemento",
        AlertMessage: "Mensaje de notificación",
        Value: "Valor",
        AddImageHint: "Añade imagen",
        AddVideoHint: "Añade video",
      },
      Default: {
        Button: "Botón",
        Title: "Título",
        Text: "Texto",
        Continue: "Continuar",
        FrontTextHint:
          "Escribe una pista o pregunta en el anverso. El usuario voltea la tarjeta para ver la respuesta.",
        BackTitle: "Respuesta",
        BackTextHint: "Escribe la explicación o respuesta correcta en el reverso.",
        QuestionHint:
          "Escribe tu pregunta aquí. El usuario selecciona Verdadero o Falso para responder.",
        MCQQuestionHint: "Escribe tu pregunta aquí. Marca la opción correcta abajo.",
        ExplanationHint: "Escribe la explicación de la respuesta correcta aquí.",
        Choice1: "Primera opción",
        Choice2: "Segunda opción",
        Choice3: "Tercera opción",
        NewScene: "Nueva Escena",
        NewScenario: "Nuevo Escenario",
      },
      Badge: {
        VisualText: "Tarjeta de narración y acción",
        VisualImage: "Tarjeta de imagen",
        VideoCard: "Tarjeta de video",
        FlipCard: "Tarjeta volteable",
        TrueFalse: "Verdadero / Falso",
        MCQ: "Pregunta de opción múltiple",
      },
      ActionType: {
        Navigate: "Ir a la escena",
        SetElementVisibility: "Mostrar/Ocultar elemento",
        Alert: "Notificación",
        SetVariable: "Actualizar variable",
        EndScenario: "Finalizar escenario",
      },
      ActionOperator: {
        Set: "Asignar (=)",
        Add: "Sumar (+=)",
        Subtract: "Restar (-=)",
        Toggle: "Alternar",
      },
      Visibility: {
        Show: "Mostrar",
        Hide: "Ocultar",
        Toggle: "Alternar",
      },
      Option: {
        True: "Verdadero",
        False: "Falso",
        SelectScene: "— seleccionar escena —",
        SelectElement: "— seleccionar elemento —",
        SelectVariable: "— variable —",
      },
      Empty: {
        Title: "No se encontró escenario",
        Description: "Crea un nuevo escenario para este elemento",
        Create: "Crear Escenario",
        NoElementsInScene: "No hay elementos en esta escena",
        AddElementFromPanel: "Agrega un elemento desde el panel derecho",
        NoScenesYet: "Aún no hay escenas",
        StartByAddingFirstScene: "Comienza agregando la primera escena",
        AddElementFromTopHint: "Añade un elemento desde arriba y colócalo en el lienzo.",
      },
      EndScreen: {
        Title: "Escenario interactivo completado",
        Restart: "Reiniciar",
      },
    },
    SceneAudioVoice: "Audio de Escena",
    NarratorSettings: "Configuración del Narrador",
    OrganizationStyle: "Estilo de Organización",
    UsedPromptInCourse: "Estilo Personalizado Usado en Este Curso",
    Generate: "Generar",
    Regenerate: "Regenerar",
    Generating: "Generando...",
    WriteYourNarration: "Escribe tu narración...",
    GenerateSceneHint:
      "(Añade una nueva escena completamente lista después de la escena seleccionada)",
    ImageText: "Texto de Imagen",
    WriteImageText: "Escribe el texto que quieres convertir en imagen...",
    GenerateImageHint: "(Agrega solo 1 imagen infográfica a la escena actual)",
    GenerateScene: "Generar Escena",
    GenerateFromNarration: "Generar desde Narración",
    GenerateFromNarrationHint:
      "(Los elementos visuales existentes en tu escena serán reemplazados por nuevos. Si no deseas perderlos, trabaja en una escena vacía.)",
    GenerateFromNarrationNewHint: "(Se añade como una nueva escena justo después de la actual.)",
    ApplyToCurrentScene: "Añadir a la escena actual",
    CreateAsNewScene: "Crear como nueva escena",
    ReviewGeneratedImages: "Imágenes generadas",
    GeneratingScene: "Generando escena...",
    GeneratingImage: "Generando imagen...",
    ToCurrentScene: "escena actual",
    AsNewScene: "nueva escena",
    Approve: "Aprobar",
    Close: "Cerrar",
    Discard: "Descartar",
    Play: "Reproducir",
    NoSoundInScene: "No hay sonido en esta escena.",
    RestoreNarrationText: "Restaurar texto de narración",
    CreateEmptySceneAndSound: "(Primero crea una escena vacía y sonido)",
    CreateAudio: "Crear Audio",
    CreatingAudio: "Creando Audio...",
    AIGenerate: "Generar con IA",
    ChooseFromLibrary: "Elegir de biblioteca",
    UploadMyImage: "Subir mi imagen",
    ImageEdit: {
      Scope: "Alcance",
      RemoveAllText: "Eliminar Todo el Texto",
      RemoveSelectedText: "Eliminar Textos Seleccionados",
      TranslateAllText: "Traducir Todo el Texto",
      TranslateSelectedText: "Traducir Textos Seleccionados",
      TargetTexts: "Textos Objetivo",
      TargetTextPlaceholder: "Texto (p. ej. OFERTA)",
    },
    // Las dos pestañas generativas de Añadir Imagen: un objeto 3D y un gráfico
    // animado a partir de un prompt.
    SceneVisual: {
      Output: "Salida",
      OutputMotion: "Estándar",
      OutputGif: "GIF",
      OutputWebp: "WebP",
      OutputMp4: "MP4",
      AiEdit: "Editar con IA",
      AiEditHint: "Escribe qué debe cambiar. Se aplica al gráfico animado actual.",
      AiEditHintLoop:
        "Escribe qué debe cambiar. Se aplica a la animación y el {{format}} se genera de nuevo.",
      AiEditPlaceholder:
        "Ej.: haz el círculo más pequeño · pon el texto en rojo · oscurece el fondo",
      AiEditRunning: "Aplicando el cambio",
      AiEditRunningMeta:
        "Puede tardar unos minutos — puedes cerrar esta ventana; se aplica a la caja al terminar.",
      AiEditApply: "Aplicar",
      AiEditUnavailable:
        "Esta imagen no se puede editar con IA (no tiene fuente). Puedes generar un nuevo gráfico animado.",
      ToVideo: "Convertir a MP4 / WebP",
      ToVideoHint:
        "El gráfico animado se convierte tal cual, con su propia duración, y se añade a la escena. No se usa ningún modelo ni se cobran créditos.",
      ToVideoMp4Hint:
        "Se añade como video con reproducción automática. Se reproduce sincronizado con la línea de tiempo.",
      ToVideoWebpHint:
        "Se añade como imagen que se reproduce una vez y se queda en el último fotograma. No sigue el cabezal de la línea de tiempo: sigue reproduciéndose sola al pausar o desplazarte.",
      ToVideoRunning: "Convirtiendo a video",
      ToWebpRunning: "Convirtiendo a WebP",
      ToVideoRunningMeta:
        "Puede tardar unos minutos — puedes cerrar esta ventana; se añade a la escena al terminar.",
      ToVideoApply: "Convertir",
      ToVideoUnavailable: "Esta caja no se puede convertir en video.",
      Generate: "Generar",
      Regenerate: "Generar de nuevo",
      GeneratingMeta:
        "El modelo está escribiendo — puede tardar unos minutos; puedes cerrar el diálogo.",
      InputRequiredTitle: "Falta una descripción",
      InputRequired: "Escribe qué quieres ver o usa la narración de la escena.",
      NarrationPlaceholder: "La narración de esta escena…",
      StyleBrief: "Dirección de estilo (opcional)",
      StyleBriefPlaceholder:
        "Paleta, tono, tipografía — p. ej. fondo oscuro, acento turquesa, sobrio",
      Model: "Modelo",
      ModelAuto: "Automático (Sonnet 5.5)",
      ModelSonnet: "Sonnet 5.5",
      ModelOpus: "Opus 5.5",
      ModelDeepseekFlash: "DeepSeek V4.1 Flash",
      Orientation: "Orientación",
      Duration: "Duración (s)",
      DurationPlaceholder: "p. ej. 15",
      ThreeD: {
        Tab: "Objeto 3D",
        Title: "Objeto 3D",
        Placeholder: "¿Qué hay que modelar? p. ej. un corazón humano de cuatro cámaras que se abre",
        Generating: "Creando el objeto 3D…",
        Hint: "La cámara, los puntos etiquetados y las interacciones útiles se deducen de lo que escribas.",
      },
      Motion: {
        GifHint:
          "La animación da una vuelta completa en este tiempo y se repite sin fin (máximo {{max}} s). Se añade a la escena como imagen.",
        GifDurationRequired: "Para un {{format}}, indica una duración entre 2 y {{max}} segundos.",
        DurationRequiredTitle: "Falta la duración",
        DurationRequired: "Indica cuántos segundos dura el gráfico animado (entre 2 y {{max}}).",
        DurationHint:
          "Si la animación termina antes, su imagen final sigue en bucle el resto del tiempo.",
        Tab: "Gráfico Animado",
        Title: "Gráfico animado",
        Placeholder:
          "¿Qué debe moverse? p. ej. un proceso de tres etapas que aparece en orden, con la última destacada",
        Generating: "Creando el gráfico animado…",
        Hint: "El modelo construye el orden a partir de tu texto; tú defines la duración.",
      },
    },
    ImageHistory: {
      Tab: "Registro de Actividad",
      AudioTab: "Registro de Audio",
      AvatarTab: "Registro de Avatar",
      CurrentBalance: "Saldo Actual",
      MonthlySpending: "Gasto Mensual",
      TrainingImageSpending: "Gasto en Imágenes",
      TrainingVideoSpending: "Gasto en Videos",
      TrainingAudioSpending: "Gasto en Audio",
      TrainingAvatarSpending: "Gasto en Avatares",
      TrainingSpending: "Gasto Total",
      Credits: "Créditos",
      Preview: "Vista previa",
      TaskName: "Nombre de tarea",
      Name: "Nombre",
      Scene: "Escena",
      Model: "Modelo",
      DateTime: "Fecha y hora",
      Prompt: "Prompt",
      Narration: "Narración",
      Category: "Tipo",
      CategoryImage: "Imagen",
      CategoryVideo: "Video",
      CategoryAudio: "Locución",
      CategoryAvatar: "Avatar",
      Status: "Estado",
      Amount: "Cantidad",
      Completed: "Completado",
      Empty: "Aún no se han generado imágenes",
      EmptyVideo: "Aún no se han generado videos",
      EmptyAudio: "Aún no se ha generado audio",
      EmptyAvatar: "Aún no se han generado avatares",
      EmptyAny: "Aún no se ha generado nada",
      Play: "Reproducir",
      ShowAll: "Todas las Actividades",
      ShowOnlyThis: "Filtrado",
      View: "Ver",
      LoadError: "No se pudo cargar el historial",
      AddFailed: "No se pudo añadir a la escena; inténtalo de nuevo.",
      NoOrganization: "Organización no encontrada",
      Close: "Cerrar",
      DefaultNameImage: "Imagen Generada por IA",
      DefaultNameVideo: "Video Generado por IA",
      DefaultNameNarration: "Narración Generada por IA",
      DefaultNameAvatar: "Avatar Generado por IA",
    },
    CreditEstimate: {
      Button: "Créditos",
      Tooltip: "Mostrar el costo en créditos de esta operación",
      Title: "Estimación de Créditos",
      Cost: "Esta operación",
      Balance: "Tu saldo",
      Sufficient: "Saldo suficiente",
      Insufficient: "Saldo insuficiente",
      MultiProvider: "proveedores en total",
      Loading: "Cargando",
      Duration: "Duración",
      Failed: "Consulta de crédito fallida",
    },
    UploadMyFile: "Subir mi archivo",
    SoundTabTooltip: {
      ai: "Convierte tu texto en una voz de narración natural con IA.",
      avatar: "Crea un avatar para presentar tu texto.",
      library: "Elige entre tus sonidos guardados.",
      record: "Graba tu propia voz y úsala como narración.",
      upload: "Sube un archivo de audio desde tu dispositivo (mp3, wav, etc.).",
    },
    TopLeft: "Superior Izquierda",
    TopCenter: "Superior Centro",
    TopRight: "Superior Derecha",
    BottomLeft: "Inferior Izquierda",
    BottomCenter: "Inferior Centro",
    BottomRight: "Inferior Derecha",
    Center: "Centro",
    BoldWhiteWithShadow: "Negrita Blanca (Sombra)",
    BoldBlackWithShadow: "Negrita Negra (Sombra)",
    LargeWhiteBold: "Blanca Grande Negrita",
    MediumWhiteRegular: "Blanca Mediana Normal",
    SmallWhiteItalic: "Blanca Pequeña Cursiva",
    SmallGrayItalic: "Gris Pequeña Cursiva",
    BoldYellowWithShadow: "Negrita Amarilla (Sombra)",
    Custom: "Personalizado",
    CustomStyle: "Estilo Personalizado",
    Style: "Estilo",
    styles_load_error: "Error al cargar plantillas de estilo",
    Generated: "Generado",
    UnknownError: "Error desconocido",
    SoundUploadFailed: "No se pudo subir el sonido",
    Added: "Añadido",
    Search: "Buscar",
    Storyboard: "Vídeos de storyboard",
    NoResults: "No se encontraron imágenes",
    "No video selected": "No se ha seleccionado ningún vídeo",
    aiTools: "IA",
    Rotation: "Rotación",
    Cancelled: "Cancelado",
    warning_title: "Advertencia",
    Page: "Página",
    soundList: "Lista de sonidos",
    "BoxAnimations--title": "Animaciones del elemento",
    sound_fx_delete_confirm: "¿Seguro que quieres eliminar este efecto?",
    sound_fx_delete_error: "No se pudo eliminar el efecto",
    "Insufficient balance": "Saldo insuficiente",
    "Result not ready yet": "El resultado aún no está listo",
    "Result URL missing": "Falta la URL del resultado",
    "No handler to apply result":
      "No hay ningún controlador para aplicar el resultado — por favor, notifícalo.",
    avatarAnimate: {
      starting: "Enviando…",
      sent: "En cola",
      trigger: "Animar avatares",
      sceneNone: "No hay ningún avatar que animar en esta escena",
      scene: "Animar el avatar de esta escena",
      none: "No quedan avatares por animar",
      all: "Animar los avatares de todas las escenas",
      history: "Historial",
      use: "Aplicar",
      historyEmpty: "No hay historial para esta escena",
    },
    interactive: {
      library: "Añadir elemento",
      library_search_placeholder: "Filtrar elementos…",
      library_search_label: "Filtrar elementos interactivos",
      library_search_clear: "Borrar filtro",
      library_search_count: "Mostrando {{shown}} de {{total}}",
      library_search_empty: "Ningún elemento coincide con “{{query}}”",
      moved_to_left: "Añade elementos desde la sección Elementos interactivos del panel izquierdo.",
    },
    LibraryCatalog: {
      title: "Catálogo de elementos interactivos",
      how_it_works: "Cómo funciona",
      live_preview: "Vista previa en directo",
      add_hint:
        "Para añadir este elemento, cierra el catálogo y haz clic en su etiqueta en el panel Elementos interactivos.",
    },
    ImageChatEdit: {
      SeedPrompt: "Quiero editar esta imagen de la siguiente manera: ",
      ButtonTooltip: "Editar con el chatbot",
    },
    EditorNavBar: {
      workflow_tooltip: "Abrir el editor de flujos de trabajo",
      workflow: "Flujo de trabajo",
    },
    Timeline: {
      WaitingForInteractive: "La línea de tiempo espera un elemento interactivo",
      SkipInteractive: "Omitir el elemento interactivo y continuar la línea de tiempo",
    },
    FlowItems: {
      selected_element: "Elemento seleccionado",
      no_selection: "Propiedades del elemento",
      click_to_select: "Selecciona un elemento en el lienzo para editar sus propiedades.",
      title: "ELEMENTOS",
      empty_after_move: "Aún no hay elementos — usa el panel izquierdo para añadir uno.",
      remove: "Eliminar",
    },
    InteractivePlugin: {
      scenario: "Escenario",
    },
    Regenerate: "Regenerar",
    EditPhoto: "Editar Foto",
    MerlinAI: "Aidea Wizard AI",
    Merlin: "Aidea Wizard",
    MerlinVideoTranscribe: "Transcribir",
    ViewTranscript: "Ver transcripción",
    MerlinVideoNarration: "Narración formal",
    MerlinVideoVoiceover: "Voz en off",
    MerlinComingSoon: "Próximamente",
    Sestek: "Sestek",
    DefaultOption: "Predeterminado",
    NarrationStyle: "Estilo de narración",
    NarrationSound: "Voz de narración",
    NarrationStyleNone: "Ninguno (locutar literal)",
    NarrationFailed: "Error al generar la narración.",
    NarrationTextPlaceholder: "Escribe el texto a locutar…",
    NarrationReady: "Narración lista.",
    GenerateAgain: "Generar de nuevo",
    NoVoicesFound: "No se encontraron voces.",
    PleaseEnterNarrationText: "Introduce el texto de la narración.",
    MerlinVideoTranscribing: "Transcribiendo vídeo…",
    MerlinVideoTranscribeFailed: "Error en la transcripción. Haz clic para descartar.",
    TranscribeRetry: "Reintentar",
    TranscribeStart: "Iniciar transcripción",
    TranscribeEmptyHint:
      "Este vídeo aún no tiene transcripción. Inicia una: se ejecuta en segundo plano y aparecerá aquí cuando esté lista.",
    TranscribeStartedHint:
      "Transcripción iniciada. Se ejecuta en segundo plano; aparecerá aquí cuando esté lista.",
    TranscriptionVideoTooLong:
      "Este video es demasiado largo para transcribir. El máximo es {{maxMinutes}} minutos.",
    TranscriptionVideoTooLarge:
      "Este video es demasiado grande para transcribir. El máximo es {{maxMB}} MB.",
    TranscriptModal_Title: "Transcripción",
    TranscriptModal_Save: "Guardar",
    TranscriptModal_Saving: "Guardando…",
    TranscriptModal_Copy: "Copiar",
    TranscriptModal_Copied: "Copiado",
    MerlinNarrationNeedsTranscript: "Transcribe el vídeo primero",
    TranscriptModal_Close: "Cerrar",
    ChangeTool: "Cambiar Herramienta",
    Collapse: "Contraer",
    AspectRatio: "Relación de Aspecto",
    AspectRatioLock: "Bloquear relación de aspecto",
    AspectRatioLockHint:
      "Mantiene las proporciones al redimensionar. Mantén Shift mientras arrastras un tirador para activarlo o desactivarlo temporalmente.",
    OptionalEnhancements: "Mejoras Opcionales",
    TextInVideo: "Texto en Video",
    TextInImage: "Texto en Imagen",
    OverlayText: "Superponer Texto",
    ClickToUploadOrDragDrop: "Haz clic para subir o arrastra y suelta",
    PNGJPGOrWEBPMax10MB: "PNG, JPG o WEBP (máx 100MB)",
    WritePrompt: "Escribir Prompt",
    FromNarration: "Desde Narración",
    RawPrompt: "Continuar con Prompt Directo",
    NoBalance: "No tienes créditos suficientes para esta operación.",
    EnrichTexts: "Enriquecer con AI",
    Enriching: "Enriqueciendo...",
    EnrichMyPrompt: "✨ Enriquecer mi prompt",
    SceneNarration: "Narración de Escena",
    EditToHighlightKeyVisuals: "Editar para resaltar visuales clave",
    DescribeSceneNarration: "Describe la narración de la escena...",
    EachSentenceBecomesScene:
      "Cada frase se convierte en una escena. Elimina las que no necesiten apoyo visual.",
    TipRemoveParts:
      "Consejo: Elimina partes que no necesiten soporte visual. Mantén las oraciones que describen lo que debe mostrarse.",
    GenerateImagePromptFromNarration: "Generar Prompt de Imagen desde Narración",
    AIWillUse: "AI usará",
    AIVoice: "Voz de Narración AI",
    CreateFromText: "Crear desde texto",
    CreateFromSceneAudio: "Crear desde audio de escena",
    SelectedAudio: "Audio seleccionado:",
    SceneAudioLabel: "Audio de la escena",
    CreateNewNarration: "Crear nueva narración",
    RestorePreviousNarration: "Recuperar audio eliminado",
    DeletedAudio: "eliminado",
    RestoreDeletedAudio: "Recuperar",
    GenerateVoice: "Generar Voz",
    RegenerateVoice: "Regenerar Voz",
    SelectNarrator: "Seleccionar Narrador",
    AvatarNarration: "Narración de Avatar",
    FromLibrary: "Desde la biblioteca",
    RecordMyVoice: "Grabar mi voz",
    SoundModalTitle: "Sonido",
    AvatarModalTitle: "Avatar",
    FromLibraryComingSoon: "No se encontraron sonidos en la biblioteca.",
    RecordMyVoiceComingSoon: "La grabación de voz estará disponible pronto.",
    CreateAvatar: "Crear Avatar",
    CreatingAvatar: "Creando...",
    OnlyAvailableForAidea: "Solo disponible para el proveedor Aidea",
    AzureKeepVoiceComingSoon:
      "El lip-sync de Azure Avatar con voz de narración estará disponible pronto.",
    SelectVoice: "Seleccionar voz",
    Voice1: "Voz 1",
    Voice2: "Voz 2",
    Voice3: "Voz 3",
    Voice4: "Voz 4",
    Voice5: "Voz 5",
    Voice6: "Voz 6",
    Voice7: "Voz 7",
    Voice8: "Voz 8",
    UsingProjectVoice: "✓ Usando voz del proyecto",
    SavedVoiceLoaded: "✓ Voz guardada cargada",
    VoiceGenerated: "✓ Voz generada",
    OwnVoice: "Voz Propia",
    VoiceText: "Texto de Voz",
    VoiceTags: "Etiquetas de Voz",
    EstimatedVoiceDuration: "Duración estimada de voz",
    UseSlideNotes: "Usar notas de la diapositiva",
    Minutes: "min",
    Seconds: "seg",
    Chars: "caracteres",
    chars: "caracteres",
    DefaultVoiceText:
      "Bienvenido al entrenamiento Ada Lovelace Test 01. En este módulo examinaremos los fundamentos psicológicos del comportamiento del usuario.",
    ProjectVoice: "Voz del proyecto:",
    Carlos: "Carlos",
    ElevenLabs: "ElevenLabs",
    Azure: "Azure",
    Aidea: "Aidea",
    Hulya: "Hülya",
    German: "Alemán",
    Speed: "1.0x",
    FemaleWarmTurkish: "Femenino · Cálido · Turco",
    ChangeNarrator: "Narración de audio",
    AIVoices: "Voces AI",
    BringYourOwnVoice: "Clonar Voz",
    Service: "Servicio",
    Language: {
      Turkish: "Turco",
      English: "Inglés (EE.UU.)",
      EnglishUK: "Inglés (Reino Unido)",
      Spanish: "Español",
      French: "Francés",
      German: "Alemán",
      Chinese: "Chino",
      Azerbaijani: "Azerbaiyano",
      Arabic: "Árabe",
      Russian: "Ruso",
      Japanese: "Japonés",
      Portuguese: "Portugués (BR)",
      Multilingual: "Multilingüe",
    },
    AccentLanguage: "Acento / Idioma",
    AccentAuto: "Automático",
    Voice: "Voz",
    Voices: "Voces",
    SampleLanguage: "Idioma de Muestra",
    CloneYourVoice: "Clonar Tu Voz",
    CloneVoiceDescription: "Sube una muestra de audio para clonar tu voz",
    VoiceName: "Nombre de Voz",
    EnterVoiceName: "Ingrese el nombre de la voz",
    AudioFile: "Archivo de Audio",
    ChooseFile: "Elegir Archivo",
    NoFileChosen: "Ningún archivo elegido",
    CloneVoice: "Clonar Voz",
    PleaseSelectAudioFile: "Por favor selecciona un archivo de audio válido",
    DropFileHere: "Suelta tu archivo de audio aquí",
    DragDropOrClick: "Arrastra y suelta tu archivo de audio aquí",
    BrowseFiles: "Explorar Archivos",
    Uploading: "Subiendo...",
    UploadError: {
      Failed: "No se pudo subir el archivo.",
      TooManyRequests: "Hay demasiadas subidas en curso. Inténtalo de nuevo cuando terminen.",
      Unauthorized: "No tienes permiso para esta acción. Vuelve a iniciar sesión.",
      TooLarge: "El archivo supera el límite del servidor.",
      ServerError: "No se pudo subir el archivo por un error del servidor.",
    },
    YourClonedVoices: "Tus Voces Clonadas",
    NoClonedVoices: "Aún no hay voces clonadas. Sube una muestra de audio para clonar tu voz.",
    ClonedVoice: "Clonado",
    ConfirmDeleteVoice: "¿Estás seguro de que quieres eliminar esta voz?",
    VoiceClonedSuccessfully: "¡Voz clonada exitosamente!",
    VoiceDeletedSuccessfully: "¡Voz eliminada exitosamente!",
    PleaseSelectClonedVoice: "Por favor selecciona una voz clonada",
    Success: "Éxito",
    UploadFile: "Subir Archivo",
    UploadVoiceFile: "Sube Tu Voz",
    RecordWithMicrophone: "Grabar con Micrófono",
    StartRecording: "Iniciar Grabación",
    StopRecording: "Detener Grabación",
    Recording: "Grabando...",
    RecordingSample: "Muestra de Grabación",
    ReadThisText: "Lee este texto:",
    RecordingInstruction:
      "Haz clic en el botón 'Iniciar Grabación' para comenzar a grabar tu muestra de voz.",
    NextSample: "Siguiente Muestra",
    FinishRecording: "Finalizar Grabación",
    MicrophonePermissionDenied:
      "Permiso de micrófono denegado. Por favor permite el acceso al micrófono.",
    MicrophoneErrorMessage: "Error del micrófono. Por favor verifique su micrófono.",
    RecordingText1:
      "Hola, esta es una prueba de mi voz. Estoy leyendo este texto para crear un clon de voz. La tecnología detrás de la clonación de voz es fascinante. Esta muestra ayudará a crear una representación precisa de mi voz.",
    RecordingText2:
      "El rápido zorro marrón salta sobre el perro perezoso. Esta oración contiene cada letra del alfabeto. La clonación de voz requiere muestras de habla diversas. Múltiples grabaciones ayudan a mejorar la precisión y naturalidad.",
    RecordingText3:
      "Disfruto leyendo libros y escuchando música en mi tiempo libre. Estas actividades me ayudan a relajarme después de un largo día. Aprender cosas nuevas es uno de mis pasatiempos favoritos. Creo que el crecimiento continuo es esencial para el desarrollo personal.",
    RecordingText4:
      "La tecnología está cambiando la forma en que nos comunicamos entre nosotros. La inteligencia artificial se está integrando más en nuestras vidas diarias. Los asistentes de voz ahora son comunes en muchos hogares. El futuro de la interacción humano-computadora está evolucionando rápidamente.",
    RecordingText5:
      "Cada mañana me despierto sintiéndome fresco y energizado para el día. Una buena noche de sueño es crucial para mantener la salud y productividad. Trato de mantener un horario de sueño consistente durante la semana. El ejercicio regular también me ayuda a estar alerta y enfocado.",
    RecordingText6:
      "La inteligencia artificial está revolucionando muchas industrias en todo el mundo. Desde la salud hasta las finanzas, la IA está teniendo impactos significativos. Los algoritmos de aprendizaje automático se vuelven más sofisticados cada día. Las aplicaciones potenciales parecen ilimitadas y emocionantes.",
    RecordingText7:
      "Me gusta viajar y explorar nuevos lugares alrededor del mundo. Conocer personas de diferentes culturas es una experiencia enriquecedora. Cada viaje me enseña algo valioso sobre la vida. Viajar amplia perspectivas y crea recuerdos duraderos.",
    RecordingText8:
      "Aprender nuevas habilidades nos ayuda a crecer y desarrollarnos como individuos. Ya sea un idioma, instrumento o habilidad técnica, la práctica es clave. El esfuerzo consistente con el tiempo conduce a la maestría. El viaje de aprendizaje en sí es gratificante y satisfactorio.",
    RecordingText9:
      "La buena comunicación es esencial para construir relaciones fuertes con otros. Escuchar activamente es tan importante como hablar claramente. Comprender diferentes perspectivas ayuda a resolver conflictos pacíficamente. La empatía y el respeto forman la base de conexiones significativas.",
    RecordingText10:
      "Creo en trabajar duro y mantenerme positivo a través de los desafíos. El éxito a menudo proviene de la persistencia y determinación. Mantener una mentalidad de crecimiento ayuda a superar obstáculos. Cada revés es una oportunidad para aprender y mejorar.",
    PlayRecording: "Reproducir Grabación",
    ResetRecording: "Restablecer Grabación",
    Provider: "Proveedor",
    Language: "Idioma",
    Voice: "Voz",
    SelectProvider: "Seleccionar un proveedor",
    SelectLanguage: "Seleccionar un idioma",
    SelectVoice: "Seleccionar voz",
    PleaseSelectProvider: "Por favor seleccione un proveedor",
    PleaseSelectLanguage: "Por favor seleccione un idioma",
    PleaseSelectVoice: "Por favor seleccione una voz",
    PleaseSelectNarrator: "Seleccione un narrador antes de generar la voz.",
    PleaseGenerateVoiceFirst: "Por favor genere la voz primero",
    PleaseUploadFileFirst: "Por favor suba un archivo primero",
    Generating: "Generando...",
    Loading: "Cargando...",
    Google: "Google",
    NoVoicesAvailable: "No hay voces disponibles",
    Gender: "Género",
    SelectGender: "Seleccionar Género",
    AllGenders: "Todos",
    AllProviders: "Todos",
    Male: "Masculino",
    Female: "Femenino",
    ChangeVoice: "Cambiar voz",
    ListenPreview: "Escuchar la vista previa generada",
    Of: "de",
    NoVoicesFound: "No se encontraron voces",
    SceneOf: "Escena {{current}} de {{total}}",
    SceneEndTime: "Tiempo de fin en la escena",
    SoundSettings: "Configuración de Sonido",
    StartTimeOnSlide: "Tiempo de Inicio en Diapositiva",
    SoundVolume: "Volumen de Sonido",
    ZeroPercent: "0%",
    HundredPercent: "100%",
    WhatVoiceShouldAvatarUse: "¿Qué voz debería usar el avatar?",
    KeepMyNarrationVoice: "Mantener mi voz de narración",
    UseSceneAudio: "Usar audio de la escena",
    LipSyncToHulya: "Sincronización labial con Hülya",
    UseADifferentVoice: "Usar una voz diferente",
    HeyGen: "HeyGen",
    AzureVideo: "Azure Video",
    Tavus: "Tavus",
    Synthesia: "Synthesia",
    GoogleAvatars: "Avatares de Google",
    StockAvatars: "Avatares de Stock",
    ChooseFromBuiltInAvatars: "Elegir de avatares incorporados",
    CreateNewAvatar: "Crear Nuevo Avatar",
    UploadVideoOrRecord: "Subir video o grabar",
    ComingSoon: "Próximamente",
    NEW: "NUEVO",
    SeeAllAvatars: "Ver Todos los Avatares",
    ShowLess: "Mostrar Menos",
    VoiceProvider: "Proveedor de Voz",
    SelectVoiceProvider: "Seleccionar proveedor de voz",
    LipsyncProvider: "Sincronización Labial",
    LipsyncAuto: "Auto",
    LipsyncCustom: "Personalizado",
    AvatarAspectRatio: "Relación de Aspecto",
    AvatarAspectSquare: "Cuadrado (1:1)",
    AvatarAspectWide: "Horizontal (16:9)",
    // Rediseño de la pestaña Avatar (diseño de dos pasos)
    AvatarStepSubtitle: "Crea un avatar para narrar tu escena",
    AideaAvatarLibrary: "Biblioteca de Avatares Aidea",
    AideaAvatarLibraryMeta: "Presentadores listos de Aidea y socios",
    CreateYourOwn: "Crea el tuyo",
    CreateYourOwnMeta: "Genera con IA, o sube un video o una foto",
    AvatarSourceChange: "Cambiar",
    AvatarPickGenderHint: "Elige un género primero",
    AvatarSelectFirstHint: "Selecciona o crea un avatar primero",
    AvatarShuffleIdentity: "Nombre y título aleatorios",
    Shuffle: "Aleatorio",
    AvatarPlaySample: "Reproducir muestra",
    AvatarDelete: {
      Button: "Eliminar avatar",
      Title: "Eliminar avatar",
      Desc: "¿Estás seguro? Tu avatar guardado «{{name}}» se eliminará por completo, junto con todos los registros creados para él. Esta acción no se puede deshacer. Los videos ya añadidos a las escenas no se ven afectados.",
      Cancel: "Cancelar",
      Confirm: "Sí, eliminar",
      Deleting: "Eliminando...",
      ErrorNotDeletable: "Este avatar no se puede eliminar.",
      ErrorGeneric: "No se pudo eliminar el avatar, inténtalo de nuevo.",
    },
    VoiceDelete: {
      Button: "Eliminar voz",
      Title: "Eliminar voz clonada",
      Desc: "¿Estás seguro? Tu voz clonada «{{name}}» se eliminará. Esta acción no se puede deshacer. Las narraciones ya añadidas a las escenas no se ven afectadas.",
    },
    All: "Todos",
    SeeAllCount: "Ver todos ({{num}})",
    AvatarIdentity: "Identidad",
    AvatarNameShort: "Nombre",
    GenerationMethod: "Método de generación",
    GenerateWithPrompt: "Generar con Prompt",
    GenerateWithPromptMeta: "Describe tu avatar libremente",
    GenerateWithGuide: "Generar con Guía",
    GenerateWithGuideMeta: "Responde unas preguntas rápidas",
    UseYourOwnMedia: "Usa tu propio contenido",
    UseYourOwnMediaMeta: "Sube un video o una foto",
    DescribeYourAvatar: "Describe tu avatar",
    Suggestions: "Sugerencias",
    AvatarSuggestAge: "edad",
    AvatarSuggestEthnicity: "etnia",
    AvatarSuggestProfession: "profesión",
    AvatarSuggestHairColor: "color de cabello",
    AvatarSuggestFacial: "rasgos faciales",
    AvatarSuggestClothing: "vestimenta",
    AvatarSuggestBackground: "fondo",
    AvatarSuggestPose: "sentado / de pie",
    AvatarSuggestHands: "manos visibles",
    GeneratePersonaPreview: "Generar vista previa de persona",
    VoiceAndNarration: "Voz y narración",
    VoiceAndNarrationSub: "Edita el texto de la narración y elige la voz",
    UseSceneAudio: "Usar audio de la escena",
    UseSceneAudioMeta: "Narra con el audio existente de esta escena",
    GenerateNewVoice: "Generar nueva voz / Editar audio de escena",
    GenerateNewVoiceMeta: "Elige una voz de IA para leer la narración",
    EditText: "Editar texto",
    AudioTags: "Etiquetas de audio",
    GenerateVoicePreview: "Generar vista previa de voz",
    GenerateVoicePreviewFull: "Generar completo",
    GenerateVoicePreviewShort: "Generar vista previa de 5s",
    VoicePreviewNotEnoughText:
      "No hay suficiente texto para una vista previa de 5 segundos. Introduce más texto.",
    GeneratingVoicePreview: "Generando…",
    AvatarGenerateFirst: "Primero genera tu avatar (Generar vista previa de persona).",
    AvatarCompleteFieldsHint: "Primero completa las selecciones requeridas.",
    AvatarVideoGenerating: "Generando video del avatar…",
    AvatarVideoGeneratingHint: "Esto puede tardar unos minutos. Mantén esta ventana abierta.",
    GenerateVoicePreviewHint: "Lee la narración con la voz seleccionada",
    StopPreview: "Detener vista previa",
    DeletePreview: "Eliminar vista previa",
    LipSync: "Sinc. labial",
    Engine: "Motor",
    AvatarRendersForScene: "El avatar se procesa para {{scene}} · {{duration}}",
    AvatarRendersForSceneNoDuration: "El avatar se procesa para {{scene}}",
    // "Vídeo con habla natural" (Omni / Seedance + ElevenLabs STS) — add_sound_modal/talking_avatar
    TalkingAvatar: {
      Beta: "Beta",
      SceneHasJob: "Esta escena tiene un trabajo de vídeo con habla natural",
      Method: {
        Title: "Método de generación",
        Lipsync: "Sincronización labial",
        LipsyncMeta: "El vídeo del avatar se sincroniza con la voz que elijas",
        Talking: "Vídeo con habla natural",
        TalkingMeta:
          "El vídeo y el habla se generan juntos; la voz se convierte a la voz que elijas",
      },
      Step: {
        Title: "Texto y voz",
        Sub: "Lo que dice el avatar y la voz con la que habla",
        Locked: "Primero elige o crea un avatar",
      },
      Text: {
        Label: "Texto de narración",
        Placeholder: "Escribe lo que debe decir el avatar…",
        Meter: "~{{est}} s / {{max}} s · {{words}} palabras · ~{{segments}} segmentos",
        MeterEmpty: "Hasta {{max}} s de habla",
        SummaryBase: "~{{seconds}} s · {{words}} palabras · {{segments}} segmentos",
        SummaryBaseSingle: "~{{seconds}} s · {{words}} palabras",
        SummaryCredit: "~{{credits}} créditos",
        WarnMax: "Te acercas al límite del modelo (máx. {{max}} s).",
        OverMax: "El texto es demasiado largo para este modelo (máx. {{max}} s); acórtalo.",
        Warn: "Te estás acercando al límite del modelo.",
        Over: "El texto es demasiado largo para este modelo; acórtalo.",
        FetchScene: "Obtener texto de la escena",
        NoSceneText: "No se encontró texto de narración en esta escena.",
      },
      Voice: {
        Title: "Voz",
        ProviderFilter: "Proveedor",
        GenderFilter: "Género",
        ChangeVoice: "Cambiar voz",
        Count: "{{shown}} / {{total}} voces",
        Hint: "El habla del vídeo se convierte a la voz seleccionada.",
        HintAudioDriven: "La narración se locuta con esta voz; el avatar habla siguiéndola.",
        ProviderElevenLabs: "ElevenLabs",
        ProviderAzure: "Azure",
        ProviderUnconfigured: "sin configurar",
        ProviderUnpriced: "sin precio definido",
        Neutral: "Neutra",
        GenderMismatchFemale:
          "La voz seleccionada es femenina y el avatar es masculino. El avatar hablará con esta voz.",
        GenderMismatchMale:
          "La voz seleccionada es masculina y el avatar es femenino. El avatar hablará con esta voz.",
        All: "Todas",
        Female: "Mujer",
        Male: "Hombre",
        Loading: "Cargando voces…",
        Empty: "No se encontraron voces.",
        LoadError: "No se pudieron cargar las voces.",
        Play: "Escuchar muestra",
        Stop: "Detener",
        Select: "Selecciona una voz",
        Change: "Cambiar",
        Close: "Cerrar",
      },
      Model: {
        Label: "Modelo",
        Loading: "Cargando modelos…",
        Unavailable: "Este modelo no está disponible ahora",
        Unpriced: "No hay precio definido para este modelo",
        AudioDrivenHint:
          "Primero se genera el audio con la voz que elijas y el avatar habla con él en una sola toma (hasta {{minutes}} min)",
        SeedanceNotAiAvatar:
          "Seedance solo funciona con avatares generados por IA. Elige Omni para este avatar.",
        SeedanceAvatarRejected: "Este personaje no se puede usar con este modelo. Elige Omni.",
        LoadError: "No se pudieron cargar los modelos.",
        Retry: "Reintentar",
      },
      Aspect: {
        Label: "Relación de aspecto",
        Wide: "Horizontal (16:9)",
        Tall: "Vertical (9:16)",
        Square: "Cuadrado (1:1)",
        Cropped: "se genera en 16:9 y se recorta a cuadrado",
      },
      Language: "Idioma hablado",
      Advanced: "Configuración avanzada",
      Credit: {
        Line: "~{{credits}} créditos · {{segments}} segmentos · ~{{seconds}} s",
        Loading: "Calculando créditos…",
        Insufficient: "Tu saldo parece insuficiente para este trabajo.",
        Error: "No se pudo estimar el crédito.",
      },
      Missing: {
        Title: "Para crear",
        Model: "elige un modelo disponible",
        Avatar: "elige un avatar",
        AvatarUploading: "espera a que termine la subida del avatar",
        AvatarUploadFailed: "la subida del avatar falló; súbelo de nuevo",
        Text: "escribe el texto de narración",
        TextOver: "acorta el texto",
        TextPart: "divide las frases largas",
        Voice: "elige una voz",
        Aspect: "elige una relación de aspecto compatible",
        ActiveJob: "espera a que termine el trabajo de esta escena",
      },
      Processing: {
        Title: "Generando el vídeo del avatar…",
        Note: "Puedes cerrar esta ventana; al terminar esperará aprobación en el panel de Actividad.",
        Background: "Continuar en segundo plano",
        Unknown:
          "No se ha podido leer el estado del trabajo desde hace un rato. También puedes seguirlo en el panel de Actividad.",
        Refresh: "Actualizar estado",
        Unreachable:
          "No se puede consultar el estado de este trabajo (no se encontró o no pertenece a esta cuenta). Puedes comprobarlo en el panel de Actividad.",
        Dismiss: "Ocultar / Volver a la configuración",
        DismissConfirm:
          "El trabajo sigue en segundo plano; cuando termine podrás añadirlo desde el panel de Actividad.",
        DismissConfirmYes: "Ocultar",
        DismissCancel: "Cancelar",
      },
      Job: {
        SeedancePortraitHint:
          "Preparando el personaje para Seedance; la primera vez puede tardar unos minutos.",
      },
      Result: {
        Title: "Video de avatar creado",
        Preview:
          "Vista previa: el vídeo se añade silenciado; la escena reproduce la voz convertida.",
        Target: "Sonido de narración",
        NewSound: "Añadir como sonido nuevo",
        Split: "dividido",
        ReplaceNote:
          "La narración seleccionada se sustituye por esta voz; el vídeo se añade silenciado.",
        AddNote: "La voz se añade como una narración nueva; el vídeo se añade silenciado.",
        SplitNote:
          "Esta narración está dividida en la línea de tiempo; todas sus partes se sustituyen por un solo sonido.",
        BgRemovalFailed: "No se pudo quitar el fondo; el vídeo se añade con su fondo.",
        CropFailed: "El recorte cuadrado falló; el vídeo se entrega en 16:9.",
        WebmSafari: "Es posible que el vídeo transparente (WebM) no se reproduzca en Safari.",
        Regenerate: "Regenerar",
        AddToScene: "Añadir a la escena",
        Adding: "Añadiendo…",
        AddFailed: "No se pudo añadir a la escena; inténtalo de nuevo.",
        Fetching: "Obteniendo el resultado…",
        FetchFailed:
          "Aún no se pudo obtener el resultado. Inténtalo de nuevo u ocúltalo y añádelo desde el panel de Actividad.",
        RetryFetch: "Volver a obtener el resultado",
      },
      History: {
        NoResult: "No se pudo obtener el resultado de este trabajo; no se añadió a la escena.",
      },
      Failed: {
        Title: "No se pudo crear el vídeo",
        CreditNote: "Los trabajos fallidos no se cobran.",
        Back: "Volver a la configuración",
        SwitchToVeo: "Cambiar a Omni",
        PickVoice: "Elegir otra voz",
        PickModel: "Elegir otro modelo",
      },
      Errors: {
        TEXT_TOO_LONG:
          "El texto es demasiado largo para este modelo (~{{est}} s / máx. {{max}} s). Acórtalo.",
        TEXT_PART_TOO_LONG:
          "Una parte del texto es demasiado larga para decirse en un solo segmento; divide las frases largas.",
        VOICE_NOT_ALLOWED:
          "Esta voz no se puede usar. Elige una de las voces de ElevenLabs, de tu organización o de Azure de la lista.",
        VOICE_PROVIDER_UNAVAILABLE:
          "Este proveedor de voz no está disponible ahora mismo; elige otra voz.",
        AVATAR_REJECTED_SEEDANCE: "Este avatar no se puede usar con Seedance, elige Omni",
        AVATAR_REJECTED: "El modelo seleccionado rechazó este avatar; prueba con otro avatar.",
        CONTENT_FILTERED:
          "El texto o el avatar fue bloqueado por el filtro de contenido del proveedor.",
        VOICE_DRIFT:
          "La conversión de voz no coincidió con el vídeo; inténtalo de nuevo o elige otra voz.",
        PROVIDER_FAILED:
          "El proveedor de vídeo no pudo terminar el trabajo; inténtalo más tarde o con otro modelo.",
        PRICE_LIST_MISSING: "No hay precio definido para este modelo; elige otro modelo.",
        TOO_MANY_ACTIVE: "Se pueden generar como máximo 3 vídeos con habla natural a la vez.",
        MODEL_UNAVAILABLE: "Este modelo no está disponible ahora; elige otro modelo.",
        AVATAR_NOT_ALLOWED:
          "Este avatar no se puede usar; elige uno de la biblioteca o uno que hayas subido.",
        TEXT_EMPTY: "El texto de narración está vacío; escribe un texto.",
        RATIO_UNSUPPORTED: "El modelo seleccionado no admite esta relación de aspecto.",
        INVALID_REQUEST: "Los datos enviados no son válidos.",
        Generic: "No se pudo crear el vídeo; inténtalo de nuevo.",
      },
    },
    AvatarName: "Nombre del Avatar",
    AvatarNamePlaceholder: 'ej. "Kemal"',
    TitleRole: "Título / Rol",
    TitleRolePlaceholder: 'ej. "CEO" o "Entrenador"',
    SourceTypeAI: "Con IA",
    SourceAI: "Generar con IA",
    AvatarCreatingAi: "Generando…",
    AvatarAiMode: "Modo",
    AvatarAiModePrompt: "Indicación",
    AvatarAiModeProperties: "Personalizado",
    AvatarAiStyle: "Estilo",
    AvatarAiPose: "Pose",
    AvatarAiPoseSeated: "Sentado",
    AvatarAiPoseStanding: "De pie",
    AvatarAiStyleRealistic: "Realista",
    AvatarAiStyleCartoon: "Caricatura",
    AvatarAiStyleAnime: "Anime",
    AvatarAiStyleAnimation: "Animación",
    AvatarAiStyle3D: "Animación 3D",
    AvatarAiStyleIllustration: "Ilustración",
    AvatarAiPromptLabel: "Describe tu avatar",
    AvatarAiPromptPlaceholder:
      'ej. "Una mujer mediterránea de 30 años, cabello castaño ondulado hasta los hombros, ojos color avellana, sonrisa amistosa, chaqueta azul marino, fondo de estudio plano."',
    AvatarAiEthnicity: "Etnia / origen",
    AvatarAiEthnicityPlaceholder: 'ej. "Mediterráneo", "Asia Oriental"',
    AvatarAiFacialFeatures: "Rasgos faciales",
    AvatarAiFacialFeaturesPlaceholder: 'ej. "cara ovalada, ojos almendrados, nariz recta"',
    AvatarAiAgeRange: "Rango de edad",
    AvatarAiHairColor: "Color de cabello",
    AvatarAiHairStyle: "Estilo de cabello",
    AvatarAiEyeColor: "Color de ojos",
    AvatarAiSkinTone: "Tono de piel",
    AvatarAiFaceShape: "Forma del rostro",
    AvatarAiBodyType: "Tipo de cuerpo",
    AvatarAiExpression: "Expresión",
    AvatarAiClothing: "Estilo de vestimenta",
    AvatarAiAccessories: "Accesorios",
    AvatarAiAccessoriesPlaceholder: 'ej. "gafas, reloj"',
    AvatarAiOptionOther: "Otro",
    AvatarAiOptionOtherPlaceholder: "Escribe el tuyo…",
    AvatarAiAgeCustomPlaceholder: "p. ej. 30 (mín 25)",
    AvatarAiBackground: "Fondo / entorno",
    AvatarAiEnvironment: "Lugar",
    AvatarAiProvider: "Proveedor IA",
    AvatarAiProviderGemini: "Gemini",
    AvatarAiProviderGeminiFast: "Gemini Fast",
    AvatarAiProviderGrok: "Grok",
    AvatarAiContentFilterError:
      "Contenido no permitido. Suaviza tu prompt o selecciones e inténtalo de nuevo.",
    AvatarAiProcessing: "Generando tu avatar IA…",
    AvatarAiStageQueued: "En cola…",
    AvatarAiStagePromptRefine: "Refinando el prompt…",
    AvatarAiStageGenerating: "Generando video (puede tardar unos minutos)…",
    AvatarAiStageFinalizing: "Finalizando…",
    AvatarAiPreviewTitle: "Vista previa del avatar generado",
    AvatarAiRefinedPrompt: "Prompt refinado",
    AvatarAiUseThis: "Usar este avatar",
    AvatarAiGenerateAnother: "Generar otro",
    AvatarAiCategory: "Categoría",
    AvatarAiCategoryEducational: "Educativo",
    AvatarAiCategoryProfessional: "Profesional",
    AvatarAiCategoryMarketing: "Marketing",
    AvatarAiCategoryTraining: "Capacitación",
    AvatarAiCategoryPresentation: "Presentación",
    AvatarAiAgeTeen: "Adolescente (13–19)",
    AvatarAiAgeYoungAdult: "Adulto joven (20–29)",
    AvatarAiAgeAdult: "Adulto (30–49)",
    AvatarAiAgeMiddleAged: "Mediana edad (50–65)",
    AvatarAiAgeSenior: "Mayor (65+)",
    AvatarAiHairColorBlack: "Negro",
    AvatarAiHairColorBrown: "Castaño",
    AvatarAiHairColorBlonde: "Rubio",
    AvatarAiHairColorRed: "Rojo / Pelirrojo",
    AvatarAiHairColorGray: "Gris",
    AvatarAiHairColorWhite: "Blanco",
    AvatarAiHairColorOther: "Otro / Teñido",
    AvatarAiHairStyleShort: "Corto",
    AvatarAiHairStyleMedium: "Mediano",
    AvatarAiHairStyleLong: "Largo",
    AvatarAiHairStyleCurly: "Rizado",
    AvatarAiHairStyleWavy: "Ondulado",
    AvatarAiHairStyleStraight: "Liso",
    AvatarAiHairStylePonytail: "Cola de caballo",
    AvatarAiHairStyleBald: "Calvo",
    AvatarAiEyeColorBrown: "Marrón",
    AvatarAiEyeColorBlue: "Azul",
    AvatarAiEyeColorGreen: "Verde",
    AvatarAiEyeColorHazel: "Avellana",
    AvatarAiEyeColorGray: "Gris",
    AvatarAiEyeColorAmber: "Ámbar",
    AvatarAiSkinFair: "Muy claro",
    AvatarAiSkinLight: "Claro",
    AvatarAiSkinMedium: "Medio",
    AvatarAiSkinOlive: "Oliva",
    AvatarAiSkinTan: "Bronceado",
    AvatarAiSkinDark: "Oscuro",
    AvatarAiSkinDeep: "Muy oscuro",
    AvatarAiFaceOval: "Ovalada",
    AvatarAiFaceRound: "Redonda",
    AvatarAiFaceSquare: "Cuadrada",
    AvatarAiFaceHeart: "Corazón",
    AvatarAiFaceOblong: "Alargada",
    AvatarAiFaceDiamond: "Diamante",
    AvatarAiBodySlim: "Delgado",
    AvatarAiBodyAthletic: "Atlético",
    AvatarAiBodyAverage: "Promedio",
    AvatarAiBodyCurvy: "Con curvas",
    AvatarAiBodyHeavy: "Robusto",
    AvatarAiExpressionSmile: "Sonrisa",
    AvatarAiExpressionNeutral: "Neutral",
    AvatarAiExpressionSerious: "Serio",
    AvatarAiExpressionFriendly: "Amistoso",
    AvatarAiExpressionProfessional: "Profesional",
    AvatarAiClothingBusinessSuit: "Negocios",
    AvatarAiClothingBusinessCasual: "Negocios casual",
    AvatarAiClothingSmartCasual: "Casual elegante",
    AvatarAiClothingCasual: "Casual",
    AvatarAiClothingMedical: "Médico",
    AvatarAiClothingSafetyIndustrial: "Seguridad / industrial",
    AvatarAiClothingAcademic: "Académico",
    AvatarAiClothingFormal: "Formal",
    AvatarAiClothingTraditional: "Tradicional",
    AvatarAiClothingAthletic: "Deportivo",
    AvatarAiAccessoryGlasses: "Gafas",
    AvatarAiAccessoryWatch: "Reloj",
    AvatarAiAccessoryEarrings: "Pendientes",
    AvatarAiAccessoryTie: "Corbata",
    AvatarAiAccessoryHeadscarf: "Pañuelo",
    AvatarAiAccessoriesMeta: "opcional · elige los que quieras",
    AvatarAiOptionalMeta: "opcional",
    BuildYourAvatar: "Crea tu avatar",
    AvatarSuggestFaceShape: "forma del rostro",
    AvatarSuggestMood: "estado de ánimo",
    AvatarSuggestLighting: "iluminación",
    AvatarAiBackgroundPlain: "Liso / neutro",
    AvatarAiBackgroundStudio: "Estudio",
    AvatarAiBackgroundOffice: "Oficina",
    AvatarAiBackgroundOutdoor: "Exterior",
    AvatarAiBackgroundClassroom: "Aula",
    AvatarAiBackgroundGradient: "Gradiente suave",
    AvatarAiEnvModernStudio: "Estudio moderno minimalista",
    AvatarAiEnvCorporateOffice: "Oficina corporativa",
    AvatarAiEnvHomeOffice: "Oficina en casa",
    AvatarAiEnvClassroom: "Aula",
    AvatarAiEnvLibrary: "Biblioteca",
    AvatarAiEnvWarehouse: "Almacén",
    AvatarAiEnvLab: "Laboratorio",
    AvatarAiEnvCafe: "Cafetería",
    AvatarAiEnvOutdoorUrban: "Exterior — urbano",
    AvatarAiEnvOutdoorNature: "Exterior — naturaleza",
    AvatarAiAdditionalDetails: "Detalles adicionales",
    AvatarAiAdditionalDetailsPlaceholder:
      "Cualquier otra cosa que valga la pena describir (ánimo, iluminación, accesorios, vibra)…",
    HarryBusiness: "Harry - Negocios",
    MaleGestures: "Masculino - Gestos",
    NarrationText: "Texto de Narración",
    FetchSceneText: "Obtener texto de la escena",
    NoNarrationTextFoundInScene: "No se encontró texto de narración en esta escena.",
    Back: "Atrás",
    LanguageNames: {
      Turkish: "Turco",
      English: "Inglés (EE. UU.)",
      EnglishUK: "Inglés (Reino Unido)",
      Spanish: "Español",
      French: "Francés",
      German: "Alemán",
      Chinese: "Chino",
      Azerbaijani: "Azerbaiyano",
      Arabic: "Árabe",
      Russian: "Ruso",
      Japanese: "Japonés",
      Portuguese: "Portugués (BR)",
      Italian: "Italiano",
      Dutch: "Neerlandés",
      Polish: "Polaco",
      Korean: "Coreano",
      Hindi: "Hindi",
      Multilingual: "Multilingüe",
    },
    InvalidVideoFormat: "Sube un archivo de video válido (mp4, webm, mov, etc.)",
    FailedToUploadVideo: "No se pudo subir el video",
    FailedToUploadVideoRetry: "No se pudo subir el video. Inténtalo de nuevo.",
    FailedToFetchVoices: "No se pudieron obtener las voces de TTS",
    FailedToLoadVoicesRetry: "No se pudieron cargar las voces. Inténtalo de nuevo.",
    CameraAccessDenied: "Acceso a la cámara denegado.",
    FailedToUploadPhoto: "No se pudo subir la foto",
    FailedToUploadPhotoRetry: "No se pudo subir la foto. Inténtalo de nuevo.",
    AvatarCreatedSuccess: "Avatar creado correctamente.",
    AvatarCreationFailed: "No se pudo crear el avatar.",
    AvatarNameRequired: "Introduce un nombre para el avatar.",
    PleaseUploadVideo: "Primero sube un video.",
    PleaseUploadPhoto: "Primero sube una foto.",
    PleaseSelectSceneAudio: "Selecciona el audio de la escena.",
    VoiceProfileNotFound:
      "No se encontró el perfil de voz. Configura la voz en los ajustes de la formación.",
    AvatarVideoCreated: "Video de avatar creado",
    SourceTypeVideo: "Video",
    SourceTypePhoto: "Foto",
    UploadVideo: "Subir video",
    VideoFormats: "MP4, MOV · 10s–60s",
    StopCamera: "Detener cámara",
    RecordVideo: "Grabar video",
    UseYourWebcam: "Usa tu cámara web",
    SourcePhoto: "Foto de origen",
    AnimateProvider: "Proveedor de animación",
    AnimateProviderHint: "El proveedor seleccionado se usará para animar la foto.",
    UploadPhoto: "Subir foto",
    PhotoFormats: "JPG, PNG · Mín. 512px",
    TakePhoto: "Tomar foto",
    UseYourCamera: "Usa tu cámara",
    CapturePhoto: "Capturar foto",
    AvatarCreatingPhoto: "Animando…",
    AvatarCreatingVideo: "Creando…",
    SaveAndUseAvatar: "Crear y usar avatar",
    AvatarCreationHint:
      "El rostro debe verse con claridad y buena iluminación. Los avatares guardados se pueden reutilizar en todos los proyectos.",
    NoAudioFoundInScene: "No se encontró audio en esta escena.",
    InfographicEngine: {
      label: "Aidea Engine",
      subtitle: "(selección del motor de comportamiento visual)",
      engine1_label: "Aidea Engine 1",
      engine1_description: "Genera imágenes infográficas en un estilo estándar y coherente.",
      engine2_label: "Aidea Engine 2",
      engine2_description:
        "Genera infografías visualmente ricas con estilos variados y dinámicos entre diapositivas; crea más imágenes por escena.",
      engine3_label: "Aidea Engine 3",
      engine3_description:
        "Produce un estilo limpio y claro con un mínimo de texto en las imágenes, transmitiendo el contenido principalmente mediante imágenes.",
      engine5_label: "Aidea Engine 5",
      engine5_description:
        "Produce un estilo limpio y enfocado con elementos más grandes, escasos y bien espaciados — como máximo 6 objetos por imagen — y etiquetas mínimas y contundentes.",
      engine6_label: "Aidea Engine 6 (Texto editable)",
      engine6_description:
        "Cada título y línea de la imagen se convierte en su propio cuadro de texto editable con su icono, que aparece animado cuando la narración lo menciona.",
      engine7_label: "Aidea Engine 7 (Personajes)",
      engine7_description:
        "Usa el reparto fijo del curso: las nuevas imágenes muestran los mismos personajes con la misma cara, pelo y vestuario.",
      engine8_label: "Aidea Engine 8 (Personajes, sin texto)",
      engine8_description:
        "Usa el mismo reparto que el Engine 7, con casi ningún texto visible en las imágenes.",
      engine9_label: "Aidea Engine 9 (Texto denso)",
      engine9_description:
        "Permite leer en pantalla lo que se escucha: un titular y sus elementos con las palabras de la narración, colocados en la imagen donde corresponden: junto a su parte, en el nodo de su paso, en su lugar del mapa.",
      provider_locked:
        "El proveedor es fijo en la narración con personajes, porque las imágenes se generan a partir de las hojas de referencia de los personajes.",
    },
    DefaultNarrationText:
      "Bienvenido al entrenamiento Ada Lovelace Test 01. En este módulo examinaremos los fundamentos psicológicos del comportamiento del usuario.",
    UseTextFromAIVoice: "Usar texto de Voz AI",
    EnterTextToBeSpokenByAvatar: "Ingrese el texto que será hablado por el avatar...",
    TransparentBackground: "Fondo Transparente",
    RemoveAvatarBackground: "Quitar fondo de avatar",
    Time: "00:00 / 00:00",
    Use: "Usar",
    Grid: "Cuadrícula",
    YouDontHaveAnyRecordedScenes: "No tienes ninguna escena guardada.",
    WriteYourSceneName: "Escribe el nombre de tu escena.",
    YouCanSeeTheScenesYouHaveRecorded:
      "Puede ver las escenas que ha grabado en 'Escenas guardadas' en la esquina inferior izquierda de la pantalla.",
    YouMustEnterASceneName: "Debes ingresar un nombre de escena.",
    CheckTheSubscriptionInformation: "Consulta la información de suscripción.",
    TypeTheTextYouWantToVoiceover: "Escribe el texto que deseas poner en off",
    Create: "Crear",
    YouMustEnterAVoiceoverText: "¡Debes ingresar un texto de voz en off!",
    DefineTheImageYouWantToCreate: "Define la imagen que quieres crear",
    YouMustEnterAPromptText: "¡Debes ingresar un texto rápido!",
    YouCanProceedUsingTheFollowingOptionsToCreateImagesWithAI:
      "Puede proceder utilizando las siguientes opciones para crear imágenes con AI.",
    TheImageYouCreatedHasBeenAddedToMyFiles: "La imagen que creó se ha agregado a 'Mis archivos'",
    YouCanAccessTheImagesYouHavePreviouslyCreatedHereOrDeleteTheImagesYouDoNotUse:
      "Puedes acceder aquí a las imágenes que hayas creado previamente o eliminar las imágenes que no utilices.",
    ToMakeVoiceoveWithAIYouCanproceedUsingTheFollowingOptions:
      "Para realizar una locución con AI, puedes proceder usando las siguientes opciones",
    AiPromptText: "Texto rápido",
    AiService: "Servicio",
    AiLanguage: "Idioma",
    Language: {
      Turkish: "Turco",
      English: "Inglés (EE.UU.)",
      EnglishUK: "Inglés (Reino Unido)",
      Spanish: "Español",
      French: "Francés",
      German: "Alemán",
      Chinese: "Chino",
      Azerbaijani: "Azerbaiyano",
      Arabic: "Árabe",
      Russian: "Ruso",
      Japanese: "Japonés",
      Portuguese: "Portugués (BR)",
      Multilingual: "Multilingüe",
    },
    SourceVideo: "Vídeo de origen",
    AiSound: "Sonido",
    AiText: "Texto",
    AiDimension: "Dimensión",
    AiQuality: "Calidad",
    AiStyle: "Estilo",
    ImprovePrompt: "Mejore la rapidez con Inteligencia Artificial",
    Lipsyncing: "Lipsync",
    BackgroundRemoval: "Eliminación de fondo",
    AdvancedSettings: "Configuraciones Avanzadas",
    GeminiGuideTitle: "Guía del Director de Voz de Gemini TTS",
    GeminiGuideColType: "Tipo de Característica",
    GeminiGuideColCommand: "Comando (Etiqueta)",
    GeminiGuideColEffect: "¿Qué hace?",
    GeminiGuideColExample: "Ejemplo de Uso",
    GeminiGuideExampleText: "Texto de Ejemplo:",
    GeminiDirective: {
      Emotion: { type: "Emoción", effect: "Hace la voz enérgica y alegre." },
      Style: { type: "Estilo", effect: "Convierte la voz en un susurro misterioso." },
      Time: { type: "Tiempo", effect: "Añade una pausa natural durante el tiempo indicado." },
      Speed: { type: "Velocidad", effect: "Acelera el habla (para alertas importantes, etc.)." },
      Pitch: { type: "Tono", effect: "Baja la voz haciéndola más autoritaria." },
      Scene: { type: "Escena", effect: "Proporciona un entorno de estudio sin eco." },
    },
    youtube: "Youtube",
    youtube_search_button: "Buscar",
    youtube_search_placeholder: "Buscar en Youtube...",
    add_to_scene: "Añadir a Escena",
    save: "Guardar",
    save_as: "Guardar Como",
    import: "Importar",
    export: "Exportar",
    export_to_lms: "Exportar a LMS",
    language: "Idioma",
    sign_out: "Cerrar Sesión",
    preview: "Vista Previa",
    ai_studio: "AI Studio",
    ai_studio_tooltip: "Abrir AI Studio",
    elements: "Elementos",
    smart_elements: "Elementos Inteligentes",
    basic_elements: "Elementos",
    click_menu: "Menú de Clic",
    sounds_panel: "Sonidos",
    shapes_panel: "Formas",
    ShapeSettings: {
      tab_fill: "Relleno",
      tab_stroke_color: "Color de línea",
      tab_stroke_style: "Estilo de línea",
      tab_radius: "Redondeo de esquinas",
      tab_shadow: "Sombra",
      tab_text: "Cuadro de texto",
      fill_none: "Sin relleno",
      fill_solid: "Color sólido",
      fill_gradient: "Degradado",
      main_color: "Color principal",
      second_color: "Segundo color",
      angle: "Ángulo",
      color: "Color",
      width: "Grosor",
      dash: "Tipo",
      dash_solid: "Continua",
      dash_dashed: "Discontinua",
      dash_dotted: "Punteada",
      start_cap: "Extremo inicial",
      end_cap: "Extremo final",
      cap_none: "Ninguno",
      cap_arrow: "Flecha",
      cap_circle: "Círculo",
      line_cap: "Terminación",
      line_cap_butt: "Plana",
      line_cap_round: "Redonda",
      radius: "Radio",
      radius_full: "Completo",
      shadow_soft: "Suave",
      shadow_medium: "Media",
      shadow_strong: "Marcada",
      blur: "Desenfoque",
      text_placeholder: "Escribe texto dentro de la forma…",
      font: "Fuente",
      font_default: "Predeterminada",
      size: "Tamaño",
      bold: "Negrita",
      italic: "Cursiva",
      padding: "Relleno interior",
      shadow_none: "Ninguna",
      align: "Alineación",
      align_left: "Izquierda",
      align_center: "Centro",
      align_right: "Derecha",
      valign: "Alineación vertical",
      valign_top: "Arriba",
      valign_middle: "Medio",
      valign_bottom: "Abajo",
    },
    ShapesPanel: {
      count: "{{count}} formas",
      empty: "Ninguna forma coincide con la búsqueda",
      back: "Atrás",
    },
    sounds_all: "Todos",
    sounds_sfx: "Efectos de sonido",
    sounds_music: "Música",
    sounds_jingles: "Jingles",
    sounds_back: "Atrás",
    sounds_dur_short: "Corto",
    sounds_dur_medium: "Medio",
    sounds_dur_long: "Largo",
    sound_add_cue: "Añadir como sonido de clic",
    sound_add_scene: "Añadir como sonido de escena",
    sounds_my_effects: "Mis efectos",
    sound_fx_new: "Crear efecto",
    sound_fx_prompt_ph:
      "Descripción del efecto (p. ej. puerta de madera pesada cerrándose en una sala de piedra vacía)",
    sound_fx_enrich: "Enriquecer con IA",
    sound_fx_system_ph: "System prompt (vacío = guía de diseño de sonido predeterminada)",
    sound_fx_duration: "Duración (s)",
    sound_fx_influence: "Influencia del prompt",
    sound_fx_low: "Bajo",
    sound_fx_mid: "Medio",
    sound_fx_high: "Alto",
    sound_fx_count: "Cantidad",
    sound_fx_loop: "Bucle",
    sound_fx_generate: "Generar efecto",
    sound_fx_generating: "Generando…",
    sound_fx_error: "No se pudo generar el efecto",
    sound_fx_empty: "Aún no hay efectos",
    sound_fx_empty_hint: "Crea tu primer efecto arriba",
    auto: "auto",
    other: "Otros",
    SmartElements_Groups_Text: "Texto",
    SmartElements_Groups_Lists: "Listas",
    SmartElements_Groups_Layout: "Diseño",
    SmartElements_Groups_DataMedia: "Datos y Medios",
    SmartElements_Groups_UI: "Interfaz",
    SmartElements_Types_heading: "Encabezado",
    SmartElements_Types_eyebrow: "Antetítulo",
    SmartElements_Types_footer: "Pie de página",
    SmartElements_Types_quote: "Cita",
    SmartElements_Types_bullet_list: "Lista con viñetas",
    SmartElements_Types_card_grid: "Cuadrícula de tarjetas",
    SmartElements_Types_timeline: "Línea de tiempo",
    SmartElements_Types_stat_group: "Estadísticas",
    SmartElements_Types_hero: "Destacado",
    SmartElements_Types_section: "Sección",
    SmartElements_Types_two_column: "Dos columnas",
    SmartElements_Types_comparison: "Comparación",
    SmartElements_Types_chart: "Gráfico",
    SmartElements_Types_image: "Imagen",
    SmartElements_Types_divider: "Divisor",
    SmartElements_Types_badge: "Insignia",
    SmartElements_Types_cta_button: "Botón CTA",
    SmartElements_Types_icon_block: "Bloque de icono",
    SmartElements_Types_flip: "Tarjeta giratoria",
    SmartElements_Types_dragBuild: "Arrastrar y emparejar",
    SmartElements_Types_reveal: "Panel desplegable",
    SE_sample_heading: "Encabezado",
    SE_sample_eyebrow: "Etiqueta superior",
    SE_sample_footer: "Nota de pie",
    SE_sample_bullet_title: "Puntos clave",
    SE_sample_bullet_point: "Punto {{n}}",
    SE_sample_card_title: "Tarjetas de funciones",
    SE_sample_card_item_title: "Tarjeta {{n}}",
    SE_sample_card_item_body: "Descripción {{n}}",
    SE_sample_timeline_title: "Cronología",
    SE_sample_timeline_step: "Paso {{n}}",
    SE_sample_timeline_step_body: "Descripción",
    SE_sample_stat_label: "Métrica {{n}}",
    SE_sample_quote_text: "Tu cita aquí.",
    SE_sample_quote_author: "Nombre del autor",
    SE_sample_hero_heading: "Título principal",
    SE_sample_hero_body: "Texto de subtítulo",
    SE_sample_2col_left_title: "Columna izquierda",
    SE_sample_2col_right_title: "Columna derecha",
    SE_sample_2col_body: "Contenido aquí",
    SE_sample_comp_option: "Opción {{letter}}",
    SE_sample_comp_feature: "Característica {{n}}",
    SE_sample_section_heading: "Título de sección",
    SE_sample_section_body: "Contenido de sección",
    SE_sample_badge: "Insignia",
    SE_sample_cta: "Comenzar",
    SE_sample_icon_title: "Función",
    SE_sample_icon_body: "Descripción",
    SE_sample_flip_front_title: "Pregunta",
    SE_sample_flip_front: "Haz clic en la tarjeta para ver la respuesta.",
    SE_sample_flip_back_title: "Respuesta",
    SE_sample_flip_back: "Escribe la explicación aquí.",
    SE_sample_drag_prompt: "Empareja cada elemento con su grupo.",
    SE_sample_drag_token: "Elemento {{n}}",
    SE_sample_drag_zone: "Grupo {{n}}",
    SE_sample_reveal_title: "Interacción de dosis",
    SE_sample_reveal_text: "Combinar estos dos fármacos aumenta el riesgo de...",
    PluginNames_BasicText: "Texto Enriquecido",
    PluginNames_RichText: "Texto Enriquecido",
    PluginNames_DataTable: "Tabla",
    PluginNames_GraficaD3: "Gráfico",
    PluginNames_EnrichedPlayer: "Reproductor Vídeo",
    PluginNames_HotspotImages: "Imagen",
    PluginNames_AudioCue: "Señal de audio",
    PluginNames_HtmlContent: "Contenido HTML",
    PluginNames_EnrichedAudio: "Reproductor Audio",
    PluginNames_EnrichedPDF: "Visor PDF",
    PluginNames_OneClick: "Clic",
    PluginNames_Characters: "Caracteres",
    PluginNames_ScormPackage: "Paquete SCORM",
    PluginNames_Shapes: "Formas",
    PluginNames_ShapeOverlay: "Forma Superpuesta",
    PluginNames_VectorShape: "Forma",
    PluginNames_VirtualTour: "Mapa Google",
    PluginNames_Visor3D: "Visor de objetos 3D",
    PluginNames_Webpage: "Web Incrustada",
    PluginNames_MultipleChoice: "Una Selección",
    PluginNames_MultipleAnswer: "Selección Múltiple",
    PluginNames_TrueFalse: "Verdadero/Falso",
    PluginNames_FillInBlank: "llenar en Blanco",
    PluginNames_FreeResponse: "Respuesta Libre",
    PluginNames_Matching: "Emparejamiento",
    PluginNames_Ordering: "Valoración",
    PluginNames_Rating: "Valoración",
    PluginNames_DragDrop: "Arrastrar y Soltar",
    PluginNames_InputText: "Introducir valor",
    PluginNames_AtomicBoxPlugin: "Elemento de Contenido IA",
    PluginNames_GuideMultiInput: "Multi-Entrada de Formación",
    PluginNames_GuideTagDisplay: "Mostrar Etiqueta de Formación",
    ai: "IA",
    ai_images: "Imagen",
    ai_sounds: "Sonido",
    ai_avatars: "Avatar",
    text: "Texto",
    data: "Datos",
    basic: "Básico",
    multimedia: "Multimedia",
    objects: "Objetos",
    assessments: "Evaluaciones",
    components: "Componentes",
    library: "Biblioteca",
    upload_files: "Subir Archivos",
    my_files: "Mis Archivos",
    org_files: "Arch. Org.",
    brand_files: "Marca",
    BrandPanel: {
      font_pick: "Elige una fuente de Google…",
      font_adding: "Añadiendo…",
      kind_logo: "Logotipos",
      kind_photo: "Fotos",
      kind_graphic: "Gráficos",
      kind_icon: "Iconos",
      kind_chart: "Diagramas",
      kind_font: "Fuentes",
      uploading: "Subiendo",
      no_results: "Sin resultados",
      empty_kind: "Aún no hay",
      primary: "Principal",
      make_primary: "Usar como logo principal",
      back: "Atrás",
      no_brands: "Aún no hay marcas",
      no_brands_hint: "Las marcas se crean en la página Plantillas de marca de la consola.",
      font_not_placeable: "Las fuentes aún no se pueden añadir a la escena",
      apply_position_all: "Actualizar posición en todas las escenas",
      rightclick_hint:
        "Haz clic para añadirlo a esta escena. Clic derecho en el lienzo → “Actualizar posición en todas las escenas” para usar el mismo lugar en todas.",
      new_category: "Nueva categoría",
      category_name_placeholder: "Nombre de la categoría",
      rename: "Cambiar nombre",
      delete_category: "Eliminar categoría",
      delete_category_confirm: "y sus {{count}} archivos se eliminarán.",
      colors: "Colores",
      colors_unit: "colores",
      colors_hint:
        "Haz clic en un color: se aplica al texto o forma seleccionados; si no hay nada seleccionado, al fondo de la escena.",
      colors_empty: "Aún no hay colores de marca",
      color_applied_text: "Aplicado al texto",
      color_applied_shape: "Aplicado a la forma",
      color_applied_background: "Aplicado al fondo de la escena",
      color_unsupported: "Este elemento no admite color",
      color_pick: "Elegir color",
      color_hex: "Código hex",
      color_primary: "Color primario",
      color_secondary: "Color secundario",
      color_accent: "Color de acento",
      color_apply: "Aplicar",
      color_invalid: "Introduce un color hex como #40cfde",
      delete_color_set: "Eliminar conjunto de colores",
      color_set_new: "Nuevo conjunto de colores",
      color_set_name: "Nombre del conjunto de colores",
      color_set_default: "Conjunto de colores {{n}}",
      color_sets_unit: "conjuntos de colores",
      color_clear: "Quitar color",
      color_empty: "Vacío",
    },
    BoxContextMenu: {
      apply_font_all_scenes: "Aplicar esta fuente a todas las escenas",
    },
    OrgFiles: "Arch. Org.",
    ClonedVoices: "Clonar voz",
    CourseVideo: "Vídeos del curso",
    Transcription: "Transcripción",
    AnimatedImage: "Imagen animada",
    TimelineAnimatedImage: "Imagen de vídeo",
    icons: "Iconos",
    animations: "Animaciones",
    characters: "Personajes",
    search: "Buscar",
    all: "Todos",
    image: "Imagen",
    audio: "Audio",
    video: "Video",
    csv: "CSV",
    pdf: "PDF",
    delete: "Eliminar",
    files: "archivos",
    loading: "Cargando...",
    no_files_found: "No Se Encontraron Archivos",
    load_more: "Cargar Más",
    no_trainings_found: "No se encontraron entrenamientos",
    unassigned_files: "Archivos Sin Asignar",
    show_list_view: "Vista de Lista",
    show_grouped_view: "Vista Agrupada",
    files_load_error: "Error al cargar archivos",
    listen: "Escuchar",
    download: "Descargar",
    file: "Archivo",
    cancel: "Cancelar",
    close: "Cerrar",
    more_filters: "Más filtros",
    collapse: "Contraer",
    try_other_search: "Prueba con otra búsqueda.",
    searching: "Buscando…",
    youtube_search: "Buscar en YouTube",
    youtube_search_hint: "Escribe y pulsa Enter.",
    library_ai: "IA",
    library_details: "Detalles",
    library_video_drafts: "Borradores de video",
    library_video_drafts_empty: "Aún no hay borradores de video",
    library_type: "Tipo",
    library_date: "Fecha",
    library_duration: "Duración",
    library_provider: "Modelo",
    library_prompt: "Prompt",
    library_copy_prompt: "Copiar prompt",
    library_director: "Video Director",
    library_logline: "Sinopsis",
    library_shot: "Plano",
    library_more: "Más",
    library_less: "Menos",
    library_open_in_director: "Abrir en Director",
    library_project_unavailable: "Proyecto no disponible",
    delete_file_title: "Eliminar archivo",
    delete_file_confirm_prefix: "¿Seguro que quieres eliminar ",
    delete_file_confirm_suffix: "? Esta acción no se puede deshacer.",
    animation_fade: "Desvanecer",
    animation_flip: "Voltear",
    animation_pinwheel: "Molinillo",
    animation_roll: "Rodar",
    animation_rotate: "Rotar",
    animation_stretch: "Estirar",
    animation_zoom: "Zoom",
    animation_pan: "Desplazamiento",
    lipsync_title: "Sincronización Labial",
    lipsync_select_narration: "Seleccionar Sonido de Narración",
    lipsync_choose_audio: "Elige una pista de audio de la escena para sincronizar con tu video",
    lipsync_select_audio_video_error:
      "Por favor selecciona un audio y asegúrate de que el video esté disponible",
    lipsync_success_message:
      "¡Sincronización labial completada exitosamente! El video ha sido actualizado con la nueva versión sincronizada.",
    lipsync_background_removal: "Eliminación de Fondo",
    lipsync_generating: "Generando...",
    lipsync_generate: "Generar",
    error: "Error",

    AudioPanel: {
      Audio: "Base de Conocimientos",
      SceneSounds: "Sonidos de Escena",
      DocumentSummary: "Resumen",
      DocumentTitles: "Títulos del Documento",
      Outline: "Esquema del Documento",
      Mindmap: "Mapa Mental",
      NarrationTexts: "Textos de Narración",
      Loading: "Cargando...",
      NoSummaryAvailable: "Resumen no disponible",
      NoOutlineAvailable: "Esquema del curso no disponible",
      NoNarrationTexts: "No hay textos de narración guardados para este entrenamiento.",
      ErrorLoadingData: "Error al cargar datos",
      ErrorPrefix: "Error",
      AllocatedScenes: "escenas",
      CourseInfo: "Información del Documento",
      Sections: "Secciones",
      CopyAll: "Copiar Todo",
      SlideNotes: "Notas de las diapositivas",
      Copied: "¡Copiado!",
    },

    Animation: {
      Animation: "Animación",
      position_add: "Añadir posición",
      FirstPositionX: "Primera Posición X",
      FirstPositionY: "Primera Posición Y",
      LastPositionX: "Última Posición X",
      LastPositionY: "Última Posición Y",
      Firstwidth: "Ancho Inicial",
      FirstHeight: "Altura Inicial",
      Lastwidth: "Ancho Final",
      LastHeight: "Altura Final",
      FirstOpacity: "Opacidad Inicial",
      LastOpacity: "Opacidad Final",
      FirstDuration: "Hora Inicial(sg)",
      LastDuration: "Hora de Finalización(sg)",
      add_animation: "Agregar Animación",
      add_animation_shortcuts: "Añadir animación",
      edit_animation: "Editar Animación",
      First_Position: "Primera Posición",
      Last_Position: "Ultima Posicion",
      PositionX: "Posición X",
      PositionY: "Posición Y",
      Opacity: "Opacidad",
      Width: "Ancho",
      Height: "Altura",
      Duration: "Duración (segundos)",
      animation_reset: "Restablecer Animación",
      PositionNumber: "Número de Posiciones",
      MiddlePositionX: "Posición Media X",
      MiddlePositionY: "Posición Media Y",
      Middlewidth: "Ancho Intermedia",
      MiddleHeight: "Altura Intermedia",
      MiddleOpacity: "Opacidad Intermedia",
      MiddleDuration: "Duración Intermedia(sg)",
      Middle_Position: "Posición Intermedia",
      ShowAnimation: "Propiedades de Animación",
    },
    "16/9": "Cambiar a 16:9",
    "4/3": "Cambiar a 4:3",
    Accept: "Aceptar",
    Animations: "Animaciones",
    Alignment: "Alineación",
    Advanced: "Avanzado",
    Aspect_ratio: "Relación de Aspecto",
    Auto: "Automática",
    AddStartAnimation: "Iniciar la Animación",
    AddEndAnimation: "Fin de la Animación",
    EditAnimation: "Editar Animación",
    AddMiddleAnimation: "Agregar Animación Intermedia",

    background: {
      background: "Fondo",
      background_color: "Cambiar Color",
      background_image: "Imagen de Fondo",
      background_zoom: "Zoom del Fondo ",
      reset_background: "Restablecer",
      background_input_url: "Imágen URL",
      cover: "Cubrir Página",
      repeat: "Repetir Imagen",
      centered: "Imagen Centrada",
      fit: "Adaptar imagen",
      background_opacity: "Opacidad de fondo",
    },
    Block: "Bloque",
    Question: "Pregunta",
    Answer: "Respuesta",
    Feedback: "Retroalimentación",
    TrueFeedback: "Retroalimentación Positiva",
    FalseFeedback: "Retroalimentación Negativa",
    Element: "Elemento",
    Option: "Opción",
    Breadcrumb: "Breadcrumb",
    Cancel: "Cancelar",
    save_as_modal: "Guardar Como",
    save_as_modal_aspect_ratio: "Relación de aspecto",
    save_as_modal_ratio_change_warning:
      "El mismo contenido se guardará con la relación de aspecto {{ratio}}. Cuando cambia la relación de aspecto, los elementos de la escena pueden no caber perfectamente.",
    TrainingName: "Nombre De La Formación",
    TrainingDescription: "Descripción",
    SoundLoading: "Cargando Audio...",
    SoundLoaded: "Audio Subió.",
    AudioName: "Nombre de Audio: ",
    EnterAudioName: "Ingrese nombre de audio",
    upload_sound_record: "Guardar Audio",
    Upload: "Subir",
    Cancel: "Cancelar",
    clipboard: {
      copy: "Copiar",
      cut: "Cortar",
      copyPaste: "Copia / Pegar",
      paste: "Pegar",
      duplicate: "Duplicar",
      to: "para",
      msg: "Estas acciones no se encuentran disponibles. Para acceder a ellas usa los atajos del teclado:",
      zoomIn: "Acercar",
      zoomOut: "Alejar",
      zoomReset: "Restablecer al 100%",
    },
    Container_: "Contenedor",
    col_dist: "Distribución de columnas",
    col_number: "Nº Columnas",
    configuration: "Configuración",
    confirm_changes: "Confirmar Cambios",
    contained_view: "Vista Contenida",
    oneclick_view: "Contenido de clic",
    CONTAINED_VIEWS: "VISTAS CONTENIDAS",
    contained_view_popover: "Esta vista enlaza desde:",
    contained_view_nowhere: "Ningún Sitio",
    content: "Contenido",
    COURSE: "DOCUMENTO",
    course: "Documento",
    course_title: "Título del Curso",
    "create new document": "Crear Nueva Página",
    "create new folder": "Crear Nueva Sección",
    "create new slide": "Crear nueva diapositiva",
    delete: "Eliminar",
    delete_contained_canvas: "Eliminar Vista Contenida.",
    delete_container: "Eliminar Bloque",
    delete_page: "Eliminar Página",
    delete_section: "Eliminar Sección",
    display: "Visualización",
    display_page: "Ocultar/Mostrar Diapositiva",
    dropbox_msg: "Haz click aquí para buscar en tus archivos de Dropbox",
    dropbox_msg_alt: "Selecciona Otro Fichero",
    document: "Documento",
    DuplicateNavItem: "Duplicar Vista",
    edit_text: "Editar Texto",
    fitToScreen: "Ajustar a pantalla",
    empty: {
      cv_empty: "Aún no has creado ninguna vista contenida.",
    },
    EmptyPresentation: "Este documento esta vacío",
    error: {
      exporting: "Ha ocurrido un error al realizar la operación",
      generic: "Ha ocurrido un error",
      importing: "Ha ocurrido un error al realizar la operación",
      reaching_server: "No se ha podido subir nada al servidor",
      searching: "Ha ocurrido un error al buscar",
      deleting: "Ha ocurrido un error al eliminar",
      mandatory: "¡Completa la etapa actual para avanzar a la siguiente!",
      mandatorytwo: "¡Para llegar a esta escena, debes completar las escenas anteriores!",
      mandatoryCompleted:
        "Cuando se cierra el requisito obligatorio, el tiempo de visualización predeterminado es de {{seconds}} segundos. Las escenas que se pasan antes de que transcurra este tiempo pueden no marcarse como vistas.",
      warning: "Precaución",
      networkError: "Error de red. Por favor, inténtalo de nuevo.",
      organizationIdNotFound:
        "No se encontró el ID de la organización en el token. Por favor, inicia sesión de nuevo.",
      failedToCloneVoice: "No se pudo clonar la voz.",
      failedToDeleteVoice: "No se pudo eliminar la voz.",
      failedToGenerateAudio: "No se pudo generar el audio.",
      serviceError: "Error del Servicio",
      systemError: "Error del Sistema",
      file_not_selected: "No se ha seleccionado ningún archivo",
    },
    Evaluation: "Evaluación",
    Exercises: "Ejercicios",
    TimeLine: "Cronología",
    Library: "Biblioteca",
    exitModal: {
      Body: "¿Desea realmente salir de Aideapro Studio?",
      cancel: "Cancelar",
      leave_without_changes: "Salir Sin cambios",
      save_and_exit: "Salvar y Salir",
      Title: "Salir de Aideapro Studio",
    },
    unsavedChangesGuard: {
      title: "Cambios sin guardar",
      body: "Tienes cambios sin guardar. ¿Qué quieres hacer antes de salir?",
      stay: "Quedarme",
      leaveWithoutSaving: "Salir sin guardar",
      saveAndLeave: "Guardar y salir",
      saving: "Guardando…",
      saveError: "No se pudieron guardar tus cambios. Inténtalo de nuevo.",
    },
    saveConflict: {
      title: "Esta formación se modificó en otro lugar",
      body: "Otra persona o proceso guardó una versión más reciente de esta formación después de que esta pestaña la cargara. Elige si quieres seguir trabajando con tu versión o cargar la otra.",
      currentUpdatedAt: "La otra versión se guardó el: {{when}}",
      cancel: "Cancelar",
      reload: "Descartar mis cambios y recargar",
      reloading: "Recargando…",
      overwrite: "Sobrescribir con mi versión",
      overwriting: "Guardando…",
    },
    Exporting: "Guardando...",
    FileDialog: "Fichero",
    FileInput: {
      Message: "Arrastra o selecciona un archivo",
      MessageMulti: "Arrastra y suelta archivos aquí",
      ClickHint: "o haz clic para buscar — puedes seleccionar varios archivos",
      Drag: "Arrastra",
      Drag_2: " un fichero ",
      Click: "o haz click",
      Click_2: " para buscar",
    },
    FileModal: {
      APIProviders: {
        MyFiles: "Biblioteca",
        Animations: "Animaciones",
        Shapes: "Formas",
        Characters: "Caracteres",
        AIAvatarsText: "Avatares IA",
        MyFilesTitle: "Ficheros subidos a este documento",
        UploadFiles: "Subir Fichero",
        UploadNewFile: "Subir Nuevo Recurso",
        UploadFilesTitle: "Importa un fichero desde tu equipo...",
        no_files: "No hay resultados con las condiciones especificadas",
        results: "Resultados",
        searching: "Buscando...",
        error: "No pudimos subir tu archivo",
        errorHint:
          "Vuelve a intentarlo. Si continúa, haz clic en el icono de información para enviar los detalles al equipo de Aidea.",
        errorDetailsTitle: "Ver detalles técnicos",
        errorReportTitle: "Detalles técnicos",
        errorReportIntro:
          "Lamentamos las molestias. Copia el texto de abajo y envíalo al equipo de Aidea para que podamos ayudarte.",
        copyReport: "Copiar detalles",
        copied: "¡Copiado!",
        uploaded: "Archivo subido a la biblioteca correctamente",
        addToScene: "Añadir a la escena",
        addAllToScene: "Añadir todo a la escena",
        addingToScene: "Añadiendo a la escena…",
        upload: "Subir Fichero",
        warning_allowed: "Este formato no está admitido para el contenido que estás editando",
        warning_forbidden: "Este formato no está admitido en esta versión de Aideapro Studio",
        warning_too_large: "El archivo no puede superar los {{max}}MB",
        clear: "Borrar",
        search: "Buscar",
        confirm_delete: "¿Estás seguro de que deseas eliminar este fichero?",
        confirm_delete_all: "¿Está seguro de que desea eliminar estos archivos?",
        delete_all: "Borrar Todo",
        library: "Biblioteca",
        AIAvatars: {
          Description:
            "Crea videos de avatares con inteligencia artificial - tecnología de texto a voz y sincronización labial",
          SelectAvatar: "Seleccionar Avatar",
          SelectAvatarForEditing: "Seleccionar Avatar para Editar",
          SelectedAvatar: "Avatar Seleccionado",
          PreviewVideo: "Vista Previa",
          EditExisting: "Editar Videos de Avatar Existentes",
          EditDescription:
            "En modo edición, puedes modificar videos de avatar generados previamente. Selecciona un video a continuación para editar sus parámetros y regenerar.",
          NoExistingVideos: "No hay videos existentes para editar",
          CreateSomeVideosFirst: "Crea algunos videos de avatar primero",
          ScriptText: "Texto del Guión",
          ScriptPlaceholder: "Introduce el texto que quieres que hable tu avatar...",
          ScriptHint: "Máximo 4096 caracteres. Usa <break time='500ms'/> para pausas.",
          VoiceService: "Servicio de Voz",
          Language: "Idioma",
          Voice: "Voz",
          Create: "Crear",
          CreateMode: "Modo Crear",
          EditMode: "Modo Editar",
          Processing: "Procesando...",
          Regenerate: "Regenerar",
          PleaseWait: "Por favor espera...",
          JobStatus: "Procesando video de avatar...",
          VideoGenerated: "El video de avatar generado se ha añadido a tus archivos.",
          AccessPrevious:
            "Puedes acceder a avatares generados previamente desde la sección 'Mis Archivos'.",
          ErrorNoText: "Debes introducir texto para el avatar",
          ErrorTextTooShort: "Tavus requiere al menos 45 caracteres de texto.",
          ErrorNoAvatar: "Debes seleccionar un avatar",
          LoadingAvatars: "Cargando avatares...",
          NoAvatarsAvailable: "No hay avatares disponibles",
          FailedToLoadAvatars: "Error al cargar avatares",
          ErrorLoadingAvatars: "Error cargando avatares",
          ProviderType: "Proveedor",
          Gender: "Género",
          AllGenders: "Todos los Géneros",
          Male: "Masculino",
          Female: "Femenino",
          ProviderTypes: {
            AI: "IA",
            Human: "Humano",
          },
          Avatars: "avatares",
          NoAvatarsMatch: "No hay avatares que coincidan con los filtros seleccionados",
          NoVoicesAvailable: "No hay voces disponibles",
          EnableTransparentBackground: "Habilitar fondo transparente",
          VideoNotSupported: "Su navegador no admite la reproducción de video.",
          NoPreviewVideo: "Sin video de vista previa",
          PlayVoiceSample: "Reproducir muestra de voz",
          Step1SelectAvatar: "Seleccionar Avatar",
          Step2Settings: "Configuración Avatar",
          Next: "Siguiente",
          Back: "Atrás",
          // Aidea específico
          SourceType: "Tipo de Fuente",
          SelectSourceType: "Seleccionar Tipo de Fuente",
          StockAvatar: "Avatar Predefinido",
          UploadVideo: "Clonar desde Video",
          ImageToVideo: "Clonar desde Imagen",
          ImageProvider: "Proveedor de Imagen",
          SelectProvider: "Seleccionar Proveedor",
          ClickToUploadVideo: "Haz clic para subir video",
          ChangeVideo: "Cambiar Video",
          SupportedFormats: "Soportado: MP4, MOV, AVI",
          UploadingVideo: "Subiendo video...",
          ClickToUploadImage: "Haz clic para subir imagen",
          ChangeImage: "Cambiar Imagen",
          SupportedImageFormats: "Soportado: JPG, PNG",
          UploadingImage: "Subiendo imagen...",
          AudioSource: "Fuente de Audio",
          SelectAudioSource: "Seleccionar Fuente de Audio",
          UploadAudio: "Subir Audio",
          TextToSpeech: "Texto a Voz",
          ClickToUploadAudio: "Haz clic para subir archivo de audio",
          ChangeAudio: "Cambiar",
          UploadingAudio: "Subiendo audio...",
          SelectedSource: "Fuente Seleccionada",
          UploadedVideo: "Video Subido",
          ErrorNoSourceType: "Por favor seleccione un tipo de fuente",
          ErrorNoVideo: "Por favor sube un video",
          ErrorNoProvider: "Por favor seleccione un proveedor",
          ErrorNoImage: "Por favor sube una imagen",
          ErrorNoAudioSource: "Por favor seleccione fuente de audio",
          ErrorNoAudio: "Por favor sube audio",
          // TTS específico
          TTSProvider: "Proveedor TTS",
          SelectTTSProvider: "Seleccionar Proveedor TTS",
          LoadingVoices: "Cargando voces...",
          VoiceGender: "Género de Voz",
          VoiceLanguage: "Idioma de Voz",
          AllLanguages: "Todos los Idiomas",
          SelectVoice: "Seleccionar Voz",
          TransparentBackground: "Fondo Transparente",
          ErrorNoTTSProvider: "Por favor seleccione proveedor TTS",
          ErrorNoVoice: "Por favor seleccione una voz",
          SelectedAudio: "Audio seleccionado:",
          SceneAudio: "Audio de la escena",
          Preview: "Vista previa:",
          NoAudioFoundInScene: "No se encontró audio en esta escena.",
          CreateFromText: "Crear a partir de texto",
          CreateFromSceneAudio: "Crear a partir del audio de la escena",
          AvatarVideoCreated: "Vídeo de avatar creado",
          AddToScene: "Añadir a la escena",
          Provider: "Proveedor",
          SourceVideo: "Vídeo de origen",
          Uploading: "Subiendo...",
          VideoFormats: "MP4, MOV · 10 s–60 s",
          RecordVideo: "Grabar vídeo",
          UseYourWebcam: "Usa tu cámara web",
          SaveAndUseAvatar: "Crear y usar avatar",
          AvatarCreationHint:
            "La cara debe verse con claridad y con buena iluminación. Los avatares guardados se pueden reutilizar en todos los proyectos.",
          PleaseSelectSceneAudio: "Selecciona el audio de la escena.",
          VoiceProfileNotFound:
            "No se encontró el perfil de voz. Configura la voz en los ajustes de la formación.",
          FailedToUploadVideo: "No se pudo subir el vídeo",
          FailedToUploadVideoRetry: "No se pudo subir el vídeo. Inténtalo de nuevo.",
          FailedToFetchVoices: "No se pudieron obtener las voces de TTS",
          FailedToLoadVoicesRetry: "No se pudieron cargar las voces. Inténtalo de nuevo.",
          // Guías de Imagen a Video
          ImageGuidelinesTitle: "Guías de Ejemplo",
          ExamplePhoto: "Foto de Ejemplo",
          GuidelinesTitle: "Requisitos de Foto",
          Guideline1: "Rostro frontal y claro",
          Guideline2: "Fondo simple sin distracciones",
          Guideline3: "Bien iluminado",
          Guideline4: "Primer plano facial",
          Guideline5: "Ojos abiertos mirando a la cámara",
          Guideline6: "Expresión y pose natural",
          Guideline7: "Foto de alta resolución",
        },
        ImageStyles: {
          AnimateAndAdd: "Aidea Wizard",
          ImagesGenerating: "imágenes en generación",
          Title: "Biblioteca de Estilos de Imagen IA",
          Description:
            "Crea imágenes impresionantes con estilos prediseñados o tus propios prompts personalizados",
          StyleTemplates: "Plantillas de Estilo",
          CustomizePrompt: "Personalizar tu Prompt",
          PromptPlaceholder: "Selecciona un estilo arriba o introduce tu prompt personalizado...",
          PromptHint:
            "Describe la imagen que quieres crear en detalle para obtener mejores resultados.",
          AIProvider: "Proveedor de IA",
          AutoProvider: "Automático",
          CustomProvider: "Personalizado",
          Orientation: "Orientación",
          Quality: "Calidad",
          Square: "Cuadrado",
          Landscape: "Horizontal",
          Portrait: "Vertical",
          HDQuality: "Calidad HD",
          Standard: "Estándar",
          GenerateImage: "Generar Imagen",
          Generating: "Generando...",
          GeneratedImage: "Tu Imagen Generada",
          AddToCanvas: "Añadir al Lienzo",
          Regenerate: "Regenerar",
          LoadingStyles: "Cargando biblioteca de estilos...",
          NoStylesAvailable: "No hay estilos disponibles",
          FailedToLoadStyles: "Error al cargar biblioteca de estilos",
          ErrorLoadingStyles: "Error cargando estilos",
          PleaseEnterPrompt: "Por favor introduce un prompt.",
          PromptRequired: "Por favor introduce un prompt.",
          PromptRequiredTitle: "Prompt requerido",
          StyleRequiredTitle: "Estilo requerido",
          PleaseSelectStyle: "Por favor selecciona un estilo o añade una imagen de referencia.",
          CustomStyleRequiredTitle: "Descripción de estilo requerida",
          CustomStyleDescRequired:
            "Por favor introduce una descripción para el estilo personalizado.",
          NarrationRequiredTitle: "Narración requerida",
          PromptEnrichEmpty: "Por favor introduce un prompt para enriquecer",
          PromptEnrichFailed: "Error al enriquecer el prompt",
          FailedToGenerate: "Error al generar imagen",
          ContentPolicyViolation:
            "Violación de política de contenido: El proveedor de IA bloqueó esta solicitud. El prompt puede contener contenido restringido. Por favor modifica tu prompt e intenta de nuevo.",
          ImageAdded: "La imagen ha sido añadida a tu lienzo",
          StyleTemplate: "Plantilla de Estilo",
          NoDescription: "Sin descripción",
          MoreStyles: "Más estilos",
          ShowLess: "Mostrar menos",
          GeneratingImage: "Generando imagen...",
          AIGeneratedImage: "Imagen Generada por IA",
          StyleLabel: "Estilo",
          StyleTemplateFallback: "Estilo {{index}}",
          CustomCardLabel: "Personalizado",
          CustomStyleDescription: "Descripción de Estilo Personalizado",
          CustomStylePlaceholder:
            "Describe el estilo visual que deseas, ej. ilustración acuarela, cinematográfico oscuro, arte vectorial plano...",
          StyleSelectionDisabled:
            "La selección de estilo está deshabilitada cuando se usa una imagen de referencia.",
          LessStyles: "Menos Estilos",
          TextOverlayHeader: "Texto {{index}}",
          TextOverlayPlaceholder: "Ingrese el texto a mostrar...",
          TextOverlayLocationLabel: "Ubicación",
          TextOverlayLocationCustomOption: "Personalizado...",
          TextOverlayLocationCustomPlaceholder: "ej. tercio inferior centro",
          TextOverlayStyleLabel: "Estilo",
          TextOverlayCustomStylePlaceholder: "ej. rojo negrita con contorno",
          AddTextOverlay: "+ Agregar Texto",
          ReferenceImageLabel: "Imagen de Referencia",
          RemoveImage: "Eliminar",
          ReferenceImageNote:
            "La IA usará esta imagen como referencia de estilo · {{aspectRatio}} · {{provider}}",
          PromptBadgePrefix: "Usa",
          DescribeImage: "Describe la imagen que deseas generar para esta escena...",
          UsesBadge: "Usa",
          AdvancedSettings: "Configuración Avanzada",
          NegativePrompt: "Prompt Negativo",
          NegativePromptPlaceholder: "Qué excluir...",
          Resolution: "Resolución",
          NarrationTextRequired: "Se requiere texto de narración.",
          PromptGenerationFailed: "No se pudo generar el indicador a partir de la narración",
        },
        VideoGeneration: {
          AddedFromTray: "Añadido a la escena",
          AddAgain: "Añadir de nuevo",
          Director: {
            Tab: "Director de video",
            Loading: "Cargando…",
            Start: "Crear un video nuevo",
            Prefilling: "Leyendo tu escena…",
            Treating: "Escribiendo el tratamiento y generando las hojas de personajes y lugares…",
            Rendering: "Renderizando el video final…",
            RenderingTitle: "Renderizando tu video…",
            RenderNote:
              "Puedes cerrar esta ventana: el renderizado continúa. Búscalo después en Borradores.",
            ClipsReady: "{{ready}} de {{total}} clips listos",
            EstimateMin: "unos {{min}} min",
            GenerateNote:
              "Puedes cerrar esta ventana: la generación continúa. Búscala después en Borradores.",
            ClipsGenerating: "{{count}} clip generándose…",
            ClipsGenerating_plural: "{{count}} clips generándose…",
            ChipReady: "Listo",
            NextNeedsApproval: "Aprueba todos los fotogramas clave para continuar",
            StepCount: "Paso {{n}} de 5",
            Steps: {
              Brief: "Brief",
              Treatment: "Tratamiento",
              Storyboard: "Storyboard",
              Edit: "Generar y editar",
              Finish: "Finalizar",
            },
            Fields: {
              scenario: "Guion",
              voiceOver: "Locución (opcional)",
              learningGoal: "Objetivo de aprendizaje",
              audience: "Audiencia",
              narration: "Narración",
              language: "Idioma",
              targetSec: "Duración objetivo (segundos)",
              customStyle: "Estilo personalizado",
              cast: "Reparto",
              locations: "Lugares",
              criticalActions: "Acciones clave",
              brandPolicy: "Política de marca",
              logline: "Logline",
              look: "Estética",
              name: "Nombre",
              description: "Descripción",
              durationSec: "Duración (segundos)",
              camera: "Cámara",
              prompt: "Prompt de movimiento",
              keyframePrompt: "Prompt del fotograma clave",
            },
            StartFrom: "Empezar desde",
            StartScene: "Esta escena",
            StartPrompt: "Mi propia idea",
            Characters: "Personajes",
            CastAi: "Los crea la IA",
            CastPhotos: "Desde mis fotos",
            CastNone: "Sin personajes",
            ScenarioPlaceholder: "Describe todo tu vídeo: historia, escenas, qué ocurre…",
            WordsCount: "{{words}} palabras",
            LikenessConsent: "Tengo permiso para usar la imagen de las personas de estas fotos.",
            PhotoName: "Nombre",
            PhotoRole: "Papel en el vídeo",
            PhotoRemove: "Quitar foto",
            AddPhoto: "Añadir foto",
            PhotosRequired: "Añade al menos una foto y pon nombre a cada persona.",
            FromPhoto: "Desde foto",
            Words: "{{words}} / 300 palabras",
            Required: "Obligatorio",
            NarrationTooLong: "La narración supera las 300 palabras; acórtala para continuar.",
            Next: "Siguiente",
            Confirm: "Confirmar y dibujar fotogramas clave",
            Summary: "{{count}} plano · {{seconds}} s",
            Summary_plural: "{{count}} planos · {{seconds}} s",
            TargetRange: "10–120 s",
            Shot: "Plano {{n}}",
            RemoveShot: "Eliminar plano",
            Approve: "Aprobar",
            Approved: "Aprobado",
            ApproveAll: "Aprobar todo",
            Regenerate: "Regenerar",
            Take: "Toma {{n}}",
            InsertShotHere: "Insertar plano aquí",
            Generated: "Generado",
            Play: "Reproducir",
            Pause: "Pausa",
            Fit: "Ajustar la línea de tiempo a la vista",
            WhatNext: "¿Qué pasa después? (opcional)",
            WhatNextRequired: "¿Qué pasa después?",
            Generate: "Generar",
            MarkIn: "Marcar inicio del rango",
            RemoveRange: "Eliminar selección",
            CutAfter: "Cortar después del cabezal",
            RangeHint: "Rango: {{from}} → {{to}}",
            SplitHere: "Dividir aquí",
            Zoom_none: "Zoom: Ninguno",
            Zoom_in: "Zoom: Acercar lento",
            Zoom_out: "Zoom: Alejar lento",
            TransitionChip: "Transición",
            Transition_none: "Transición: Ninguna",
            Transition_crossfade: "Transición: Fundido cruzado",
            Transition_fade: "Transición: Fundido a negro",
            TransitionFallback:
              "No hay suficiente metraje extra para un fundido cruzado — se usará un fundido a negro",
            TransitionSkipped: "Clip demasiado corto para una transición — se omitirá",
            CutStart: "Cortar desde el inicio hasta el cabezal",
            DeleteClip: "Eliminar clip",
            Close: "Cerrar",
            EditShot: "Editar plano",
            PlaySound: "Reproducir con sonido",
            ClipSound: "Sonido del clip",
            Mute: "Silenciar",
            NoClipSound: "Estos clips no tienen sonido",
            NoNarration: "Esta escena no tiene audio de narración",
            ShotActions: "Acciones del plano",
            Inspector: "Panel del plano",
            BackToEdit: "Volver a editar",
            ReplaceVideo: "Reemplazar vídeo",
            OpenLibrary: "Abrir en la biblioteca",
            RenderAgain: "Renderizar de nuevo",
            RenderStale: "Puede que el corte haya cambiado desde este render — renderiza de nuevo",
            Clips: "{{count}} clip",
            Clips_plural: "{{count}} clips",
            FinishExplain:
              "El renderizado une {{count}} clips en un solo MP4 ({{duration}}, {{aspect}}, 720p, sin sonido). La narración de la escena queda aparte y se reproduce con él. Renderizar es gratis y tarda aproximadamente un minuto.",
            FinishWarnEmpty: "Nada que renderizar: el montaje no tiene clips.",
            FinishWarnPending: "{{count}} toma sigue generándose y no está en el montaje.",
            FinishWarnPending_plural:
              "{{count}} tomas siguen generándose y no están en el montaje.",
            FinishWarnFailed: "{{count}} toma fallida no está en el montaje.",
            FinishWarnFailed_plural: "{{count}} tomas fallidas no están en el montaje.",
            CutPreview: "Vista previa del montaje completo",
            StartFrame: "Fotograma inicial",
            EndFrame: "Fotograma final",
            EndAuto: "La IA decide",
            EndNext: "Primer fotograma del siguiente clip",
            EndPick: "Elegir un fotograma",
            PickTake: "Toma",
            PickFrame: "Fotograma",
            EndMarker: "→ fotograma final",
            Retry: "Reintentar",
            Render: "Renderizar",
            AddToScene: "Añadir a la escena",
            VideoName: "Video del director",
            Drafts: "Borradores",
            DraftsEmpty:
              "Aún no hay borradores. Empieza un video nuevo o edita uno existente en el Director.",
            Untitled: "Sin título",
            Imported: "Importado",
            PolicyAdjusted: "Ajustado por seguridad",
            PolicyOriginal: "Tu prompt",
            PolicySent: "Prompt enviado",
            UseSaferPrompt: "Usar prompt más seguro",
            OriginDirector: "Director",
            Rendered: "Renderizado",
            DraftStatus: {
              prefilling: "Preparando",
              brief: "Brief",
              treating: "Escribiendo tratamiento",
              treatment: "Tratamiento",
              storyboard: "Storyboard",
              editing: "Editando",
            },
            DraftSeconds: "{{n}} s",
            DraftShots: "{{count}} plano",
            DraftShots_plural: "{{count}} planos",
            ImportAudioWarning: "El sonido original no se conservará en el video editado.",
            EditInDirector: "Editar en el Director",
            Selection: "Selección",
            SelectionStart: "Inicio de la selección",
            SelectionEnd: "Fin de la selección",
            RefSetName: "Conjunto de referencias",
            RefSet: "Conjunto de referencias ({{n}}/{{max}})",
            RefSetEmpty:
              "Captura fotogramas del vídeo para reutilizarlos en prompts y generaciones.",
            AddCurrentFrame: "Añadir fotograma actual",
            AddToRefs: "Añadir al conjunto de referencias",
            Preview: "Vista previa",
            PreviewClose: "Cerrar vista previa",
            PreviewPrev: "Imagen anterior",
            PreviewNext: "Imagen siguiente",
            PreviewOf: "{{n}} de {{total}}",
            UseTake: "Usar esta toma",
            Upload: "Subir",
            UploadImage: "Elegir un archivo de imagen",
            RefMenu: "Acciones de la referencia",
            RefN: "Referencia {{n}}",
            UseAsEnd: "Usar como fotograma final",
            UseAsKeyframe: "Usar como fotograma clave del plano seleccionado",
            GenerateFinal: "Generar fotograma final…",
            UseFrameFinal: "Usar este fotograma para generar un fotograma final…",
            DeleteRef: "Eliminar",
            FinalTitle: "Generar un fotograma final",
            FinalPrompt: "Describe el fotograma final",
            ImagesUsed: "Imágenes que usa este plano",
            KeyframeImage: "Fotograma clave",
            RegenRefs: "Referencias para regenerar ({{n}}/{{max}})",
            RegenRefsEmpty: "Añade fotogramas al conjunto de referencias para usarlos aquí.",
            DeselectRef: "Quitar la selección de la referencia",
            DeleteFromRefs: "Eliminar del conjunto de referencias",
            ConfirmDeleteRef: "¿Eliminar esta referencia del conjunto? Se borra definitivamente.",
            ShotInProgress: "Toma en curso…",
            FrameAgent: {
              Direct: "Dirigir desde aquí…",
              Title: "Dirigir desde aquí",
              MarkCaption: "Opcional: marca el elemento",
              ClearMark: "Quitar marca",
              IntentPlaceholder:
                "¿Qué debería pasar a partir de aquí? Ej.: el personaje sale por la puerta",
              Plan: "Planificar",
              Planning: "Planificando…",
              Change: "Cambiar",
              S_continue: "Continuaré este clip desde aquí.",
              S_bridge_next:
                "Continuaré este clip desde aquí y aterrizaré en el primer fotograma del siguiente clip.",
              S_endframe_then_continue:
                "Primero crearé el fotograma objetivo y luego generaré el movimiento para llegar a él.",
              S_replace_range: "Reemplazaré la parte seleccionada.",
              CostVideo: "Vídeo",
              CostFrame: "Fotograma objetivo",
              CostTotal: "Total",
              CreateFrame: "Crear fotograma objetivo",
              StillFailed: "Falló el fotograma objetivo. Inténtalo de nuevo.",
              FramePrompt: "Prompt del fotograma",
              Update: "Actualizar",
              FrameAt: "Fotograma {{time}}",
              RangeFromStart:
                "Reemplazar no puede empezar en el primer fotograma: se continuará la selección en su lugar",
            },
            ShotFailed: "Falló la generación",
            FromRef: "De una referencia",
            RemoveRefKeyframe: "Quitar el fotograma clave de referencia",
            ConfirmRemoveRefKeyframe:
              "¿Quitar el fotograma clave de referencia? El plano vuelve a su fotograma clave anterior.",
            RefCancel: "Cancelar",
            RegenKeyframe: "Regenerar fotograma clave",
            InsertNeedsPlayhead:
              "No hay nada antes del primer fotograma, así que no se puede insertar un plano aquí. Añade un plano al principio.",
            StoryAssets: "Historia y recursos",
            StoryAssetsHelper:
              "Consulta la historia, el reparto, los escenarios y los fotogramas clave, y reutiliza cualquier imagen en un plano nuevo.",
            Tabs: {
              Story: "Historia",
              Cast: "Reparto",
              Locations: "Escenarios",
              Keyframes: "Fotogramas clave",
              Refs: "Conjunto de referencias",
            },
            Aspect: "Relación de aspecto",
            ShotList: "Lista de planos",
            NothingHere: "Aún no hay nada.",
            Cookbook: {
              Title: "De este curso",
              Badge: "Del curso",
              Exclude: "No usar en este vídeo",
              Use: "Usar en este vídeo",
              NotUsed: "No se usa en este vídeo",
              Rename: "Renombrar",
              Save: "Guardar",
              Cancel: "Cancelar",
              Remove: "Quitar del curso",
              ConfirmRemove:
                "¿Quitarlo del curso? Los vídeos existentes conservan su propia copia.",
              ConfirmYes: "Quitar",
              StyleMismatch:
                "Los personajes de este curso conservan su aspecto; el estilo elegido se aplica a los nuevos.",
              UseLabel: "Personajes y lugares del curso",
              UseAll: "Usar todos",
              UsePick: "Elegir",
              UseOff: "No usar",
              SaveNew: "Guardar nuevos personajes y lugares en el curso",
            },
            SrcLibrary: "Desde la biblioteca",
            LibrarySearch: "Buscar en tu biblioteca",
            LibraryLoadFailed: "No se pudo cargar tu biblioteca.",
            UseLibraryImage: "Usar imagen de la biblioteca",
            OpenInDirector: "Abrir en el Director de video",
            MakeVideoInDirector: "Crear video en el Director",
            VideoEditor: "Editor de video",
            EmptyTitle: "Empieza tu video",
            EmptyHint: "Elige cómo empezar, o añade un plano o trae tus propios medios.",
            NewVideo: "Nuevo vídeo",
            StartCinematic: "Vídeo cinematográfico a partir de la narración de la escena",
            StartOwnPrompt: "Crear con tu propio prompt",
            NeedsNarration: "Esta escena no tiene texto de narración",
            FlowSwitch: "Tipo de vídeo",
            FlowCinematic: "Cinematográfico",
            AnalysisCost: "0,5 cr",
            AnalysisCostTip: "Un nuevo análisis cuesta 0,5 créditos",
            Reused: "Se muestra tu vídeo anterior de esta escena: la narración no ha cambiado.",
            Ld: {
              StartLd: "Vídeo L&D a partir de la narración de la escena",
              FlowLd: "L&D",
              Objective: "¿Qué debe mostrar este vídeo?",
              ObjectivePlaceholder:
                "p. ej. La forma correcta de levantar una caja pesada y qué pasa si no se hace",
              UseCase: "Tipo de vídeo",
              Audience: "Público (opcional)",
              Length: "Duración: {{sec}} s",
              Look: "Estilo",
              LookBrand: "Marca por defecto",
              LookDefault: "{{style}} (por defecto para este tipo)",
              LookChange: "Cambiar",
              LookHide: "Ocultar",
              Estimate: "Aprox. {{low}}–{{high}} créditos",
              EstimateDetail: "{{shots}} planos, hasta {{stills}} imágenes",
              EstimateLoading: "Calculando…",
              DraftFirst: "Borrador primero",
              DraftHint: "Primero una vista previa barata; finaliza los planos que conserves.",
              Draft: "Borrador",
              FinalNotPlaced: "Final (sin colocar)",
              Finalize: "Finalizar",
              FinalizeShot: "Finalizar este plano",
              FinalizeStrip: "{{n}} planos en borrador",
              FinalizeModel: "Modelo final",
              FinalizeAll: "Finalizar {{n}} planos · {{price}}",
              UseCases: {
                safety: "Demostración de seguridad",
                safety_hint: "Forma incorrecta, consecuencia, forma correcta",
                process: "Recorrido de un proceso",
                process_hint: "Paso a paso, primeros planos de manos y herramientas",
                scenario: "Escenario",
                scenario_hint: "Una breve situación laboral",
                concept: "Explicación de un concepto",
                concept_hint: "Animado, sin personas",
                product: "Presentación de producto",
                product_hint: "Planos del producto y luego en uso",
              },
            },
            StartingPoint: "Punto de partida",
            EmptyAddShot: "Añadir plano",
            EmptyImportVideo: "Importar video de la biblioteca",
            EmptyImportHint:
              "Abre un proyecto nuevo con ese video; este proyecto vacío se queda en tus borradores.",
            EmptyAddImage: "Añadir imagen de la biblioteca",
            OriginBlank: "En blanco",
            InRefSet: "En el conjunto de referencias",
            UseKeyframeFor: "Usar como fotograma clave del plano {{n}}",
            NewShotWith: "Nuevo plano con esto",
            AddShot: "Añadir plano",
            AddShotHelper:
              "Crea un plano nuevo a partir de una descripción, personajes o un fotograma clave existente.",
            AddShotPrompt: "¿Qué ocurre en este plano?",
            AddShotAtStart: "Añadir plano al principio",
            EditVideoTitle: "Editar vídeo",
            AdvancedEditor: "Editor avanzado",
            PickCast: "Personajes (hasta {{max}})",
            PickLocation: "Escenario",
            KeyframeSource: "Fotograma inicial",
            KeyframeNew: "Generar desde la descripción",
            KeyframeExisting: "Del conjunto de referencias",
            KeyframeFree: "Reutilizar un fotograma clave es gratis.",
            StartNone: "Ninguno (texto a vídeo)",
            EndFrameOptional: "Fotograma final (opcional)",
            EndNone: "Ninguno",
            EndRefSet: "Imagen de referencia",
            EndNeedsStart: "Un fotograma final necesita un fotograma inicial",
            GenerateKeyframe: "Generar fotograma clave",
            AddShotNoGen: "Añadir sin generar",
            TextOnly: "Solo texto",
            Bridge: "Enlace",
            PickKeyframe: "Elige un fotograma clave",
            Placement: "¿Dónde va?",
            PlaceHere: "En el cabezal",
            PlaceStart: "Al principio",
            PlaceEnd: "Al final",
            AddStartFrame: "Añadir fotograma inicial",
            AddEndFrame: "Añadir fotograma final",
            StartEmptyHint: "Opcional — déjalo vacío para texto a vídeo",
            EndEmptyHint: "Opcional",
            EndEmptyHintAI: "Opcional — déjalo vacío y la IA decide",
            NoEndFrame: "Este modelo no admite último fotograma",
            NeedsStart: "Necesita un fotograma inicial",
            FrameChange: "Cambiar",
            FrameRemove: "Quitar",
            SrcRefSet: "Conjunto de referencias",
            SrcKeyframes: "Fotogramas clave",
            SrcUpload: "Subir imagen",
            KeyframeOf: "Fotograma clave · {{label}}",
            BridgeLabel: "Puente → siguiente clip",
            GeneratedLabel: "Generado desde la descripción",
            GeneratedPending: "La imagen se crea al añadir el plano",
            PlayheadFrame: "Fotograma del cabezal",
            GuideImages: "Imágenes guía ({{n}}/{{max}})",
            VideoRefs: "Imágenes de referencia ({{n}}/{{max}})",
            CastLocation: "Personajes y lugar",
            NoneSelected: "Ninguno seleccionado",
            PickerDone: "Hecho",
            ChooseSource: "Elige una fuente",
            FrameOf: "{{label}} · {{time}}",
            InsertTitle: "Insertar plano",
            InsertHelper: "Genera un clip nuevo que empieza en este fotograma y se coloca aquí.",
            FinalHelper:
              "Crea una imagen de referencia nueva a partir de este fotograma, por ejemplo cómo debe terminar un plano.",
            EditHelper:
              "Cambia el prompt de movimiento del plano o redibuja su fotograma clave a partir de referencias.",
            DiscardDraft: "Descartar borrador",
            NewShots: "Planos nuevos",
            NewShotsWaiting: "{{count}} plano nuevo en espera",
            NewShotsWaiting_plural: "{{count}} planos nuevos en espera",
            NewShot: "Nuevo",
            GenerateClip: "Generar clip",
            BridgeNext: "Enlazar con el clip siguiente",
            ShotDetails: "Detalles del plano",
            PrevFrame: "Fotograma anterior",
            NextFrame: "Fotograma siguiente",
            EndRef: "Del conjunto de referencias",
            EndUpload: "Subir una imagen",
            RefPending: "Esperando a que termine de procesarse la imagen…",
            PreparingImage: "Preparando la imagen…",
            WhatHappens: "Qué pasará:",
            EndHelp: {
              auto: "La IA continúa desde el fotograma inicial y decide cómo termina el plano.",
              next: "El nuevo plano termina en el primer fotograma del siguiente clip, para enlazar con el corte.",
              ref: "El nuevo plano termina en la imagen de referencia que elijas.",
              pick: "El nuevo plano termina en el fotograma que elijas de uno de tus clips.",
            },
            Models: {
              video: "Modelo de vídeo",
              image: "Modelo de imagen",
              "veo-fast": "Omni",
              veo: "Omni",
              grok: "Grok",
              seedance: "Seedance",
              ltx: "LTX",
              "gemini-nano": "Nano",
              "gemini-pro-nano": "Nano Pro",
              Price: "{{n}} créditos",
              PriceShort: "{{n}} cr",
              BriefRow: "Modelo de IA",
              Recommended: "Recomendado",
              HintEnd: "admite un último fotograma",
              HintRefs: "imágenes de referencia",
            },
            Credit: {
              Stills: "Imágenes de reparto y lugares (hasta)",
              Keyframes: "Fotogramas clave",
              Takes: "Tomas de video",
              Take: "Una toma de video",
            },
            Errors: {
              content_filtered:
                "El filtro de contenido bloqueó este plano. Edita el prompt e inténtalo de nuevo.",
              generic: "Algo salió mal. Inténtalo de nuevo.",
              busy: "Aún se está procesando la solicitud anterior; inténtalo de nuevo en un momento.",
              conflict:
                "El proyecto cambió mientras tanto. Se muestra la última versión; repite tu último cambio.",
              stale: "Este proyecto de video ya no está disponible.",
              flow_switch:
                "No se pudo cambiar el tipo de video: el servidor puede necesitar una actualización.",
              next_required:
                "Este plano aún no tiene prompt. Describe qué ocurre a continuación o edita el plano primero.",
              end_frame_none:
                "No hay un clip siguiente donde terminar. Elige otra opción de fotograma final.",
              end_frame_invalid: "Ese fotograma final no está disponible. Elige otro.",
              end_frame_requires_start:
                "Ese fotograma final necesita un fotograma inicial. Elige primero uno inicial.",
              end_frame_unsupported:
                "Este modelo no puede terminar en un fotograma elegido: prueba 'La IA decide'",
              edl_full:
                "El video está lleno: no hay espacio para otro plano generado. Recorta o elimina algo primero.",
              project_limit:
                "Este proyecto alcanzó su límite (importaciones, planos o tomas). Elimina algo o empieza un video nuevo.",
              continue_source_gone: "Se eliminó el corte del que continuaba este plano.",
              import_source_invalid:
                "No se puede importar este video. Elige un video subido a Aidea.",
              import_too_large: "Este video es demasiado grande para importarlo.",
              import_too_long: "Este video es demasiado largo para importarlo.",
              not_regenerable: "Este plano no se puede regenerar.",
              finalize_no_draft: "Ese plano no tiene un clip borrador que finalizar.",
              refs_full: "El conjunto de referencias está lleno (24). Elimina una primero.",
              refs_source_invalid: "Ese fotograma o imagen no se puede usar como origen.",
              refs_source_required: "Elige primero un fotograma o una imagen de origen.",
              refs_invalid: "Esa referencia ya no está disponible.",
              cast_photos_consent_required:
                "Confirma que tienes permiso para usar a las personas de las fotos.",
              cast_photos_invalid: "Una de las fotos ya no está disponible: vuelve a añadirla.",
              keyframe_not_from_ref: "Este fotograma clave ya no proviene de una referencia.",
              refs_too_large: "Esta imagen es demasiado grande para usarla como referencia.",
              shot_invalid_cast: "Uno de los personajes elegidos ya no existe. Elige de nuevo.",
              shot_invalid_location: "El escenario elegido ya no existe. Elige de nuevo.",
            },
          },
          EnrichTexts: "Enriquecer con IA",
          Title: "Generar Video",
          NarrationText: "Texto de Narración",
          NarrationTextPlaceholder: "Ingrese el texto de narración para el video...",
          NarrationTextRequired: "Se requiere texto de narración.",
          ContentLanguage: "Idioma del Contenido",
          VideoProvider: "Proveedor de Video",
          VideoStyle: "Estilo de Video",
          VideoStylePlaceholder: "Seleccionar estilo",
          VideoDuration: "Duración del Video",
          VideoDurationPlaceholder: "Duración en segundos",
          Generate: "Crear Storyboard",
          Generating: "Creando storyboard...",
          Submitting: "Enviando...",
          VideoReady: "¡Video listo!",
          AddToEditor: "Agregar al Editor",
          Download: "Descargar",
          Close: "Cerrar",
          Processing: "Generando video...",
          BackgroundNote: "El proceso continuará en segundo plano incluso si cierra el modal.",
          Failed: "Error al generar el video.",
          Optional: "(opcional)",
          NoVideo: "Aún no hay videos",
          UploadPrompt: "Sube tu propio video para comenzar.",
          UploadNow: "Subir ahora",
          UploadDropTitle: "Haz clic para subir o arrastra y suelta",
          UploadDropSubtitle: "MP4, MOV, o WEBM (máx 500MB)",
          ErrorTooLarge: "El archivo es demasiado grande. El tamaño máximo es 500MB.",
          ErrorInvalidType: "Solo se pueden subir archivos MP4, MOV o WEBM.",
          ConvertNote: "Tu archivo .{{ext}} se convertirá a .mp4 durante la subida.",
          StyleNames: {
            photo: "Fotorrealista",
            "3d": "Animación 3D",
            cinema: "Cinematográfico",
            motion: "Gráficos en Movimiento",
            anime: "Anime",
            watercolor: "Acuarela",
            illustration: "Ilustración",
            stopmotion: "Stop-motion",
            animation: "Animación",
            realistic: "Realista",
            cartoon: "Dibujos Animados",
            artistic: "Artístico",
            documentary: "Documental",
            educational_explainer: "Explicativo Educativo",
            whiteboard_animation: "Animación de Pizarra",
            futuristic_sci_fi: "Ciencia Ficción Futurista",
          },

          // AI Generate Tab
          AIModel: "Modelo IA",
          AspectRatio: "Relación de Aspecto",
          Duration: "Duración",
          Auto: "Auto",
          AIDecides: "IA decide",
          Custom: "Personalizado",
          SetTotal: "Establecer total",
          Seconds: "seg",
          Style: "Estilo",
          StyleDisabledNote: "(Deshabilitado - usando imagen de referencia de estilo)",
          CustomCardLabel: "Personalizado",
          ChangeImage: "Cambiar Imagen",
          MoreStyles: "Más estilos",
          LessStyles: "Menos estilos",
          OptionalEnhancements: "Mejoras Opcionales",
          OverlayText: "Superponer texto",
          StartingImage: "Imagen Inicial",
          FirstFrame: "Primer cuadro",
          Browse: "Explorar",
          StyleReference: "Referencia de Estilo",
          VisualGuide: "Guía visual",
          TextAndImageOverlays: "Superposiciones de Texto e Imagen",
          Text: "Texto",
          Image: "Imagen",
          NoOverlaysYet:
            "Aún no hay superposiciones. Agregue superposiciones de texto o imagen para mostrar en el video.",
          Position: "Posición",
          TopLeft: "Superior Izquierda",
          TopCenter: "Superior Centro",
          TopRight: "Superior Derecha",
          BottomLeft: "Inferior Izquierda",
          BottomCenter: "Inferior Centro",
          BottomRight: "Inferior Derecha",
          Center: "Centro",
          EnterTextToDisplay: "Ingrese el texto a mostrar",
          FontFamily: "Familia de Fuente",
          FontStyle: "Estilo de Fuente",
          Normal: "Normal",
          Bold: "Negrita",
          Italic: "Cursiva",
          BoldItalic: "Negrita Cursiva",
          FontSize: "Tamaño de Fuente",
          FontColor: "Color de Fuente",
          BGColor: "Color de Fondo",
          BGOpacity: "Opacidad de Fondo",
          ImageURLOrUpload: "URL de Imagen o Cargar",
          Upload: "Cargar",
          File: "Archivo",
          WidthPx: "Ancho (px)",
          HeightPx: "Alto (px)",
          Opacity: "Opacidad",
          Preview: "Vista Previa",
          SampleText: "Texto de Muestra",
          WritePrompt: "Escribir Prompt",
          FromNarration: "Desde Narración",
          AIWillDecide: "IA decidirá el número de escenas y duración",
          DescribeVideo: "Describa el video que desea generar para esta escena...",
          SceneNarration: "Narración de Escena",
          EachSentenceOneScene: "Cada oración = una escena",
          DescribeSceneNarration: "Describa la narración de la escena...",
          EachSentenceBecomesScene:
            "Cada oración se convierte en una escena. Elimine lo que no necesite soporte visual.",
          DefaultStyles: {
            photo: "Fotorrealista",
            "3d": "Animación 3D",
            cinema: "Cinematográfico",
            motion: "Gráficos en Movimiento",
            anime: "Anime",
            watercolor: "Acuarela",
            illustration: "Ilustración",
            stopmotion: "Stop Motion",
          },
          Model: {
            grok: {
              Label: "Grok",
            },
            "veo-fast": {
              Label: "Omni (720p)",
            },
            "veo-lite": {
              Label: "Omni (720p)",
            },
            veo: {
              Label: "Omni",
            },
          },
          ImageUrlPlaceholder: "https://...",
          StartingImagePreviewAlt: "Vista previa de imagen inicial",
          StyleReferencePreviewAlt: "Vista previa de referencia de estilo",
          AdvancedSettings: "Configuración Avanzada",

          // Storyboard Panel
          StoryboardCreating: "Cargando storyboard...",
          Back: "Atrás",
          Storyboard: "Storyboard",
          ScenesCount: "escenas",
          Clear: "Limpiar",
          Scene: "Escena",
          Narration: "Narración",
          VideoPrompt: "Prompt de Video",
          Edit: "Editar",
          Save: "Guardar",
          Saving: "Guardando...",
          Cancel: "Cancelar",
          Cancelling: "Cancelando...",
          VideoPreview: "Vista Previa de Video",
          AddToScene: "Agregar a Escena",
          Regenerate: "Regenerar",
          NextScene: "Crear la Escena",
          PreviewImage: "Vista Previa de Imagen",
          GeneratePreviewImage: "Generar Imagen de Vista Previa",
          RegeneratePreviewImage: "Regenerar",
          GeneratingPreview: "Generando...",
          GenerateAllScenes: "Generar Todas las Escenas",

          // Add scene
          AddScene: "Añadir Escena",
          AddSceneTitle: "Añadir Nueva Escena",
          AddSceneNarrationLabel: "Texto de Narración",
          AddSceneNarrationPlaceholder:
            "¿Qué debe narrarse en esta escena? (al menos 20 caracteres)",
          AddSceneDurationLabel: "Duración (segundos)",
          AddScenePromptLabel: "Prompt de Video",
          AddScenePromptPlaceholder:
            "Describe las imágenes de esta escena (al menos 20 caracteres)",
          AddScenePromptHint:
            "La narración se deriva de este prompt; el proveedor define la duración.",
          AddScenePromptTooShort: "El prompt de video debe tener al menos 20 caracteres",
          AddScenePositionLabel: "Posición",
          AddScenePositionAppend: "Añadir al final",
          AddScenePositionBefore: "Antes de la Escena {{n}}",
          AddSceneAfterScene: "Después de la Escena {{n}}",
          AddSceneAdding: "Añadiendo...",
          AddSceneTextTooShort: "El texto de narración debe tener al menos 20 caracteres",

          // Reference image (image-to-video)
          ReferenceImageAdd: "Imagen de referencia",
          ReferenceImageUploading: "Subiendo...",
          ReferenceImageSet: "Imagen de referencia lista",
          ReferenceImageRemove: "Quitar",
          StartingImageAsReference: "Imagen inicial",

          // Scene images (select as reference)
          SceneImages: "Imágenes de la escena",
          SceneImagesHint:
            "Selecciona una imagen de esta escena para usarla como imagen inicial del vídeo.",
          SceneImageSelect: "Seleccionar como referencia",

          // Status labels
          StatusPending: "Pendiente",
          StatusGenerating: "Generando",
          StatusProcessing: "Procesando",
          StatusCompleted: "Completado",
          StatusFailed: "Fallido",
          StatusError: "Error",

          // Error messages
          SceneError: "Error de Escena",
          ContentNotSuitable: "El contenido no es adecuado para la generación",
          ErrorOccurred: "Ocurrió un error durante la generación del video",
          EditSaveError: "No se pudieron guardar los cambios. Inténtelo de nuevo.",
          GenerationError: "Error de Generación",
          ValidationError: "Error de Validación",
          SceneTextTooShort:
            "El texto de la escena debe tener al menos 20 caracteres para una narración significativa",
          VideoPromptTooShort:
            "El prompt de video debe tener al menos 20 caracteres para una generación de video significativa",

          // Modal tabs
          AIGenerate: "Generar con IA",
          UploadMyVideo: "Subir mi video",
          BackToForm: "Volver al Formulario",
          CustomStyleDescription: "Descripción de Estilo Personalizado",
          CustomStylePlaceholder:
            "Describa el estilo visual que desea, ej. noir cinematográfico, animación retro de los 80, plastilina stop-motion...",

          // Existing storyboard warning
          ExistingStoryboardTitle: "Storyboard Existente",
          ExistingStoryboardMessage:
            "Ya hay un storyboard en progreso. Crear un nuevo video eliminará el storyboard existente. ¿Desea continuar?",
          ProceedAnyway: "Continuar de Todos Modos",

          // Storyboard status messages
          OngoingStoryboard: "Storyboard en Curso",
          ContinueFromWhere: "Puede continuar donde lo dejó",
          ViewStoryboard: "Ver",
          SearchLibrary: "Buscar",
          LibraryLoadError: "No se pudieron cargar los vídeos",

          // Language names
          Languages: {
            "tr-TR": "Turco (tr-TR)",
            "en-US": "Inglés (en-US)",
            "es-ES": "Español (es-ES)",
            "fr-FR": "Francés (fr-FR)",
            "de-DE": "Alemán (de-DE)",
            "ar-SA": "Árabe (ar-SA)",
            "ja-JP": "Japonés (ja-JP)",
            "pt-BR": "Portugués (pt-BR)",
            "az-AZ": "Azerbaiyano (az-AZ)",
          },

          // Provider names
          Providers: {
            grok: "Grok",
            "veo-fast": "Omni (720p)",
            "veo-lite": "Omni (720p)",
            veo: "Omni",
          },
        },
      },
      FileHandlers: {
        downloadAsFile: "Descargar Fichero",
        insert: "Insertar",
        import: "Importar",
        embed: "Incrustar",
        replace: "Reemplazar",
        replace_bckg: "Cambiar fondo",
        table: "Tabla",
        graph: "Gráfica",
        video: "Vídeo",
        audio: "Audio",
        image: "Imagen",
        Animations: "Animaciones",
        Object3D: "Objeto 3D",
        cancel: "Cancelar",
        custom: "Archivo Personalizado",
        selectAll: "Seleccionar Todo",
        selected: "Seleccionado",
        question: "Pregunta",
        type: "Tipo",
        filter_questions: "Filter Questions",
        no_matches: "No Matches",
        feedback0: "No se añadirá ningún ejercicio",
        feedback1s: "Se añadirá 1 ejercicio",
        feedback1p: "Se Añadirán",
        feedback2p: "Ejercicios",
      },
      Title: "Importar Recurso...",
    },
    fullscreen: "Pantalla Completa",
    global_config: {
      Accept: "Guardar Cambios",
      aspect_ratio: "Relación de aspecto en diapositivas",
      timeline_visible: "Línea de tiempo visible",
      jobWidgetVisible: "Async Widget",
      chatbotEnabled: "Chatbot",
      anonymous: "Anónimo",
      author: "Autor",
      avatar: "Miniatura",
      avatar_delete_img: "Borrar Imagen",
      avatar_screenshot: "Capturar Pantalla",
      avatar_import: "Import Image",
      context: "Contexto",
      context_list: {
        school: "Ed.Primaria, Secundaria y Bach.",
        primary_school: "Ed. Primaria",
        secondary_school: "Ed. Secundaria",
        bach_school: "Bachillerato",
        high_education: "Educación Superior",
        training: "Formación Laboral",
        other: "Other",
      },
      course_title: "Título del Curso",
      course_font: "Fuente de la Formación",
      course_font_none: "Sin definir",
      course_font_scope_scene: "Solo esta escena",
      course_font_scope_course: "Toda la formación",
      course_font_note:
        "La fuente seleccionada se aplica a todos los cuadros de Texto Básico y Texto Enriquecido de la formación, reemplazando los ajustes de fuente de cada cuadro. Se aplica al guardar.",
      default_score: "Puntuación por defecto",
      total_score: "Puntuación Total",
      total_questions: "Número total de preguntas",
      required_correct_answers: "Número de respuestas correctas requeridas",
      require_question_evaluation: "Evaluación de preguntas requerida",
      require_question_evaluation_info:
        'La opción "ver respuesta" se activará automáticamente para que esta función funcione correctamente.',
      description: "Descripción",
      description_placeholder: "Describa brevemente de qué trata el documento",
      dif: {
        null: "Sin Especificar",
        undefined: "Sin Especificar",
        "very easy": "Muy Fácil",
        easy: "Fácil",
        medium: "Medio",
        difficult: "Difícil",
        "very difficult": "Muy difícil",
      },
      difficulty: "Dificultad",
      Discard: "Cancelar",
      hideGlobalScore: "Puntuación Global",
      keylist: {
        Art: "Arte",
        Biology: "Biología",
        Chemistry: "Química",
        Citizenship: "Ciudadanía",
        Computerscience: "Informática",
        Economics: "Economía",
        Education: "Educación",
        Engineering: "Ingeniería",
        Foreignlanguages: "Idiomas",
        Generalculture: "Cultura General",
        Geography: "Geografía",
        Geology: "Geología",
        History: "Historia",
        Humanities: "Humanidades",
        Literature: "Literatura",
        Maths: "Matemáticas",
        Music: "Música",
        Naturalscience: "Ciencias Naturales",
        Physics: "Física",
        Technology: "Tecnología",
      },
      keywords: "Palabras Clave",
      keyw: {
        Add_tag: "Añadir Palabra Clave",
      },
      language: "Idioma",
      minTimeProgress: "Mínimo tiempo por página",
      mode: "Modo del curso",
      content_language: "Idioma de la formación",
      content_language_hint:
        "Los textos de las preguntas y el audio, los avatares y los vídeos generados usan este idioma por defecto. No cambia el idioma de la interfaz del editor.",
      mode_list: {
        clm: "CLM",
        infographic: "Infografía",
        html_artifact: "HTML interactivo",
        presentation: "Presentación",
        atomic_presentation: "Presentación atómica",
        mixed: "Mixto",
      },
      no_lang: "Sin especificar",
      permissions: {
        title: "Permisos",
        allow_clone: "Permitir Clonar",
        allow_comments: "Permitir Comentar",
        allow_download: "Permitir Descargar",
      },
      prompt: "¿Desea guardar los cambios antes de salir?",
      public_domain: "Dominio Público",
      recom_age: "Edad Recomendada",
      rights: "Licencia",
      rights_short_txt:
        "Las licencias Creative Commons son una vía simple y estandarizada de otorgar permisos de derechos de autor a sus trabajos.",
      status: "Estado",
      status_list: {
        draft: "Borrador",
        public: "Público",
        final: "Final",
        revised: "Revisado",
        unavailable: "No Disponible",
      },
      title: "Configuración Global",
      title_advanced: "Avanzado",
      title_general: "Datos Generales",
      typicalLearningTime: "Tiempo típico de aprendizaje",
      version: "Versión",
      visor_nav: {
        keybindings: "Flechas Del Teclado",
        player: "Barra de Botones",
        sidebar: "Barra Lateral",
        title: "Navegación al Previsualizar",
        fixedPlayer: "Navegación Fija ",
        timeBar: "Barra de tiempo",
      },
      group: {
        general: "General",
        geometry: "Geometría de escena",
        scene_defaults: "Valores por defecto de escena",
        progress_access: "Progreso y acceso",
        visor_navigation: "Navegación del visor",
        theme: "Tema",
      },
      default_scene_duration: "Duración predeterminada de escena (s)",
      scene_defaults_override_warning:
        "Al guardar, estos ajustes se escriben en todas las escenas existentes y reemplazan sus ajustes de obligatoriedad.",
      default_scene_duration_hint:
        "El tiempo que necesita una escena no obligatoria para considerarse completada. Si se deja vacío, se aplica el tiempo mínimo por página ({{seconds}} s).",
      wait_for_time_hint:
        "Esperar el tiempo de diapositiva espera el final de la escena en la línea de tiempo.",
      default_scene_duration_placeholder: "No establecido",
      default_mandatory_label: "Obligatoria",
      auto_next: "Siguiente escena automática",
      scene_duration_placeholder: "Duración propia de la escena",
      scene_group: {
        standard: "Escenas",
        standard_hint:
          "Escenas sin preguntas. Si es obligatoria, no se puede avanzar antes de que termine el tiempo.",
        question: "Escenas con preguntas",
        question_hint:
          "Escenas con preguntas. Estos ajustes nunca se aplican a las escenas sin preguntas.",
        transition: "Transición de escena",
        transition_hint:
          "Se aplica a todas las escenas. Las escenas con preguntas no avanzan automáticamente.",
      },
      cancel: "Cancelar",
    },
    ratio_style: {
      standard: "Estándar / Digital",
      classic: "Clásico",
      square: "Cuadrado / Redes",
      reels: "Reels / Shorts",
      ig_portrait: "Instagram Vertical",
    },
    ratio_reproduce: {
      menu_label: "Generar en Otra Proporción",
      title: "Generar en Otra Proporción",
      question:
        "{{title}} ({{ratio}}) ¿Deseas reproducir esta formación en otra proporción de pantalla?",
      pick_ratio: "Selecciona la Proporción Objetivo",
      desc: {
        "16_9": "Formato panorámico estándar",
        "4_3": "Formato de TV clásico",
        "1_1": "Feed de Instagram y redes sociales",
        "9_16": "Instagram Reels, YouTube Shorts",
        "4_5": "Formato de publicación vertical de Instagram",
      },
      resolution: "Resolución",
      res_1k: "1K",
      res_1k_desc: "Bajo costo, rápido",
      res_2k: "2K (Predeterminado)",
      res_2k_desc: "Calidad y costo equilibrados",
      res_4k: "4K",
      res_4k_desc: "Máxima calidad",
      new_name: "Nombre de la Nueva Formación",
      note: "Nota: Esto creará una nueva formación y puede tardar unos minutos. Las fotos pueden no ser exactamente iguales.",
      create: "Crear",
      creating: "Creando…",
      error: "No se pudo iniciar la operación. Inténtalo de nuevo.",
      errors: {
        not_owner: "Esta formación no te pertenece.",
        forbidden: "No tienes autorización para esta acción.",
      },
      timeout: "La operación agotó el tiempo de espera.",
      toast_started_title: "Reproducción iniciada",
      toast_done_title: "Generar en Otra Proporción",
      toast_progress: "Generando... {{progress}}%",
      toast_done:
        "Formación creada. Puedes encontrar la nueva formación en tu página de Formaciones.",
      toast_failed: "La reproducción falló.",
    },
    nav_dropdown: {
      new_training: "Crear nuevo",
      subtitles: "Subtítulos",
    },
    Header: "Cabecera",
    Height: "Altura",
    Height_auto: "Alto Automático",
    Height_auto_message: "Sólo funcionará si el contenedor tiene una altura fijada",
    Height_percentage: "Alto (%)",
    Height_pixels: "Alto (px)",
    hide: "Ocultar",
    atLeastOneSceneVisible: "Al menos una escena debe permanecer visible",
    sceneMultiSelect: {
      title: "Eliminar escenas",
      selected: "{{count}} escenas seleccionadas",
      confirm: "¿Eliminar {{count}} escenas?",
    },
    horizontal: "Subtítulo Horizontal",
    Images: "Imágenes",
    importData: "Importar Fichero Datos...",
    importFile: {
      title: "Añadir Fondo",
      pages: {
        from: "Desde",
        title: "Páginas",
        to: "Hasta",
        whole_file: "Archivo Completo",
      },
      importAs: {
        title: "Importar Como",
        slideBackground: "Fondo en Diapositiva",
        images: "Imágenes",
        customSize: "Ajustar al tamaño del fichero",
        PDFViewer: "Visor de PDF",
      },
      footer: {
        ok: "Aceptar",
        cancel: "Cancelar",
      },
    },
    ZipImport: {
      drop_zip: "Suelta aquí el ZIP de la grabación de pantalla",
      hint: "ZIP de grabación de pantalla exportado desde la extensión grabadora",
      starting: "Iniciando…",
      success: "¡Importación completada!",
      failed: "La importación falló",
      invalid_file: "No es un archivo ZIP válido",
      try_again: "Intentar de nuevo",
      tab_upload: "Subir archivo",
      tab_screen: "Formación en pantalla",
      select_scene: "¿Después de qué escena insertar?",
      at_end: "Al final",
    },
    Importing: "Abriendo...",
    INDEX: "ÍNDICE",
    index_total_duration: "Duración total",
    Indice: "Índice",
    insert_plugin: "Insertar Contenido",
    joyride: {
      back: "Atrás",
      carrousel: "Completa y ordena tu documento añadiendo más páginas, diapositivas y secciones.",
      canvas: "Esta es la zona de edición, úsala para ir construyendo tu recurso",
      close: "Cerrar",
      drag: "Elige el contenido que necesitas, y añádelo arrastrando o haciendo clic.",
      idealStudio_description:
        "tu herramienta para la creación de recursos educativos enriquecidos y estandarizados",
      index:
        "Gestiona tus páginas, diapositivas y vistas contenidas desde el índice. ¡Ah! Una vista contenida se refiere a las vistas que puedes enlazar añadiendo puntos calientes (marcas) en tu contenido.",
      last: "Finalizar",
      manual:
        "Si te ha quedado alguna duda, accede al menú de ayuda. Puedes volver a ejecutar este paseo o consultar nuestro",
      manual2: " manual de usuario",
      menu: "Desde el menú puedes importar tus PDFs y todo lo que necesites. También desde aquí podrás exportar tu documento a formatos estándar y cambiar la configuración global.",
      need_help: "¿Necesitas ayuda para empezar?",
      next: "Siguiente",
      preview: "Previsualiza tu documento tantas veces como necesites para ver cómo está quedando",
      skip: "Saltar",
      start: "Si, me vendría bien",
      toolbar: "Cambia la configuración de tus vistas y contenidos en la barra de propiedades.",
      welcome: "¡Bienvenido a ",
      why: "¿Por qué no comienzas a crear contenido?",
    },
    currentLang: "es",
    marks: {
      add_mark: "Añadir Marca",
      add_mark_to: "Añadir Marca A",
      create_mark:
        "Estás creando una nueva marca que enlaza a una vista contenida. ¿Cómo quieres llamarlas?",
      edit_mark_to: "Editar Clic ",
      existing_content: "Contenido Existente",
      existing_content_label: "Destino Del Enlace",
      external_url: "Contenido externo",
      external_url_label: "URL",
      hover_message: "Enlaza Con ",
      link_to: "Enlazar Con",
      mark_color: "Color de la Marca",
      mark_name: "Nombre Marca",
      marks_list: "Lista de Marcas",
      nothing: "No hacer nada",
      next_view: "Contenido siguiente",
      prev_view: "Contenido anterior",
      go_to_section: "Ir a la sección",
      go_to_section_label: "Sección",
      add_click_zone: "Añadir zona de clic",
      new_content: "Nuevo Contenido",
      new_content_label: "Destino del Enlace",
      new_document: "Página",
      new_slide: "Diapositiva",
      new_mark: "Nueva Marca",
      popup: "Mostrar PopUp",
      popup_label: "Texto de la clic",
      popup_placeholder: "Escribe el texto que quieres que aparezca al hacer click en la marca",
      value: "Valor",
      wrong_value: "Valor Incorrecto",
      save_changes: "Guardar",
      applyAllScenes: "Guardar como Plantilla",
      applyAllScenesNote: "Guarda esta diapositiva como plantilla para reutilizarla más tarde.",
      upload_template: "Guardar Diapositiva",
      TemplateName: "Nombre de la Plantilla:",
      template_uploaded_slide: "Plantillas Guardadas",
    },
    boxPaste: {
      assetsWarning:
        "No se pudieron copiar los archivos multimedia del elemento. Sigue apuntando a la formación original y es posible que no se muestre a los usuarios: ",
    },
    messages: {
      add_new_mark: "Añadir Nueva Marca",
      add_answer: "Añadir Respuesta",
      AddBox: "Añade una nueva caja",
      adjust_to_document: "Ajustar al Documento",
      alert: "Alerta",
      align_bottom:
        "La parte inferior del elemento se alinea con la parte inferior del elemento más bajo de la línea",
      align_center: "Alinear al Centro",
      align_left: "Alinear a la izquierda",
      align_middle: "El elemento se alinea al medio de la línea",
      align_right: "Alinear a la derecha",
      align_top:
        "La parte superior del elemento se alinea con la parte superior del elemento más alto de la línea",
      all_fields: "Debes rellenar todos los campos para subir el fichero",
      Cancel: "Cambiar",
      Change_source: "Cambiar...",
      Change: "Değiştir",
      columns_distribution: "Distribución de columnas",
      confirm_delete_cv: "Confirmar borrado",
      confirm_delete_CV_also_1: 'Esta es la única marca que enlaza a "',
      confirm_delete_CV_also_2: '". Desea eliminar la vista también?',
      confirm_delete_cv_as_well: "Borrar también vista contenida",
      confirm_delete_cv_not: "Borrar sólo la marca",
      delete_busy_cv: "Todas las marcas que enlazan a esta vista serán eliminadas",
      delete_contained_canvas:
        "Esta acción borrará esta vista y todo su contenido, incluyendo las marcas que enlazan a ella",
      delete_container: "Esta acción borrará todo el contenido que ha incluído en este bloque.",
      delete_idealStudio_document: "Borrar documento Aideapro Studio",
      delete_idealStudio_document_message:
        "¿Estás seguro de que deseas borrar el documento? Perderás todo el contenido que has creado.",
      delete_page:
        "Esta acción borrará todo el contenido de la página y las marcas que enlacen a ella.",
      cant_delete_last_page:
        "La última escena no se puede eliminar. Debe haber al menos una escena.",
      delete_section:
        "Esta acción borrará todo el contenido de la sección y de sus descendientes y las marcas que enlacen a ellos.",
      docs: "Ver Documentación",
      drag_content: "Arrastra aquí tu contenido",
      draw_borders: "Representar el borde de los documentos",
      edit_text: "Editar Texto",
      double_click_to_edit: "Haga doble clic para editar",
      change_icon: "Cambiar icono",
      erase_plugin: "Borrar",
      increase_text_size: "Aumentar tamaño de texto",
      decrease_text_size: "Reducir tamaño de texto",
      align_left: "Alinear a la izquierda",
      align_center: "Centrar",
      align_right: "Alinear a la derecha",
      align_up: "Alinear arriba",
      align_right: "Alinear a la derecha",
      align_left: "Alinear a la izquierda",
      align_center: "Alineación central",
      align_down: "Alinear hacia abajo",
      align_arrows: "Alinear",
      erase_container: "Borrar Contenedor",
      error: "Error",
      exit: "Salir",
      exit_page: "¿Seguro que deseas eliminar esta página?",
      export: "Exportar...",
      export_course: "Exportar Documento",
      export_to_lms: "Exportar a LMS",
      lms_overwrite_message: "Esta formación fue exportada previamente al LMS el {{date}}.",
      lms_overwrite_message_second: "¿Cómo desea continuar?",
      lms_overwrite_title: "Exportar a LMS",
      lms_save_as: "Crear Nuevo",
      lms_overwrite: "Sobrescribir",
      export_to_HTML: "Exportar a HTML",
      export_to_label: "Elige cómo quieres exportar el documento",
      export_to_SCORM: "Exportar a SCORM",
      export_to: "Exportar a",
      forbidden: "No se puede modificar la licencia de un recurso que ya ha sido publicado",
      force_page_break:
        "Quiero que los documentos importados comiencen siempre en una página nueva.",
      fullscreen: "Ampliar a pantalla completa",
      global_config: "Configuración Global",
      go_back: "Volver",
      go_back_to: "Volver a ",
      help: "Ayuda",
      language: "Lenguaje",
      language_english: "Inglés",
      language_spanish: "Español",
      language_turkish: "Turco",
      help_modal_text: "Resuelve cualquier duda sobre Aideapro Studio",
      import: "Importar... ",
      import_file: "Importar Archivo ",
      instance_limit: "Este plugin sólo permite una instancia por página",
      clm_plugin_blocked: "Este tipo de elemento no está disponible en las presentaciones CLM.",
      depth_limit: "No puedes situar aquí este tipo de contenido",
      height_auto_warning:
        "Sólo si fijas una altura podrán tener alturas relativas las cajas en su interior",
      mark_input: "Hay un error en el valor introducido",
      no_internet: "Necesitas conexión a Internet",
      OK: "Aceptar",
      okay: "Aceptar",
      only_pages: "Sólo Páginas",
      only_slides: "Sólo Diapositivas",
      operation_in_progress: "Operación en curso...",
      pointer_events: "Permitir manipular el contenido manualmente",
      popoverUrlTitle: "Cambia esta URL",
      preview: "Muestra una vista preliminar",
      publish_tooltip: "Permite que el curso esté disponible al público",
      publish_alert_title: "Publicar este documento",
      publish_alert_text:
        "Con esta acción compartes este documento de forma pública. Significa que cualquier usuario puede tener acceso a reutilizarlo.",
      publish_not_allowed:
        "Añade un título y una imagen a tu documento antes de publicarlo. Para hacer esto accede a Menú > Configuración global.",
      redo: "Rehace la última acción",
      RemoveBox: "Borra Una Caja",
      remove_answer: "Borrar Respuesta",
      move_up: "Mover arriba",
      move_down: "Mover abajo",
      save_changes: "Guardando Cambios",
      save_as_changes: "Guardar cambios como",
      saving: "Guardando...",
      selfContained:
        "Deseo incluir los ficheros que he subido al paquete exportado para poder utilizarlo cuando no tengo conexión a Internet.",
      subtitlesOnByDefault: "Mostrar los subtítulos automáticamente al abrir la formación.",
      slides_per_page: "Número de diapositivas por página: ",
      slides_and_pages: "Diapositivas y Páginas",
      undo: "Deshace la última acción",
      unpublish: "Hace que el documento deje de estar accesible al público",
      GoogleFontsModal: {
        title: "Consentimiento de Uso de Google Fonts",
        fontsNotFound: "Las siguientes fuentes no se encontraron en su sistema:",
        needGoogleFonts: "Necesitamos usar el servicio de Google Fonts para usar estas fuentes.",
        importantInfo: "Información Importante:",
        connectsToGoogle: "Google Fonts se conecta a los servidores de Google para cargar fuentes",
        ipAddressVisible: "Google puede ver su dirección IP",
        secureLoading: "Las fuentes se cargan de forma segura",
        safeForViewing: "Las fuentes son solo para visualización y no contienen código malicioso",
        editorAndExport:
          "En el editor, las fuentes se cargarán mediante enlace, mientras que en las exportaciones, los archivos de fuentes se descargarán e incluirán en el paquete",
        permissionQuestion: "¿Consiente el uso de Google Fonts?",
        cancel: "Cancelar",
        approve: "Sí, Consiento",
        success: "Fuente agregada con éxito.",
        error: "Las fuentes seleccionadas no se pudieron descargar desde el servicio Google Fonts.",
        connectionError: "Ocurrió un error de conexión.",
        loading: "Por favor, espere...",
      },

      help_welcome: "Bienvenido a Aideapro Studio.Haga clic para obtener sugerencias de ayuda.",
      help_guide:
        "Si tiene alguna pregunta después de los consejos de ayuda, puede consultar nuestra guía del usuario aquí. (Esta opción está en desarrollo.)",
      help_documentation:
        "Si eres un desarrollador, puedes echar un vistazo a la documentación aquí. (Esta opción está en desarrollo.)",
      Success: "Éxito",
      SuccessMessage: "Su e-learning se ha registrado correctamente.",
      LmsExportSuccess: "La formación se exportó al LMS y se añadió al Repositorio de Contenidos.",
      RotateLeft: "Girar a la izquierda",
      RotateRight: "Gira a la derecha",
      Copied: "Copiado!",
      syncScene: {
        buttonLabel: "Sincronizar escena",
        buttonTitle: "Sincronizar la escena activa",
        syncing: "Sincronizando escena...",
        successTitle: "Sincronización",
        successMessage: "Escena sincronizada correctamente.",
        errorTitle: "Error",
        errorMessage: "No se pudo sincronizar la escena.",
        aiButton: "Sincronizar con IA",
        modal: {
          title: "Sincronizar con IA",
          desc: "La IA sincroniza automáticamente los elementos visuales y de texto de la escena con tu archivo de audio.",
          step1: "Se analiza el archivo de audio",
          step2: "La sincronización de los elementos visuales se alinea con el audio",
          step3: "Los elementos de texto se colocan según el audio",
          extractTexts: "Extraer los textos de las imágenes",
          extractTextsPrice: "10 créditos",
          busy: {
            motion: "Enriqueciendo y animando la escena…",
            extract: "Extrayendo los textos de las imágenes…",
          },
          toast: {
            synced: "Sincronización de la escena terminada",
            extracted: "Sincronización terminada — se añadieron los textos de las imágenes",
            motion: "Escena enriquecida y animada",
          },
          jobFailed:
            "No se pudo completar el trabajo. No se cobraron créditos; inténtalo de nuevo.",
          howItWorks: "Cómo funciona",
          howItWorksSoon: "Vídeo próximamente",
          howItWorksSync:
            "Los elementos se ajustan a la narración: cada uno entra con sus palabras y sale cuando llega la siguiente imagen. Activa “Extraer los textos de las imágenes” para convertir el texto de las imágenes en texto editable y animado, que se aplica a la escena automáticamente.",
          howItWorksMotion:
            "Primero se sincroniza la escena; después se extrae el texto de las imágenes y se diseñan gráficos animados según la narración. El resultado se aplica a la escena automáticamente; la bandeja de trabajos muestra cada paso.",
          cancel: "Cancelar",
          confirm: "Iniciar sincronización",
          modeSync: "Sincronizar elementos actuales",
          modeSyncDesc: "Reajusta el tiempo de los elementos de la escena a la narración",
          modeMotion: "Enriquecer y animar",
          modeMotionDesc:
            "Sincroniza, extrae el texto de las imágenes, añade gráficos animados y lo aplica a la escena — sin paso de aprobación",
          motionConfirm: "Iniciar diseño de movimiento",
          motionPaidNote: "De pago: se aplica el precio de Motion Director.",
          motionErrors: {
            "scene-missing": "No se encontró la escena.",
            "no-images": "Esta escena no tiene imágenes para animar.",
            "no-training": "Abre esta formación desde su página e inténtalo de nuevo.",
            "no-extractable":
              "Ninguna imagen permite extraer su texto (se omiten las imágenes recortadas o ampliadas).",
            failed: "No se pudo iniciar el diseño de movimiento. Inténtalo de nuevo.",
          },
        },
      },
      previewSpeed: {
        title: "Velocidad de vista previa",
        buttonTitle: "Velocidad de vista previa",
        cycleTitle: "Siguiente velocidad",
        normal: "normal",
        note: "Solo para la vista previa de la línea de tiempo: no afecta a la formación publicada.",
        youtubeLimit: "YouTube admite 2× como máximo.",
      },
      trackClip: {
        repeatForScene: "Repetir en la escena",
      },
      animationNames: {
        Pan: "Paneo de entrada",
        Fade: "Aparecer",
        "Fade In": "Aparecer",
        "Scale In": "Acercar",
        "Slide In Right": "Deslizar a la derecha",
        "Slide In Left": "Entrar desde la izquierda",
        "Slide In Up": "Deslizar arriba",
        "Slide In Down": "Deslizar abajo",
        Rotate: "Girar",
        Bounce: "Rebotar",
        "Bounce In": "Entrar rebotando",
        "Rotate In": "Entrar girando",
        "Type Writer": "Máquina de escribir",
        "Wavy Text": "Texto ondulado",
        Flip: "Voltear",
        Pinwheel: "Molinete",
        Roll: "Rodar",
        Stretch: "Estirar",
        "Pan Out": "Paneo de salida",
        "Fade Out": "Desvanecer",
        "Scale Out": "Alejar",
        "Slide Out Right": "Salir a la derecha",
        "Slide Out Left": "Salir a la izquierda",
        "Slide Out Up": "Salir arriba",
        "Slide Out Down": "Salir abajo",
        "Rotate Out": "Salir girando",
        "Bounce Out": "Salir rebotando",
        "Type Writer Out": "Máquina de escribir (salida)",
        "Wavy Text Out": "Texto ondulado (salida)",
      },
      animationPanel: {
        panEntryName: "Entrada Pan",
        panExitName: "Salida Pan",
        direction: "Dirección",
        zoomOut: "Alejar",
        zoomIn: "Acercar",
        zoomAmount: "Cantidad de Zoom",
        startPoint: "Punto de Inicio",
      },
    },
    ThemePalette: {
      Title: "Selección de Tema y Paleta",
      Select: "Seleccionar",
      Theme: "Tema",
      SelectTheme: "Selecciona un tema",
      LoadingThemes: "Cargando temas...",
      Palette: "Paleta",
      LoadingPalettes: "Cargando paletas...",
      NoPalettes: "No se encontraron paletas para este tema.",
      ErrorSelectBoth: "Por favor selecciona un tema y una paleta.",
      UnknownError: "Ha ocurrido un error desconocido.",
      Apply: "Aplicar",
      Applying: "Aplicando...",
      NoThemesError: "Error al cargar los temas del servidor.",
      ThemeStyleFetchError: "Error al cargar los estilos del tema desde el servidor.",
      RemoveTheme: "Eliminar Tema",
      ApplyToAll: "Aplicar a todas las escenas",
      Custom: "Personalizado",
      Mode: "Modo",
      ModeImage: "Imagen",
      ModeHtml: "HTML / CSS",
      ModeColor: "Color",
      HtmlPlaceholder:
        '<div style="position:absolute;inset:0;background:linear-gradient(135deg,#1a1a2e,#16213e);"></div>',
      Edit: "Editar",
      Preview: "Vista previa",
    },
    EditButton: {
      edit_selected: "Editar elemento seleccionado",
      no_selection: "Selecciona un elemento para editar",
      multi_selection: "Selecciona un único elemento para editar",
      container_selected: "Los contenedores no se pueden editar directamente",
      unsupported_plugin: "Este tipo de elemento no tiene acción de edición",
      artifact_ref:
        "Las escenas interactivas se editan con IA, desde el botón de chat del elemento",
      html_modal_title: "Editar contenido HTML",
      html_placeholder: '<div style="padding:16px;background:#fff">Hola</div>',
    },
    MoodleXML: {
      are_you_sure: "Seguro que es MoodleXML?",
      parse_error: "Error al parsear el fichero",
      unrecognized: "Tipo de ejercicio deseconocido",
      not_supported: "No Soportado",
    },
    Multimedia: "Media",
    NavItem_name: "Nombre de la Página",
    General_name: "General",
    NavItem_title: "Título de la Página",
    no_results: "Sin Resultados",
    Objects: "Objetos",
    OK: "OK",
    Open: "Abrir",
    Open_Catalog: "Ver Imágenes Subidas",
    open_conf: "Configuración",
    minTime: "Duración  de Escena",
    slideDuration: "Duración de Escena",
    autoNext: "Cambio Automático",
    autoNextNote: "El avance automático ocurre cuando termina toda la escena.",
    autoNextShowCta: "Mostrar cuenta atrás antes de avanzar",
    autoNextShowCtaNote:
      "Muestra la tarjeta de la siguiente escena con una cuenta atrás de 5s. Desactivado, el avance es directo.",
    sceneEndCta: "Tarjeta de transición al final de la escena",
    sceneEndCtaNote:
      "Activada, al terminar la escena (y cumplirse su requisito, si lo hay) aparece una tarjeta que invita a la siguiente escena. Desactivada (por defecto), la escena permanece en pantalla y se avanza con el botón Siguiente.",
    mandatoryType: "Opciones de Transición de Diapositivas",
    isMandatory: "Obligatoria",
    waitForAction: "Esperar la respuesta",
    waitForCorrectAction: "Espera Respuesta Correcta",
    waitForOneClick: "Esperar el clic",
    waitForTime: "Espere el Tiempo de Diapositiva",
    // TODO: deprecated — labels below only serve retired mandatory types shown
    // disabled on legacy trainings; remove once no trainings still use them.
    waitForAnimation: "Espera la Animación",
    waitForSound: "Espera el Sonido",
    waitForVideo: "Espera el Video",
    FileSizeLimit: {
      TooLarge: "El archivo es demasiado grande. Puedes subir hasta {{max}} MB.",
    },
    AddSoundUpload: {
      DropTitle: "Haz clic para subir o arrastra y suelta",
      DropSubtitle: "MP3, WAV o M4A (máx 100MB)",
      Remove: "Eliminar",
      SoundSettings: "Configuración de Sonido",
      StartTime: "Hora de Inicio",
      FinishTime: "Hora de Finalización",
      Volume: "Volumen",
      ErrorInvalidType: "Solo se pueden subir archivos MP3, WAV o M4A.",
      ErrorTooLarge: "El archivo es demasiado grande. El tamaño máximo es 500MB.",
    },
    SceneAudio: {
      Title: "Sonidos de Narración",
      ErrorRequestFailed: "Solicitud fallida",
      ErrorPrefix: "Error",
      NoTrainingAudio: "No hay audio de narración guardado para este entrenamiento.",
      NoSceneAudio: "No se encontró audio de narración.",
      Collapse: "Contraer",
      Expand: "Expandir",
      HideText: "Ocultar Texto",
      ShowText: "Mostrar Texto",
      Pause: "Pausar",
      Play: "Reproducir",
      Video: "Vídeo",
      ViewScene: "Ver Escena",
      Edit: "Editar",
      Delete: "Eliminar",
      AddAudio: "Añadir Sonido",
    },
    Mindmap: {
      Title: "Mapa mental",
      Open: "Abrir mapa mental",
      OpenHint: "Se abre en una pestaña nueva",
      Loading: "Cargando...",
      Empty: "No se generó ningún mapa mental para esta formación.",
      EmptyHint: "Los mapas mentales solo se generan en cursos creados a partir de documentos.",
      Error: "No se pudo cargar el mapa mental.",
    },
    ImgTextToImage: {
      TabStyleLibrary: "Biblioteca de estilos",
      TabTraditionalMode: "Modo clásico",
      Provider: {
        Flux: "Flux – 1.1 Pro",
        GeminiNano: "Gemini – 3.1 Flash Image",
        Grok: "Grok",
        GPTImage: "GPT-image-1.5",
      },
      WaitMessage: "Espera, por favor...",
    },
    Sound: {
      Sounds: "Sonidos",
      Sound: "Sonido de Narración",
      uploadSound: "Importar Sonido",
      soundRecorder: "Grabadora de Sonido",
      addSound: "Agregar Sonido",
      demoSound: "Sonidos de Muestra",
      slaytSounds: "Sonidos en la Diapositiva",
      soundList: "Lista de Sonidos",
      add_sound: "Agregar Sonido",
      sound_name: "Nombre de Sonido",
      sound_name_holder: "Nombre de Sonido...",
      Add: "Agregar",
      select_sound: "Selección de Sonido",
      AddNewSoundFromList: "Agregar Sonido de la Biblioteca",
      AddNewSoundFromLocal: "Agregar Sonido desde la Computadora",
      AddAISound: "Agregar Sonido IA",
      NoFileChosen: "Seleccionar sonido",
      VolumeLevel: "Volumen de Sonido",
      DemoSound: "Vista previa de sonido",
      Start_Time: "Hora de inicio: ",
      End_Time: "Hora de finalización: ",
      Volume: "Volumen: ",
      Edit: "Editar",
      Delete: "Borrar",
      Play: "Reproducir",
      Pause: "Pausar",
      listenSounds: "Escuchar Sonido(s)",
      FileAdded: "Sonido agregado exitosamente.",
    },
    Recorder: "Hora del Registrador",

    order: {
      Ahead: "Adelante",
      Behind: "Atrás",
      BringtoFront: "Al Frente",
      SendtoBack: "Al Fondo",
    },
    page: "Página",
    pages: "Páginas",
    pagenumber: "Nº",
    Pixels: "Píxeles",
    Percentage: "Porcentaje",
    player: {
      First: "Principio",
      Previous: "Anterior",
      Next: "Siguiente",
      Last: "Fin",
      Export: "Exportar",
    },
    plugin_config: "Configuración",
    Position: "Posicionamiento",
    Preview: "Previsualizar",
    Properties: "Propiedades",
    Publish: "Publicar",
    row_number: "Nº filas en col. ",
    Read_more: "Saber Más",
    Redo: "Rehacer",
    Reorder: "Reordenar",
    repeatedItemCopied: "(copia)",
    Rotate: "Rotar (º)",
    HorizontalFlip: "Volteo horizontal",
    VerticalFlip: "Volteo vertical",
    Save: "Guardar",
    SaveAs: "Guardar Como",
    Score: "Puntuación",
    Score_feedback: "Tu Puntuación Es",
    "SCORM Explanation":
      "Un paquete SCORM es un conjunto de archivos que se empaquetan conforme a un estándar para objetos de aprendizaje. Los paquetes SCORM son ficheros zip que pueden ser integrados en cualquier plataforma de aprendizaje que soporte el estándar (Moodle, Blackboard, …) y que pueden ser utilizados para la presentación de contenidos multimedia y como herramientas de evaluación. Por tanto, puedes integrar este documento en Moodle y otras plataformas de aprendizaje descargándolo como SCORM.",
    "HTML Explanation":
      "Esta opción exporta un paquete .zip que contiene dos carpetas: una con el archivo index.html del documento, que podrás abrir en cualquier navegador, y otra con los recursos necesarios para su correcta previsualización.",
    "URL Explanation":
      "Esta opción toma una copia de la capacitación que preparó y genera un enlace (url). <b>La capacitación se guarda automáticamente antes de generar el enlace</b>, por lo que tus últimos cambios siempre se incluyen. Puedes compartir y publicar el enlace generado en otros medios.",
    "EDI Explanation":
      "Esta opción exporta un fichero .edi con todo el contenido de tu documento, el cual podrás importar de nuevo desde otro documento Aideapro Studio aunque esté en otra plataforma distinta.",
    "PDF Explanation": "Esta opción genera un archivo PDF",
    Search_in_ViSH: "Buscar en ViSH",
    Searching: "Buscando...",
    section: "Sección",
    show: "Mostrar",
    show_subtitle: "Mostrar Subtítulo",
    slide: "Diapositiva",
    step_next: "Siguiente paso",
    step_previous: "Atrás",
    Submit: "Corregir",
    subtitle: "Subtítulo",
    subtitle_hide: "Ocultar Subtítulo",
    Replay: "Volver a reproducir",
    visor: {
      subtitles: "Subtítulos",
      playbackSpeed: "Velocidad de reproducción",
      normalSpeed: "normal",
      off: "Desactivado",
      previous: "Anterior",
      play: "Reproducir",
      pause: "Pausar",
      replay: "Volver a reproducir",
      reset: "Reiniciar",
      next: "Siguiente",
      fullscreen: "Pantalla completa",
      exit_fullscreen: "Salir de pantalla completa",
      remaining: "restante",
      more: "Más opciones",
      volume: "Volumen",
      mute: "Silenciar",
      unmute: "Activar sonido",
      close: "Cerrar",
      seek_back: "Back 10 seconds",
      seek_forward: "Forward 10 seconds",
      show_controls: "Show controls",
      hide_controls: "Hide controls",
    },
    // Visor chrome scene-end CTA (visor-ui redesign, Task 3). EN copy per project convention.
    VisorCtaNextScene: "Next scene · {{n}}/{{total}}",
    VisorCtaFinish: "Complete the training",
    VisorCtaFinishInfo: "Training completed",
    VisorCtaFinishEyebrow: "All scenes completed",
    VisorCtaSingleEyebrow: "Single-scene training",
    VisorCtaReplay: "Watch this scene again",
    VisorCtaAnnounce: "Scene {{n}} completed. Next: {{next}}.",
    VisorCtaPreparing: "Scene {{n}} is being prepared…",
    VisorCtaIncompleteEyebrow: "Unwatched scenes · {{n}} left",
    VisorCtaAnnounceIncomplete: "There are unwatched scenes. Continue with: {{next}}.",
    VisorCtaReplayTraining: "Watch the training again",
    // Visor chrome scene row / scene panel / header pill (visor-ui redesign, Task 7). EN copy per project convention.
    VisorRowScene: "SCENE",
    VisorRowVideo: "VIDEO",
    VisorRowQuiz: "QUIZ",
    VisorRowPage: "PAGE",
    VisorRowLockedTitle: "Scene {{n}} isn't unlocked yet",
    VisorRowLockedBody: "Finish the earlier scenes to continue.",
    VisorNoScenes: "Esta formación aún no tiene escenas.",
    VisorPanelScenes: "Scenes",
    VisorPillScene: "Scene {{n}}/{{total}}",
    VisorPillProgress: "Progreso del curso: {{pct}}%",
    // Visor chrome stage seek zones (visor-ui redesign, Task 8). EN copy per project convention.
    VisorSeekFwd: "+10 SECONDS",
    VisorSeekBack: "−10 SECONDS",
    // Visor SCORM offline queue notice (visor-ui redesign, Task 10). EN copy per project convention.
    VisorOfflineSaved:
      "No connection — your progress is saved on this device and will be sent when you're back online.",
    VisorVideoFailedTitle: "No se pudo cargar un video de esta escena",
    VisorVideoFailedBody: "La escena continúa sin él.",
    VisorMediaFailedTitle: "No se pudo cargar el contenido",
    VisorMediaFailedBody: "Este contenido no se puede cargar ahora; la escena continúa sin él.",
    // Visor chrome edge/empty states + resume card (visor-ui redesign, Task 11). EN copy per project convention.
    VisorErrTitle: "Scene {{n}} failed to load",
    VisorErrBody: "The video file can't be reached. Check your connection and try again.",
    VisorErrRetry: "Try again",
    VisorErrSkip: "Skip to scene {{n}}",
    VisorNoScenesTitle: "This training doesn't have any scenes yet",
    VisorNoScenesBody:
      "Content will show up here once it's ready. You can let your training admin know.",
    VisorResumeEyebrow: "WHERE YOU LEFT OFF",
    VisorResumeContinue: "Continue",
    VisorResumeRestart: "Start over",
    VisorCtaAnnouncePreparing: "Scene {{n}} is being prepared.",
    success_transaction: "La operación se ha realizado correctamente",
    Structure: "Estructura",
    Style: "Estilo",
    StyleDisabledNote: "(Desactivado: se usa la imagen de referencia de estilo)",
    CustomCardLabel: "Personalizado",
    ChangeImage: "Cambiar imagen",
    MoreStyles: "Más estilos",
    styles: {
      background_color: "Color de Fondo",
      PluginName: "Imagen Básica",
      border_color: "Color de Borde",
      border_size: "Grosor de Borde",
      border_style: "Estilo de Borde",
      border_style_options: {
        none: "Ninguno",
        hidden: "Oculto",
        dotted: "Punteado",
        dashed: "Discontinuo",
        solid: "Sólido",
        double: "Doble",
        groove: "Ranura",
        ridge: "Relieve",
        inset: "Hundido",
        outset: "Elevado",
        initial: "Predeterminado",
        inherit: "Heredar",
      },
      font_weight: {
        100: "100",
        200: "200",
        300: "300",
        400: "400",
        500: "500",
        600: "600",
        700: "700",
        800: "800",
        900: "900",
        normal: "Normal",
        bold: "Negrita",
      },
      box_style: "Estilo Caja",
      opacity: "Opacidad",
      padding: "Padding",
      absolute: "Absoluto",
      relative: "Relativo",
    },
    templates: {
      scene_header_placeholder: "Título de la escena",
      add_text: "Añade Texto Aquí",
      elements_list: "Lista De Elementos",
      ex_unique_response: "Ejercicio Respuesta Ûnica",
      ex_multiple_response: "Ejercicio Respuesta Múltiple",
      ex_free_response: "Ejercicio Respuesta Libre",
      ex_true_false: "Ejercicio Verdadero / Falso",
      ex_background_sound: "Sonido De Fondo",
      ex_matching: "El Ejercicio Emparejamiento",
      "ex_fill-in-the-blank": "Ejercicio De Rellenar Espacios En Blanco",
      first_element: "Primer Elemento",
      second_element: "Segundo Elemento",
      third_element: "Tercer Elemento",
      text_images: "Texto e Imagen",
      map: "Mapa Interactivo",
      video: "Video Interactivo",
      web: "Web Incrustada",
      template1: "Imagen & Texto",
      template2: "Bloques Texto",
      template3: "Bloques Imagen",
      template4: "Vídeo Enriquecido",
      template5: "Mapa Interactivo",
      template6: "Web Incrustada",
      template7: "Imagen & Lista",
      template8: "Una Selección",
      template9: "Respuesta Múltiple",
      template10: "Respuesta Abierta",
      template11: "Verdad./Falso",
      template12: "Sonido de Fondo",
      template13: "Emparejamiento",
      template14: "Relleno De Huecos",
      template0: "En Blanco",
      templatechose: "Selección de plantilla",
      tab_template: "Desde Plantilla",
      tab_zip: "Formación en pantalla",
    },
    export: {
      full_sli_doc:
        "Formato apaisado. Una diapositiva por página. Se incluyen los elementos de tipo página.",
      two_sli_doc:
        "Formato vertical. Dos diapositivas por página. Se incluyen los elementos de tipo página.",
      full_sli:
        "Formato apaisado. Una diapositiva por página. NO se incluyen los elementos de tipo página.",
      two_sli:
        "Formato vertical. Dos diapositivas por página. No se incluyen los elementos de tipo página.",
      sli_comments:
        "Formato vertical. Una diapositiva por página. Se añadirá espacio para comentarios bajo cada diapositiva. NP se incluyen los elementos de tipo página.",
      four_sli:
        "Formato apaisado. Cuatro diapositivas por página. NO se incluyen los elementos de tipo página.",
      full_doc: "Formato vertical. Un documento por página. NO se incluyen las diapositivas.",
      two_doc: "Formato horizontal. Dos documentos por página. NO se incluyen las diapositivas.",
      safari_landscape:
        "Estás usando Safari. Para exportar correctamente el documento, recuerda seleccionar la orientación horizontal en la ventana de impresión.",
      firefox_landscape:
        "Estás usando Firefox. Para exportar correctamente el documento, recuerda seleccionar la orientación horizontal en la ventana de impresión.",
      safari_portrait:
        "Estás usando Safari. Para exportar correctamente el documento, recuerda seleccionar la orientación vertical en la ventana de impresión.",
      firefox_portrait:
        "Estás usando Firefox. Para exportar correctamente el documento, recuerda seleccionar la orientación vertical en la ventana de impresión.",
      print_title: "Modo de Impresión",
      warning_title: "Atención",
      null_print:
        "No hay nada que exportar. Selecciona un modo de impresión que incluya al menos un elemento de tu documento.",
      download_failed: "La descarga no pudo completarse. Por favor, inténtelo de nuevo más tarde.",
      sli_doc: "Diapositivas y Páginas",
      sli: "Sólo Diapositivas",
      doc: "Sólo Páginas",
      sli_doc_explanation:
        "estos modos incluyen tanto las diapositivas como las páginas del documento.",
      sli_explanation:
        "estos modos incluyen las diapositivas pero NO incluyen las páginas del documento.",
      doc_explanation:
        "estos modos incluyen las páginas pero NO incluyen las diapositivas del documento.",
      clm_desc: "Paquete CLM",
      clm_explanation:
        "Exporta esta presentación como un paquete CLM estático: index.html, clm-config/config.json y una imagen por página. Toda la navegación pasa por tus zonas de clic.",
      clm_zip_name: "Nombre del archivo del paquete",
      clm_export_done: "Exportación completada con {{count}} advertencia(s).",
      clm_close: "Cerrar",
      clm_check_again: "Comprobar de nuevo",
      clm_not_checked: "La presentación aún no se ha comprobado.",
      clm_no_problems: "Lista para exportar: no se encontraron problemas.",
      clm_errors_title: "Corrige esto antes de exportar",
      clm_warnings_title: "Advertencias (se permite exportar)",
      clm_problem_no_pages: "La presentación no tiene escenas visibles.",
      clm_problem_document_scene:
        "{{scene}}: las escenas de documento no se pueden exportar a CLM.",
      clm_problem_missing_target:
        "{{scene}}: una zona de clic apunta a un destino que ya no existe.",
      clm_problem_multi_nav:
        "{{scene}}: una zona de clic navega a más de una página (un clic = una navegación).",
      clm_problem_unsupported_plugin: "{{scene}}: {{plugin}} no se puede exportar y se omitirá.",
      clm_problem_boundary_nav:
        "{{scene}}: una zona de clic de siguiente/anterior no tiene adónde ir en esta página (quedará inactiva).",
      clm_problem_unsupported_connect_mode:
        '{{scene}}: una zona de clic está configurada como "{{connectMode}}", que el paquete estático no puede enlazar (quedará inactiva).',
      clm_problem_empty_click_zone:
        "{{scene}}: una zona de clic no tiene destino (quedará inactiva).",
      clm_problem_small_touch_target:
        "{{scene}}: una zona de clic mide menos de 48px (difícil de tocar).",
      clm_problem_furniture_occlusion:
        "{{scene}}: una zona de clic está en la franja inferior; comprueba que no tape las referencias/códigos de la página.",
      clm_problem_background_not_exported:
        "{{scene}}: las imágenes de fondo no se exportan; solo se usa el color de fondo.",
      clm_problem_approx_geometry:
        "{{scene}}: un elemento usa tamaños en px; su posición se aproxima en el lienzo de 1920×1080.",
      clm_problem_external_html:
        "{{scene}}: un elemento HTML que incrusta una URL externa no se puede exportar sin conexión y se omitirá.",
      clm_problem_unsafe_external_url:
        "{{scene}}: el enlace externo de una zona de clic no es una dirección web segura (solo se exportan http(s)/mailto/tel) y se omitirá.",
      clm_problem_theme_not_exported:
        "{{scene}}: esta escena usa un fondo de tema, que no se exporta; se usará una página negra en su lugar.",
      clm_problem_missing_asset: "{{scene}}: a {{plugin}} le falta su imagen y se omitirá.",
      clm_problem_download_failed: "{{scene}}: no se pudo descargar la imagen ({{url}}).",
      clm_problem_artifact_failed:
        "No se pudo obtener un elemento HTML animado ({{detail}}). Guarda e inténtalo de nuevo.",
      clm_problem_parity: "Error interno: no coincide el número de páginas ({{detail}}).",
      clm_problem_invalid_state:
        "Error interno: no se pudo comprobar la presentación ({{detail}}).",
    },
    video_export: {
      translate_confirm_title: "¿Generar en este idioma?",
      translate_confirm_replace_title: "Este idioma ya existe, ¿regenerarlo?",
      translate_confirm_text:
        "El video combinado se volverá a locutar en este idioma. Puede tardar unos minutos según la duración del video y consume créditos.",
      translate_confirm_start: "Generar",
      languages_show_more: "+{{n}} idiomas más",
      languages_show_less: "Mostrar menos",
      title: "Exportar Video",
      sync_scenes: "Actualizar Escenas",
      sync_scenes_tooltip:
        "Obtiene la lista de escenas actual de la formación y pone en cola las escenas que aún no se han renderizado o que fallaron. Los videos completados no se modifican.",
      sync_scenes_confirm:
        "Se obtendrá la lista de escenas actual de la formación; las escenas que aún no se hayan renderizado o que hayan fallado se pondrán en cola. Los videos de escena ya completados no se modificarán. ¿Continuar?",
      recovering: "Recuperando…",
      recover: "Recuperar Videos Antiguos",
      stop: "Detener Todo",
      stop_confirm:
        "Se cancelará el renderizado o la combinación en curso. Los videos de escena ya completados no se eliminarán. ¿Continuar?",
      clear_tooltip:
        "Elimina todos los registros de exportación de esta formación y vuelve a empezar",
      clear_confirm:
        "Todos los registros de esta exportación se eliminarán de forma permanente. ¿Continuar?",
      clearing: "Reiniciando…",
      clear: "Volver a Empezar",
      start_modal_title: "Iniciar Generación de Video",
      regenerate_modal_title: "Regenerar Escena",
      regenerate_modal_hint:
        "Esta escena se regenerará. El video actual permanecerá hasta que termine.",
      save_reminder:
        "No olvide guardar la formación. Los cambios no guardados no se incluirán en la producción del video.",
      cancel: "Cancelar",
      subtitle_lang_label: "Idioma de subtítulos (opcional)",
      subtitle_none: "— Sin subtítulos —",
      subtitle_scene_count: "({{count}} escenas)",
      duration_tooltip: "Duración total",
      history_tooltip: "Videos combinados anteriores",
      history: "Historial",
      merge_reselect_tooltip: "Volver a combinar con la nueva selección",
      merge_disabled_tooltip: "Se activa cuando todas las escenas estén listas",
      merge: "Combinar",
      re_merge: "Volver a Combinar",
      checking: "Comprobando trabajo existente…",
      start_hint:
        "Genera las escenas una por una, revísalas y vuelve a generar las que no te gusten. Cuando estés listo, pulsa el botón de combinar manual para crear el video final.",
      start: "Empezar",
      merged_label: "Video combinado",
      download: "Descargar",
      regenerate_scene: "Regenerar Esta Escena",
      idle_hint: 'Haz clic en el botón "Empezar" arriba a la derecha para comenzar.',
      starting: "Iniciando trabajo…",
      select_scene: "Selecciona una escena",
      merging_placeholder: "Combinando…",
      merging_progress: "Combinando… {{pct}}%",
      render_percent: "Render {{pct}}%",
      error_prefix: "Error: ",
      retry: "Reintentar",
      dont_merge_overlay: "No se combinará",
      dont_merge_tooltip_include: "Incluir en la combinación",
      dont_merge_tooltip_exclude: "No combinar — excluir de la combinación",
      dont_generate_overlay: "No se generará",
      dont_generate_tooltip_include: "Incluir en la generación",
      dont_generate_tooltip_exclude: "No generar — excluir de esta exportación",
      cancel_scene_tooltip: "Cancelar",
      regenerate_scene_tooltip: "Regenerar",
      history_title: "Combinaciones anteriores",
      history_loading: "Cargando…",
      history_empty: "Todavía no hay ningún video combinado.",
      preparing_scenes: "Preparando escenas…",
      rendering_of_total: "Renderizando {{count}} de {{total}} escenas",
      queued_of_total: "{{count}} de {{total}} escenas en cola",
      rendering_count: "{{count}} escena(s) renderizando",
      queued_count: "{{count}} escena(s) en cola",
      job_on_way: "El trabajo está en camino",
      status_queued: "En cola",
      status_rendering: "Renderizando",
      status_uploading: "Subiendo",
      status_completed: "Completado",
      status_failed: "Fallido",
      status_cancelled: "Cancelado",
      status_merged: "Combinado",
      status_merge_pending: "Pendiente de combinar",
      merge_cancel_confirm:
        "Ya hay una combinación en curso. Para excluir esta escena debemos cancelar la combinación actual — el video deberá combinarse de nuevo. ¿Continuar?",
      training_id_missing: "No se encontró el ID de la formación.",
      no_scenes: "Esta formación no tiene escenas. Vuelve al editor y añade una escena.",
      state_read_error: "No se pudo leer el estado guardado",
      checking_save: "Comprobando el guardado…",
      save_required_title: "Primero debes guardar",
      save_required_body:
        'Tu trabajo actual debe estar guardado en el servidor antes de generar un video. Para que todos tus cambios de escenas, audio, animación y texto se rendericen correctamente, primero pulsa "Guardar" y vuelve a intentarlo.',
      save_failed: "Error al guardar",
      saving: "Guardando…",
      save_now: "Guardar Ahora",
      recheck: "Comprobar de Nuevo",
      error_title: "Ocurrió un error",
      menu_label: "Exportar video",
      translate_starting: "Iniciando…",
      translate_failed: "No se pudo iniciar la traducción.",
      recover_tooltip:
        "Buscar en Azure Blob videos de escena renderizados anteriormente que no tienen registro en la base de datos.",
      languages_tooltip: "Genera y mira el video en otros idiomas",
      languages: "Idiomas",
      watch: "Ver",
      languages_title: "Idiomas",
      languages_hint:
        "Dobla el video combinado a otro idioma. Las escenas no cambian; solo cambia el audio.",
      dismiss: "Cerrar",
      languages_available: "Videos listos",
      languages_needs_merge:
        "Primero combina el video — la traducción se hace a partir del video combinado.",
      variant_original: "Original",
      languages_add: "Añadir idioma",
      translate_no_languages: "No hay idiomas registrados para el doblaje.",
      translate_regenerate: "Este idioma ya existe — se volverá a generar",
      translate_start: "Generar en este idioma",
      translate_busy: "Hay una traducción en curso",
      translate_disabled_tooltip: "Primero combina el video",
      translate_exists: "disponible",
      close: "Cerrar",
    },
    subtitles: {
      title: "Subtítulos",
      available_languages: "Idiomas Disponibles",
      refresh: "Actualizar",
      no_subtitles:
        "Aún no se han generado subtítulos. Use el formulario de abajo para generarlos.",
      delete_language: "Eliminar los subtítulos de este idioma",
      subtitles_for: "Subtítulos de",
      not_found: "No se encontró subtítulo para esta escena",
      no_subtitle_for_scene: "No hay subtítulo disponible para esta escena",
      generate_title: "Generar Subtítulos",
      select_language: "Seleccionar idioma...",
      force_regenerate: "Forzar regeneración",
      generating: "Generando...",
      generate_btn: "Generar",
      generating_subtitles: "Generando subtítulos...",
      confirm_delete_title: "Eliminar Subtítulos",
      confirm_delete_message:
        "¿Está seguro de que desea eliminar todos los subtítulos de este idioma? Esta acción no se puede deshacer.",
      cancel: "Cancelar",
      delete_confirm: "Eliminar",
    },
    Text: "Datos",
    text_here: "Introduzca aquí su texto",
    Title: " Título",
    Title_document: "Título del Curso",
    Slide_document: "Título Diapositiva",
    Page_document: "Título Página",
    Filter: "Filtro",
    SelectAFolder: "Seleccione Una Carpeta...",
    Undo: "Deshacer",
    Units: "Unidades",
    Unpublish: "Privado",
    Uploading: "Subiendo...",
    Upload_to_ViSH: "Subir a ViSH",
    Uploaded_Images: "IMÁGENES SUBIDAS",
    Uploaded_Images_No: "No has subido ninguna imagen a este proyecto",
    vertical: "Subtítulo vertical",
    Vertical_align: "Alineación Vertical",
    vish_search: "Buscador VISH",
    vish_search_terms: "Términos de Búsqueda",
    vish_search_button: "Buscar",
    vish_search_by: "Buscar Por",
    vish_search_by_type: "Búsqueda Por Tipo",
    vish_search_filters: {
      ranking: "Ranking",
      popularity: "Popularidad",
      modification: "Modificación",
      creation: "Creación",
      visits: "Visitas",
      favorites: "Likes",
      quality: "Calidad",
    },
    vish_search_types: {
      Picture: "Imagen",
      Resource: "Todo",
      Audio: "Audio",
      Embed: "Incrustar",
      Excursion: "Excursión",
      Swf: "Objeto Flash",
      Link: "Enlace",
      Officedoc: "PDF",
      // "Scormfile": "Paquete SCORM",
      Video: "Vídeo",
      Webapp: "Aplicación Web",
      Workshop: "Taller",
      XML: "XML",
      JSON: "JSON",
      CSV: "CSV",
      OBJ: "OBJ",
      All: "Todos",
      Writing: "Escrito",
      Zipfile: "Fichero ZIP",
      IdealStudioDocument: "Documento Aideapro Studio",
      Arrows: "Flechas",
      Education: "Educación",
    },
    vish_upload: "Subir",
    vish_upload_desc: "Descripción",
    vish_upload_other: "Sube imágenes, vídeos y otros recursos",
    vish_upload_title: "Título",
    "Want some help?": "¿Quieres Ayuda?",
    Weight: "Peso",
    Width: "Ancho",
    Width_percentage: "Ancho (%)",
    Width_pixels: "Ancho (px)",
    languages: {
      Afrikanns: "Afrikáans",
      Albanian: "Albanés",
      Arabic: "Árabe",
      Armenian: "Armenio",
      Basque: "Euskera",
      Bengali: "Bengalí",
      Bulgarian: "Búlgaro",
      Catalan: "Catalán",
      Cambodian: "Jemer",
      Chinese: "Chino",
      Azerbaijani: "Azerbaiyano",
      Croation: "Croata",
      Czech: "Checo",
      Danish: "Danés",
      Dutch: "Holandés",
      English: "Inglés",
      Estonian: "Estonio",
      Fiji: "Fiyi",
      Finnish: "Finés",
      French: "Francés",
      Georgian: "Georgiano",
      German: "Alemán",
      Greek: "Griego",
      Gujarati: "Guyaratí",
      Hebrew: "Hebreo",
      Hindi: "Hindi",
      Hungarian: "Húngaro",
      Icelandic: "Islandés",
      Indonesian: "Indonesio",
      Irish: "Irlandés",
      Italian: "Italiano",
      Japanese: "Japonés",
      Javanese: "Javanés",
      Korean: "Coreano",
      Latin: "Latín",
      Latvian: "Letón",
      Lithuanian: "Lituano",
      Macedonian: "Macedonio",
      Malay: "Malayo",
      Malayalam: "Malabar",
      Maltese: "Maltés",
      Maori: "Maorí",
      Marathi: "Maratí",
      Mongolian: "Mongol",
      Nepali: "Nepalí",
      Norwegian: "Noruego",
      other: "Otros",
      Persian: "Persa",
      Polish: "Polaco",
      Portuguese: "Portugués",
      Punjabi: "Panyabí",
      Quechua: "Quechua",
      Romanian: "Rumano",
      Russian: "Ruso",
      Samoan: "Samoano",
      Serbian: "Serbian",
      Slovak: "Eslovaco",
      Slovenian: "Esloveno",
      Spanish: "Español",
      Swahili: "Suajili",
      Swedish: "Sueco",
      Tamil: "Tamil",
      Tatar: "Tártaro",
      Telugu: "Télugu",
      Thai: "Tailandés",
      Tibetan: "Tibetano",
      Tonga: "Tongano",
      Turkish: "Turco",
      Ukranian: "Ucraniano",
      Urdu: "Urdu",
      Uzbek: "Uzbeko",
      Vietnamese: "Vietnamita",
      Welsh: "Galés",
      Xhosa: "Xosa",
    },
    TextAnimations: {
      title: "Animaciones de Texto",
      chooseAnimation: "Elegir Animación",
      preview: "Vista Previa",
      settings: "Configuración",
      duration: "Duración (segundos)",
      delay: "Retraso (segundos)",
      delayDescription: "La animación comenzará después de este retraso",
      replay: "Reproducir",
      applyAnimation: "Aplicar Animación",
      deleteAnimation: "Eliminar Animación",
      sampleText: "Texto de Muestra para Animación",
      animations: {
        fadeIn: "Desvanecer",
        slideInRight: "Deslizar desde Derecha",
        slideInLeft: "Deslizar desde Izquierda",
        slideInUp: "Deslizar desde Abajo",
        slideInDown: "Deslizar desde Arriba",
        scaleIn: "Escalar",
        rotateIn: "Rotar",
        bounceIn: "Rebotar",
        typeWriter: "Máquina de Escribir",
        wavyText: "Texto Ondulado",
      },
    },
    BoxAnimations: {
      title: "Animaciones de Caja",
      chooseAnimation: "Elegir Animación",
      preview: "Vista Previa",
      settings: "Configuración",
      duration: "Duración (segundos)",
      delay: "Retraso (segundos)",
      delayDescription: "Retraso antes de que comience la animación",
      replay: "Reproducir",
      applyAnimation: "Aplicar Animación",
      deleteAnimation: "Eliminar Animación",
      sampleText: "Caja de Muestra",
    },
    AssessmentMenu: {
      nAnswers: "Número de respuestas",
      nStatements: "Número de afirmaciones",
      nItems: "Número de elementos",
      nPairs: "Número de pares",
      nBlanks: "Número de espacios",
      labels: "Etiquetas",
      shuffleAnswers: "Mezclar respuestas",
      shuffle: "Mezclar",
      showFeedback: "Mostrar retroalimentación",
      partialCredit: "Crédito parcial",
      points: "Puntos",
      minLength: "Longitud mínima",
      maxLength: "Longitud máxima",
      countCharacters: "Contar caracteres",
      buttons: "Botones",
      addAnswer: "Añadir respuesta",
      removeAnswer: "Eliminar respuesta",
      addOne: "Añadir uno",
      removeOne: "Eliminar uno",
      editQuestion: "Editar pregunta",
      fitToScreen: "Ajustar a la pantalla",
      duplicate: "Duplicar",
      preview: "Vista previa",
      previewThisQuestion: "Previsualizar esta pregunta",
      moreOptions: "Más opciones",
      styleAndColors: "Estilo y colores…",
      delete: "Eliminar",
      deleteQuestion: "Eliminar pregunta",
      assessmentOptions: "Opciones de evaluación",
      questionOptions: "Opciones de pregunta",
      richTextEditor: "Editor de texto enriquecido",
      setBlankAnswers: "Establece la respuesta correcta para cada espacio",
      correctAnswers: "Respuestas correctas",
      noBlanksYet: "Aún no hay espacios — añade uno con “+ añadir espacio”.",
      blank: "Espacio",
      correctValue: "valor correcto",
      correctAnswerPlaceholder: "respuesta correcta",
      addFillBlank: "Añadir un espacio",
      addDragArea: "Añadir un área de arrastre",
    },
    pages: "Páginas",
    doc_name: "Nombre del documento",
    edit: "Editar",
    "Image Animator": "Animador de Imágenes",
    "Current Image": "Imagen Actual",
    "No image selected": "Ninguna imagen seleccionada",
    NoPreviewImage: "Sin imagen de vista previa",
    "View fullscreen": "Ver en pantalla completa",
    "Animate your static image using AI": "Anima tu imagen estática con IA",
    "Remove background from the image": "Elimina el fondo de la imagen",
    "Remove specific objects from the image": "Elimina objetos específicos de la imagen",
    "Remove text from the image": "Elimina el texto de la imagen",
    "Translate text within the image": "Traduce el texto dentro de la imagen",
    "Generate similar variations of the image": "Genera variaciones similares de la imagen",
    "Edit your image using AI": "Edita tu imagen con IA",
    "Change text content within the image": "Cambia el contenido de texto dentro de la imagen",
    "Change the aspect ratio of the image using AI":
      "Cambia la relación de aspecto de la imagen con IA",
    "Increase image resolution using AI": "Aumenta la resolución de la imagen con IA",
    "Generate a similar infographic based on this image":
      "Genera una infografía similar basada en esta imagen",
    "Replace a garment or product using a reference image":
      "Reemplaza una prenda o producto usando una imagen de referencia",
    "Decompose this image into editable layers": "Descompón esta imagen en capas editables",
    "Separate the baked-in text into editable text boxes":
      "Separa el texto incrustado en cuadros de texto editables",
    "Animated Result": "Resultado Animado",
    Duration: "Duración",
    Size: "Tamaño",
    "Animation Prompt (Optional)": "Prompt de Animación (Opcional)",
    "Animation Prompt Placeholder":
      "Describe cómo quieres animar la imagen (ej., 'Añadir zoom suave de cámara y movimiento suave', 'Crear un efecto parallax sutil con elementos flotantes')",
    "AI Provider": "Proveedor de IA",
    "Coming Soon": "Próximamente",
    Reject: "Rechazar",
    "Starting Animation...": "Iniciando Animación...",
    "Start Animation": "Iniciar Animación",
    "Please enter an animation prompt": "Por favor introduce un prompt de animación",
    "Animation generation failed. Please try again.":
      "La generación de animación falló. Por favor inténtalo de nuevo.",
    "Failed to check job status": "Error al verificar el estado del trabajo",
    "Failed to start animation": "Error al iniciar la animación",
    "Failed to submit animation job": "Error al enviar el trabajo de animación",
    "Failed to fetch job status": "Error al obtener el estado del trabajo",
    Error: "Error",
    training: {
      close: "Cerrar",
      completed_exit: "Has completado la formación. ¿Quieres salir?",
      completed: "Has completado la formación.",
      failed: "Formación Fallida",
      failed_message:
        "Debido a que no se alcanzó la tasa de éxito objetivo en las preguntas de evaluación ({{correct}} / {{required}}), la formación se reiniciará automáticamente.",
      yes: "Sí",
      no: "No",
      ok: "Aceptar",
      previously_started: "Has trabajado previamente en esta formación...",
      continue_from_bookmark: "Continuar desde donde lo dejé",
      restart_from_beginning: "Reiniciar la formación desde el principio",
    },

    "Image Animator": "Animador de Imágenes",
    "Merlin Image Animator": "Animador de Imágenes Aidea Wizard",
    "Image Edit": "Edición de Imagen",
    "Resize the Image": "Redimensionar Imagen",
    "Resize the image": "Redimensionar Imagen",
    "Replace Text": "Reemplazar Texto",
    "Generate Image with Text": "Generar Imagen con Texto",
    "Generate with Style Reference": "Generar con Referencia de Estilo",
    "Select Feature": "Seleccionar Función",
    Yakında: "Próximamente",
    "Animate Image": "Animar Imagen",
    AnimateImageNoReference: "Animar Imagen — no disponible: sin imagen de referencia",
    ExtractText: "Extraer Texto",
    "Remove Background": "Eliminar Fondo",
    "Remove Object": "Eliminar Objeto",
    "Add Object": "Añadir Objeto",
    "Add Logo": "Añadir Logo",
    "Edit Region": "Editar con Prompt",
    "Remove Text": "Eliminar Texto",
    "Translate Text": "Traducir Texto",
    "Generate Similar": "Generar Similar",
    "Change Object": "Cambiar Objeto",
    "Edit Image": "Editar Imagen",
    "Change Image Text": "Cambiar Texto de Imagen",
    "No image selected": "No hay imagen seleccionada",
    NoPreviewImage: "Sin imagen de vista previa",
    Prompt: "Prompt",
    EnterDescriptionPlaceholder: "Ingresa una descripción...",
    EditImagePromptPlaceholder:
      "Describe los cambios (ej. 'Cambia el fondo a una playa tropical al atardecer')",
    RemoveObjectPromptPlaceholder: "¿Qué debe eliminarse? (ej. 'caballo')",
    RemoveObjectSelectAreaLabel: "Área a eliminar (opcional)",
    RemoveObjectSelectAreaButton: "Seleccionar área",
    RemoveObjectAreaReselect: "Reseleccionar área",
    RemoveObjectAreaSelected: "Área seleccionada",
    RemoveObjectSelectAreaHint:
      "Dibuja un recuadro sobre el objeto a eliminar. Si seleccionas un área, el prompt es opcional.",
    ChangeObjectPromptPlaceholder:
      "Describe el objeto a reemplazar y con qué reemplazarlo (ej. 'Reemplaza el coche rojo con una bicicleta azul')",
    "Text Changes": "Cambios de Texto",
    Add: "Agregar",
    OriginalTextPlaceholder: "Texto original (ej. Hola Mundo)",
    NewTextPlaceholder: "Nuevo texto (ej. Hello World)",
    SelectText: "Seleccionar texto",
    DragOverTextToExtract: "Arrastra sobre el texto que quieres extraer",
    ExtractingText: "Extrayendo texto…",
    NoTextDetected: "No se encontró texto en el área seleccionada",
    TextExtractionFailed: "No se pudo extraer el texto",
    EnterCustomLocationPlaceholder: "Ingresa una ubicación personalizada...",
    SelectLocation: "Selecciona ubicación",
    "Top Left": "Superior Izquierdo",
    "Top Center": "Superior Centro",
    "Top Right": "Superior Derecho",
    "Middle Left": "Medio Izquierdo",
    Center: "Centro",
    "Middle Right": "Medio Derecho",
    "Bottom Left": "Inferior Izquierdo",
    "Bottom Center": "Inferior Centro",
    "Bottom Right": "Inferior Derecho",
    Custom: "Personalizado",
    "Target Language": "Idioma de Destino",
    Count: "Cantidad",
    "AI Provider": "Proveedor de IA",
    AnimationLabel: "Animación",
    Effect: "Efecto",
    "Edit Text": "Editar texto",
    "Advanced Settings": "Configuración Avanzada",
    "Output Format": "Formato de Salida",
    "Optimized size, good quality": "Tamaño optimizado, buena calidad",
    "Full quality, larger size": "Calidad completa, mayor tamaño",
    DurationSecondsShort: "{{count}} s",
    Loop: "Bucle",
    "Play Once": "Reproducir una vez",
    "Transparent Background": "Fondo Transparente (Coste Extra)",
    ExtendAnimation: "Extender (+8 s)",
    ExtendToSceneDuration: "Ajustar a la duración de la escena (~{{sec}} s)",
    Extended: "Extendida",
    "Failed to extend animation": "No se pudo extender la animación",
    ConvertToLoop: "Convertir en bucle",
    ConvertToPlayOnce: "Convertir en reproducción única",
    PreviewAndEdit: "Vista previa y edición",
    AnimEdit: {
      ActionsTitle: "Acciones",
      AddAsMp4: "Añadir a la escena como MP4",
      AddAsWebp: "Añadir a la escena como WebP",
      ExtendTitle: "Extender",
      Model: "Modelo",
      AddPrompt: "Añadir prompt",
      ContinuationPromptPlaceholder:
        "Déjalo vacío para el modo automático — la IA deduce el siguiente movimiento a partir del último fotograma.",
      ExtendUnavailableProvider:
        "Extender solo está disponible para animaciones de Gemini. Esta se generó con {{provider}}; la conversión a bucle sigue disponible.",
      NoSourceVideo:
        "Esta versión no tiene vídeo de origen, así que no se puede extender ni convertir. Aun así, puedes aplicarla.",
      MaxDurationHint: "máx. 45 s",
      ReferenceImageLabel: "Imagen de continuación (opcional)",
      Upload: "Subir",
      PickFromScene: "De la escena",
      PickFromLibrary: "De la biblioteca",
      Applied: "Aplicada",
      UseFrameAsContinuation: "Usar este fotograma como imagen de continuación",
      FrameTimeReadout: "{{t}} / {{d}} s",
      FrameExtractFailed: "No se pudo extraer ese fotograma.",
      SummaryDuration: "Animación: {{sec}} s",
      SummarySceneWindow: "En la escena: {{start}}–{{end}} s",
      InfoShownWindow: "Se muestra en la escena entre {{start}}–{{end}} s",
      InfoNeeded: "Duración necesaria: {{sec}} s",
      Advanced: "Avanzado",
      SimpleView: "Vista simple",
      SummaryPrompt: "Prompt: {{prompt}}",
      NoPromptGiven: "Sin prompt",
      TabDuration: "Duración",
      TabFormat: "Formato",
      TabContinuation: "Imagen de continuación",
      SceneFitRequired: "Necesarios {{sec}} s",
      SceneFitProduced: "{{sec}} s generados",
      SceneFitShortfall: "Faltan {{sec}} s",
      SceneFitCapNote: "Total limitado a {{sec}} s",
      RangeSummary: "{{from}} s → {{to}} s · máx. {{cap}} s",
      ExtendSettingsLabel: "Extender con",
      NoContinuationImage: "Sin imagen de continuación",
      Change: "Cambiar",
      ModelGeminiOnlyHint: "Extender solo está disponible para animaciones de Gemini",
      StepSetup: "Configurar",
      StepGenerate: "Generar",
      StepEdit: "Editar",
      SourceImageLabel: "Imagen de origen",
      MotionDescriptionLabel: "Descripción del movimiento",
      OptionalLabel: "opcional",
      PlaybackLabel: "Reproducción",
      PlaybackHint: "¿Repetir en bucle continuamente en la escena?",
      SetupSceneFitBanner:
        "Este elemento aparece en la escena entre {{start}}–{{end}} s. Una animación de {{sec}} s cubre exactamente ese intervalo.",
      GeneratingTitle: "Generando animación",
      GeneratingHint: "Suele tardar entre 40 y 90 s",
      ElapsedTime: "{{time}} transcurridos",
      ContinueInBackground: "Continuar en segundo plano",
      CancelJob: "Cancelar",
      ResultReadyTitle: "Animación lista",
      ResultReadySummary:
        "{{sec}} s · {{playback}} · {{provider}} — cubre el intervalo de {{windowSec}} s de la escena",
      ResultReadySummaryNoWindow: "{{sec}} s · {{playback}} · {{provider}}",
      Regenerate: "Regenerar",
      Retry: "Reintentar",
      BackToSetup: "Volver a la configuración",
      BackToResult: "Volver al resultado",
      ApplyToScene: "Aplicar a la escena",
      HistoryTitle: "Historial de versiones",
      HistoryFilterAll: "Todas",
      HistoryFilterAnimations: "Animaciones",
      HistoryFilterEdits: "Ediciones",
      HistoryFilterEmpty: "Ninguna versión coincide con este filtro",
      HistoryOnScene: "En la escena",
      HistoryConfirmHint:
        "seleccionada — al confirmar, el elemento de la escena se sustituirá por esta versión.",
      BackButton: "Volver",
      ActivityLogTitle: "Registro de actividad",
      HistoryHeader: "Historial",
      HistoryCollapse: "Ocultar historial",
      HistoryExpand: "Mostrar historial",
      SendToPopup: "Abrir en la ventana emergente",
    },
    Processing: "Procesando...",
    "Processing Failed": "Error de Procesamiento",
    "Job failed": "Trabajo fallido",
    "Failed to check job status": "No se pudo verificar el estado del trabajo",
    "API URL not configured": "URL de API no configurada",
    "The operation could not be completed. Please try again.":
      "La operación no pudo completarse. Por favor, inténtalo de nuevo.",
    ImageAnimationFailedGenericMessage:
      "La operación no pudo completarse. Por favor, inténtalo de nuevo.",
    AnimationCopyrightBlocked:
      "Google no pudo animar esta imagen porque parece contener contenido con derechos de autor, marca registrada o de una persona famosa. Prueba con otra imagen libre de derechos.",
    AnimationSafetyBlocked:
      "Google no pudo animar esta imagen porque la política de seguridad del servicio de IA no lo permite (p. ej., niños fotorrealistas, violencia o contenido sensible). Prueba con otra imagen.",
    AiProviderSafetyBlocked:
      "El servicio de IA rechazó esta solicitud por su política de seguridad. La entrada (imagen o texto) puede contener contenido restringido, p. ej., niños fotorrealistas, violencia o lenguaje inapropiado. Inténtalo de nuevo con otro contenido.",
    AiProviderCopyrightBlocked:
      "El servicio de IA rechazó esta solicitud porque la entrada parece contener contenido con derechos de autor, marca registrada o de una persona famosa. Inténtalo de nuevo con otro contenido libre de derechos.",
    Dismiss: "Descartar",
    "Dismiss All": "Descartar Todo",
    "Result Ready": "Resultado Listo",
    Option: "Opción",
    "Use This": "Usar Esta",
    "Accept & Replace": "Aceptar y Reemplazar",
    "Animation Result": "Resultado de Animación",
    Start: "Iniciar",
    NoElementInScene: "Aún no hay elementos en esta escena",
    "Unknown error": "Error desconocido",
    "Resize Image": "Redimensionar Imagen",
    "Upscale Image": "Ampliar Imagen",
    "Generate Similar Infographic": "Generar Infografía Similar",
    GenerateFromReferencePromptPlaceholder:
      "Describe la imagen que deseas generar basándote en esta referencia...",
    "Replace Product": "Reemplazar Objeto",
    Optional: "opcional",
    Remove: "Eliminar",
    "Failed to upload image": "No se pudo subir la imagen",
    ReplaceProduct: {
      SelectObjectLabel: "Selecciona el objeto a reemplazar",
      SelectObjectButton: "Seleccionar objeto en la imagen",
      SelectObjectHint:
        "Dibuja un recuadro alrededor del objeto que deseas reemplazar en la imagen.",
      OptionalBadge: "opcional",
      TargetObjectTitle: "Nota adicional",
      TargetObjectLabel: "Nota adicional (opcional)",
      TargetObjectPlaceholder: "p. ej. 'la chaqueta', 'la taza'",
      TargetObjectHint:
        "Si el recuadro seleccionado contiene más de una cosa, indica cuál. Déjalo vacío para reemplazar lo que esté dentro del recuadro.",
      AdaptStyleLabel: "Adaptar el objeto al estilo de la imagen",
      AdaptStyleHint:
        "Cuando está activado, el objeto de referencia se vuelve a generar para que coincida con el estilo de la imagen de origen antes de insertarlo. Cuando está desactivado, se inserta tal cual.",
      RegionSelected: "Región seleccionada",
      RegionSelectedReselect: "Volver a seleccionar región",
      DragOverObject: "Arrastra sobre el objeto a reemplazar",
      ReferenceImageLabel: "Imagen de referencia (nuevo objeto)",
      ReferenceSelected: "Imagen de referencia seleccionada",
      ChangeUpload: "Cambiar",
      ChooseFromHistory: "Elegir del historial",
      PickFromLibrary: "Elegir de la biblioteca",
      PickFromLibraryTitle: "Elige una imagen de referencia de la biblioteca",
      UploadHint: "Sube o arrastra una imagen (PNG, JPG, JPEG)",
      InvalidFileType: "Este tipo de archivo no se acepta. Sube solo una imagen (PNG, JPG, JPEG).",
      PromptLabel: "Instrucción adicional",
      PromptPlaceholder:
        "Opcional: p. ej. 'reemplaza solo la chaqueta, conserva la pose y el fondo'",
      PickReferenceTitle: "Elige una imagen de referencia",
    },
    AreaOps: {
      Title: "Editar Imagen",
      TabEdit: "Editar",
      TabArea: "Operaciones de Área",
      Intro:
        "Elige una función, marca un área en la imagen y aplica. Las operaciones se ejecutan en segundo plano una tras otra; puedes seguir trabajando.",
      DrawRegionHint: "Dibuja un área sobre la imagen",
      ClickPointHint: "Haz clic en un punto de la imagen",
      Empty: "Aún no hay operaciones. Elige una función arriba.",
      Apply: "Aplicar",
      RemoveLast: "Quitar Último Pin",
      RevertOriginal: "Volver al Original",
      RevertToVersion: "Volver a esta versión",
      Working: "Procesando…",
      ReferenceImage: "Imagen de referencia",
      UploadReference: "Subir imagen de referencia",
      RemoveReference: "Quitar",
      Remove: "Eliminar",
      TargetObjectPlaceholder: "p. ej. 'chaqueta', 'taza' (opcional)",
      PromptOptional: "Instrucción adicional (opcional)",
      RemoveObjectPromptPlaceholder: "¿Qué quitar? (opcional)",
      OriginalTextPlaceholder: "Texto original",
      NewTextPlaceholder: "Texto nuevo",
      EditRegionPromptPlaceholder: "¿Cómo debo editar esta área?",
      TargetLanguage: "Idioma de destino",
      SelectLanguage: "Selecciona idioma",
      StatusDraft: "borrador",
      StatusQueued: "en cola",
      StatusRunning: "procesando",
      StatusDone: "listo",
      StatusFailed: "error",
      History: "Historial",
      OriginalVersion: "Original",
      AddObjectPromptPlaceholder: "¿Qué añado aquí? (p. ej., una manzana roja)",
      UseFullImageReference: "Usar toda la imagen como referencia de estilo",
      LogoImage: "Logotipo",
      UploadLogo: "Subir logotipo",
      PickFromLibrary: "Elegir de la biblioteca",
      LibraryNoLogos: "Aún no hay logotipos en la biblioteca de marca",
      LibraryLoadFailed: "No se pudo cargar la biblioteca de marca",
      ApplyLogoToAllImages: "Aplicar a todas las imágenes de la formación",
      EditRegionPromptPlaceholder:
        "¿Cómo editar esta área? (p. ej. 'ponla azul', 'quita la mancha', 'muévela a la derecha')",
      // Operaciones de área por lotes (area-ops-batch)
      AddToList: "Añadir a la lista",
      BatchLabel: "Edición por lotes",
      MaxOpsReached: "Se pueden añadir como máximo {{max}} operaciones",
      StatusStaged: "en lista",
      BatchUnsupported:
        "La edición por lotes no está disponible; las operaciones se aplican una a una",
      InsufficientBalance: "Saldo insuficiente",
      OpUnchanged:
        "No se detectó ningún cambio en esta zona. Revisa el resultado antes de volver a aplicarlo.",
      OpMarkerInk:
        "El modelo dibujó una marca en esta zona. Revisa el resultado antes de volver a aplicarlo.",
      OpLogoFailed: "No se pudo añadir el logo. Prueba con otro archivo de logo.",
      // Modo imagen completa + funciones traídas del AI Wizard
      ApplyToWholeImage: "Aplicar a toda la imagen",
      WholeImage: "Imagen completa",
      ResizeImage: "Redimensionar",
      SimilarInfographic: "Infografía Similar",
      ReplaceProductCard: "Reemplazar Objeto",
      RemoveObjectWholePromptPlaceholder: "¿Qué quitar? (p. ej. 'la silla del fondo')",
      ResizeBlockedByStaged:
        "No se puede cambiar la proporción mientras haya operaciones de área en la lista",
    },
    ReplaceBackground: {
      ReferenceImageLabel: "Lugar de fondo (imagen de referencia)",
      ReferenceSelected: "Lugar de referencia seleccionado",
      ChangeUpload: "Cambiar",
      UploadHint: "Sube o arrastra una imagen del lugar (PNG, JPG, JPEG)",
      SelectAreaLabel: "Área a reemplazar",
      SelectAreaButton: "Seleccionar área en la imagen",
      RegionSelectedReselect: "Volver a seleccionar área",
      PromptLabel: "Instrucción adicional",
      PromptPlaceholder: "Opcional: p. ej. 'luz de atardecer', 'que sea interior'",
    },
    "Aspect Ratio": "Relación de Aspecto",
    "Scale Factor": "Factor de Escala",
    GuideMultiInput: {
      flow_items_title: "Elementos del Flujo",
      add_click: "Añadir Clic",
      add_input: "Añadir Entrada",
      empty_items:
        "Aún no hay elementos. Añade elementos de clic o entrada con los botones de arriba.",
      kind_click: "Clic",
      kind_input: "Entrada",
      label: "Etiqueta",
      label_placeholder: "Etiqueta opcional",
      item_color: "Color del Elemento",
      success_message: "Mensaje de Éxito",
      success_placeholder: "Ej. ¡Buen trabajo!",
      failure_message: "Mensaje de Error",
      failure_placeholder: "Ej. Revisa la ortografía",
      on_click_label: "Al hacer clic",
      onClick_next_item: "Ir al siguiente elemento",
      onClick_step: "Ir a una escena específica",
      target_step_label: "Escena Destino",
      pick_target: "— Selecciona una escena —",
      click_here: "Haz clic aquí",
      tag: "Etiqueta (opcional, para referencia posterior)",
      tag_placeholder: "Ej. nombrePila",
      validation_mode: "Modo de Validación",
      validation_exact: "Coincidencia exacta",
      validation_random: "Longitud aleatoria",
      expected_value: "Valor Esperado",
      min_chars: "Mín",
      max_chars: "Máx",
      move_up: "Mover arriba",
      move_down: "Mover abajo",
      delete_item: "Eliminar",
      delete: "Eliminar",
      expand_item: "Expandir",
      collapse_item: "Contraer",
      expand_all: "Expandir todo",
      collapse_all: "Contraer todo",
    },
    EditorShortcuts: {
      mini_preview: "Vista previa rápida",
    },
    "Edit HTML": "Editar HTML",
    "Replace File": "Reemplazar archivo",
    "Plugin Settings": "Ajustes del complemento",
    "Fit to Screen": "Ajustar a la pantalla",
    "Fit to Document": "Ajustar al documento",
    "Text Size": "Tamaño del texto",
    "Increase Text": "Aumentar texto",
    "Decrease Text": "Reducir texto",
    layersPanel: {
      title: "Capas",
      showAll: "Mostrar todo",
      hideAll: "Ocultar todo",
      lockAll: "Bloquear todo",
      unlockAll: "Desbloquear todo",
      show: "Mostrar",
      hide: "Ocultar",
      lock: "Bloquear",
      unlock: "Desbloquear",
      lockedNoDrag: "Bloqueado",
      dragToReorder: "Arrastra para reordenar",
      dragGroup: "Arrastra para mover todo el grupo",
      elements: "elementos",
    },
    scenePaste: {
      copyScene: "Copiar escena",
      copied: "Escena copiada — pégala en cualquier formación.",
      title: "¿Añadir la escena a esta formación?",
      contains: "Contiene",
      image: "imagen",
      images: "imágenes",
      video: "vídeo",
      videos: "vídeos",
      sound: "sonido",
      sounds: "sonidos",
      narration: "narración",
      narrations: "narraciones",
      mediaCopied: "Su contenido multimedia se copiará en esta formación.",
      mediaReused: "Su contenido multimedia se reutilizará.",
      addScene: "Añadir escena",
      copying: "Copiando…",
      done: "Listo — escena añadida.",
      error: "No se pudo pegar la escena: ",
    },
    Workflow: {
      title: "Flujo de trabajo",
      EmptyScene: "No hay contenido en esta escena todavía.",
      EmptySceneHint: "El flujo de trabajo aparecerá aquí a medida que añada contenido.",
      trigger: "Disparador",
      variable: "Variable",
      template: "Plantilla",
      simulate: "Simular",
      add_action: "Añadir acción",
      delete_trigger: "Eliminar disparador",
      close: "Cerrar",
      generating: "Generando flujo de trabajo…",
      done: "Listo",
      failed: "Error en la generación",
      close_to_widget: "Cerrar (seguir ejecutándose en el widget)",
      suggestions: "Sugerencias",
      make_suggestion: "Generar sugerencias",
      no_suggestions: "Aún no hay sugerencias.",
      scope_scene: "Alcance: esta narración",
      scope_course: "Alcance: todo el curso",
      insert_after: "¿Después de qué escena insertar?",
      insert_beginning: "(al principio)",
      fab: "Abrir flujo de trabajo",
      fab_tooltip: "Abrir el editor de flujos de trabajo",
      fab_chip: "flujo de trabajo",
      add_interaction: "Añadir interacción",
      click_hint: "haz clic en cualquier disparador para inspeccionarlo →",
      add_trigger: "Disparador",
      add_variable: "Variable",
      add_template: "Plantilla",
      back_to_graph: "Volver al gráfico",
      no_suggestions_yet: "Aún no hay sugerencias para esta formación",
      suggestions_explainer:
        "La IA puede analizar tus escenas y sugerir dónde añadir interactividad para profundizar el aprendizaje.",
      generate_for_scene: "Generar para",
      generate_for_course: "Para todo el curso",
      suggestions_hint:
        "Por escena es lo mejor cuando vas iterando; todo el curso es una base que se genera una vez por formación.",
      scene_has_no_content: "Esta escena aún no tiene contenido",
      no_workflow_yet: "Aún no hay flujo de trabajo",
      no_workflow_explainer:
        "Esta formación no tiene reglas de interacción. Podemos generar una base que refleje el orden de tus escenas y las evaluaciones existentes — después podrás editarla.",
      generate_workflow: "Generar flujo de trabajo",
      fill_empties_hint: "Se omitirán las secciones que ya tengan reglas de flujo de trabajo.",
      generating_for: "Generando…",
      view_progress: "Ver progreso",
      cancel: "Cancelar",
      loading: "Cargando…",
      export_title: "Exportar el flujo de trabajo como JSON",
      import_title: "Importar el flujo de trabajo desde JSON",
      presets_select_plugin_first: "Selecciona un InteractivePlugin para aplicar una plantilla.",
      use_wizard_instead: "Usar el asistente en su lugar",
      review_tooltip: "Hacer una revisión pedagógica de este flujo de trabajo",
      review_workflow: "Revisar flujo de trabajo",
      translate_tooltip: "Traducir las interacciones de la escena actual",
      translate_scene: "Traducir escena",
      event: "Evento",
      scene: "Escena",
      no_scenes: "(sin escenas)",
      plugin_box: "Caja interactiva",
      any_box: "Cualquiera (*)",
      create: "Crear",
      scoring_mode: "Modo de puntuación",
      translate_picker_title: "Traducir la escena a…",
      translating: "Traduciendo…",
      highlight_unreachable: "Resaltar los nodos inalcanzables",
      unreachable_count: "{{count}} nodo inalcanzable",
      unreachable_count_plural: "{{count}} nodos inalcanzables",
      unreachable: "inalcanzables",
      delete_variable: "Eliminar variable",
      variable_invalid_id:
        "Usa lowerCamelCase (letras/dígitos; debe empezar por una letra minúscula).",
      variable_duplicate_id: "Ya existe una variable con este id.",
      variables: "Variables",
      variable_id_placeholder: "nombre (p. ej., score)",
      variable_initial_placeholder: "valor inicial",
      add: "Añadir",
      variables_empty:
        "Aún no hay variables. Añade una para usarla en las acciones setVar / de ramificación.",
    },
    InteractivityStudio: {
      title: "Estudio de interactividad",
      scene: "Escena",
      close: "Cerrar",
      tab: {
        workflow: "Flujo de trabajo",
        suggestions: "Sugerencias",
        flow_viewer: "Visor de flujo",
      },
    },
    Wizard: {
      q1: "¿Qué tipo de interacción?",
      q2: "Cuando el alumno hace eso, ¿qué ocurre?",
      q3_branch: "¿Adónde lleva el camino INCORRECTO?",
      q3_review: "Revisa tus elecciones",
      back: "Atrás",
      create: "Crear",
      pick_scene: "Elige una escena…",
    },
    Akis: {
      title: "ELEMENTOS DEL FLUJO",
      empty: "Aún no hay elementos. Usa los botones de arriba para añadir uno.",
      label: "Etiqueta",
      triggers: "disparadores asociados",
      remove: "Eliminar",
    },
    AiSuggestions: {
      button: "Sugerencias",
    },
    FlowViewer: {
      title: "Visor de flujo",
      current_context: "contexto de la escena actual",
      mode: {
        all: "Mostrar todo",
        scene: "Mostrar escena",
        storyboard: "Storyboard",
      },
    },
    LeftPanel: {
      scenes: "ESCENAS",
      flow_viewer: "Visor de flujo",
      flow_viewer_tooltip: "Abrir el visor de flujo",
    },
    SkipInteractive: {
      label: "Omitir interactivo",
      button: "Omitir",
      help: "Si está marcado, aparece un botón Omitir en la esquina inferior derecha de la ventana durante el momento interactivo.",
    },
    "Edit Image v2": "Editar imagen v3",
  },
};

export { es };
